<template>
  <div class="supplus-storage">
    <a-tabs
      v-model="activeKey"
      style="background: #fff"
      @change="handleChangeTab"
    >
      <a-tab-pane key="余料清单">
        <template #tab>
          <span id="supplus_storage_list">
            {{ t('surplusMaterial') }}
          </span>
        </template>
      </a-tab-pane>
      <a-tab-pane key="余料库" force-render>
        <template #tab>
          <span id="supplus_storage_store">
            {{ t('surplusStore') }}
          </span>
        </template></a-tab-pane
      >
    </a-tabs>
    <!-- 定制用户金标 -->
    <div
      :class="{
        'special-flag': isCustomUser,
      }"
      class="flag"
    >
      <!-- 定制功能/限时试用 -->
      {{
        isCustomUser
          ? $t('common.customFunction')
          : $t('common.limitedTimeTrial')
      }}
    </div>
    <div class="loading-box" v-if="showLoading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 60px" spin />
      </a-spin>
    </div>
    <div class="supplus-content bg-white" v-show="!showAddNewSupplus">
      <div v-if="activeKey == '余料清单'" class="h100">
        <div class="top-operation pb20">
          <div class="left-operation">
            <a-button
              id="supplus_storage_add_btn"
              class="supplus-btn new-supplus"
              @click="addNewSupplusSide"
            >
              <span class="iconfont icon-add"></span>
              <span>
                <!-- 添加余料 -->
                {{ t('addSurplus') }}
              </span>
            </a-button>
            <newContent :styleObj="{ top: '-12px' }">
              <a-button
                id="supplus_storage_add_btn"
                class="mr8"
                @click="isShowQRCodeModal = true"
              >
                <span>
                  {{ $translateLang('余料入库码') }}
                </span>
              </a-button>
            </newContent>
            <a-popover
              :overlayStyle="{ width: '170px' }"
              placement="bottomLeft"
              trigger="click"
              overlayClassName="more-popover"
              v-model="isShowPopover"
            >
              <template #content>
                <a-button
                  @click="handleOpenFile"
                  v-bp="'supplus_storage:import'"
                  class="action-btn fs14 color-0 br4 no-select inline-block align-center mb8"
                  id="supplus_storage_import_surplus_btn"
                  >{{ $translateLang('导入余料') }}</a-button
                >
                <a-button
                  @click="batchExportSurplus"
                  v-bp="'supplus_storage:export'"
                  class="action-btn fs14 color-0 br4 no-select inline-block align-center mb8"
                  id="supplus_storage_export_list_btn"
                  >{{ $translateLang('导出当前余料清单') }}</a-button
                >

                <a-button
                  class="action-btn fs14 color-0 br4 no-select inline-block align-center mb8"
                  @click="handleDownloadSample"
                  v-bp="'supplus_storage:download_template'"
                  id="supplus_storage_dowload_import_temp_btn"
                  >{{ $translateLang('下载余料导入模板') }}</a-button
                >
              </template>
              <a-button id="supplus_storage_add_batch_import_export_btn">
                <span>{{ $translateLang('余料批量导入导出') }} </span>
                <i class="iconfont icon-chevron-down1 ml8"></i>
              </a-button>
            </a-popover>
            <Input
              class="ml8"
              type="file"
              id="material_import_file_input"
              ref="inputFileRef"
              @input="getFileData"
            />
            <a-popover
              class="ml8"
              placement="bottomLeft"
              trigger="click"
              overlayClassName="more-popover"
              :zIndex="1000"
            >
              <!-- :visible="isPopoverVisible" -->
              <template #content>
                <a-button class="w100 mb8" @click="handleOpenSurplusTrimSetting"
                  ><span
                    ><g-t-view
                      :text="$translateLang('余料默认修边设置')"
                    ></g-t-view
                  ></span>
                </a-button>
                <a-button
                  class="action-btn fs14 color-0 br4 no-select inline-block align-center mb8"
                  style="width: 187px"
                  id="supplus_storage_add_less_reserve_btn"
                >
                  <a-checkbox
                    v-model="isLessReserve"
                    @change="handleLessReserve"
                    id="supplusStorage_isLessReserve"
                  >
                    <span id="supplusStorage_isLessReserve_label" class="pr10">
                      <!-- 启用余料不翻版加工 -->
                      <g-t-view
                        :text="$t('surplusPage.surplusNoRoll')"
                        width="130px"
                      ></g-t-view>
                    </span>
                  </a-checkbox>
                </a-button>
                <div class="relative">
                  <a-button
                    class="action-btn surplus-lock-btn fs14 color-0 br4 no-select inline-block align-center mb8"
                    style="width: 187px"
                    id="supplus_storage_add_surplus_lock_btn"
                  >
                    <a-checkbox
                      v-model="isSurplusLock"
                      @change="handleChangeSurplusLock"
                      id="supplusStorage_surplusLock"
                    >
                      <span id="supplusStorage_surplusLock_label" class="pr10">
                        <!-- 启用余料锁定功能 -->
                        <g-t-view
                          :text="$t('surplusPage.enableSurplusLock')"
                          width="116px"
                        ></g-t-view>
                      </span>
                    </a-checkbox>
                  </a-button>
                  <a-tooltip placement="bottom">
                    <template slot="title">
                      {{ $t('surplusPage.enableSurLockTip') }}
                    </template>
                    <i
                      class="iconfont icon-warning absolute r5 t5"
                      style="color: #18a8c7"
                    ></i>
                  </a-tooltip>
                </div>
                <newContent :is-new-content="false" :show="!isShowSurLockNew">
                  <a-button
                    class="action-btn fs14 color-0 br4 no-select inline-block align-center mb8"
                    style="width: 187px"
                    id="supplus_storage_add_second_confirm_btn"
                  >
                    <a-checkbox
                      v-model="isSecondConfirm"
                      @change="handleChangeSecond"
                      id="supplusStorage_second_confirm"
                    >
                      <span id="supplusStorage_second_confirm_label">
                        <g-t-view
                          :text="$translateLang('启用余料入库二次确认')"
                          width="140px"
                        ></g-t-view>
                      </span>
                    </a-checkbox>
                  </a-button>
                </newContent>
              </template>
              <newContent :show="!isShowSurLockNew">
                <a-button
                  id="supplus_storage_add_more_btn"
                  @click="isPopoverVisible = !isPopoverVisible"
                >
                  <span>
                    <!-- 更多按钮 -->
                    {{ $t('common.moreOperate') }}
                  </span>
                  <i class="iconfont icon-chevron-down1 ml8"></i>
                </a-button>
              </newContent>
            </a-popover>
            <a-button v-show="isSurplusLock" class="ml8" @click="handleRefresh">
              <span class="flex flex-cross--center">
                <i class="iconfont icon-Frame21" style="font-size: 18px"></i>
                <span>
                  <!-- 刷新按钮 -->
                  {{ $t('common.refresh') }}
                </span>
              </span>
            </a-button>
          </div>
          <div class="right-filter">
            <g-paid-feature
              block
              :iconStyle="{ right: '-5px' }"
              :permission-keys="[USER_PERMISSION_KEY.SURPLUS_RECYCLE_BIN]"
              :title="
                isShowRecycleBin
                  ? $t('common.exclusiveFeature')
                  : $t('printTag.dualLanguageTip2')
              "
              style="width: 120px"
              class="mr8"
            >
              <a-button
                class="cursor-pointer delete-btn"
                @click="handleToRecycleBin"
                id="supplus_storage_recycle_bin_btn"
              >
                <i class="el-icon-delete mr2"></i>
                <g-t-view :text="t('recycleBin')" width="100px"></g-t-view>
              </a-button>
            </g-paid-feature>
            <a-input-search
              v-model="keyWord"
              :placeholder="$t('common.inputPlaceholder')"
              @search="getSupplusList()"
              @change="handleChange"
              id="supplus_storage_search_input"
              allowClear
            >
              <a-select
                slot="addonBefore"
                v-model="searchType"
                style="width: 90px"
                id="supplus_storage_search_type_select"
              >
                <a-select-option
                  id="supplus_storage_search_type_select_name"
                  value="name"
                >
                  <!-- 余料名称 -->
                  {{ t('surplusName') }}
                </a-select-option>
                <a-select-option
                  id="supplus_storage_search_type_select_remark"
                  value="remark"
                >
                  <!-- 备注 -->
                  {{ $t('common.remark') }}
                </a-select-option>
              </a-select>
            </a-input-search>
          </div>
        </div>
        <div class="filter pv16 mb20">
          <div class="flex flex-wrap--wrap">
            <div class="filter-item">
              <span class="label">
                <!-- 余料形状 -->
                {{ t('surplusShape') }}：
              </span>
              <a-select
                id="supplus_storage_filter_shap_select"
                v-model="activeShape"
                style="width: 200px"
              >
                <a-select-option
                  id="supplus_storage_filter_shap_select_all"
                  value="全部"
                >
                  <!-- 全部 -->
                  {{ $t('common.all') }}
                </a-select-option>
                <a-select-option
                  id="supplus_storage_filter_shap_select_rect"
                  value="rect"
                >
                  <!-- 矩形 -->
                  {{ $t('common.rect') }}
                </a-select-option>
                <a-select-option
                  id="supplus_storage_filter_shap_select_L"
                  value="L"
                >
                  <!-- L形 -->
                  {{ $translateLang('L形') }}
                </a-select-option>
                <a-select-option
                  id="supplus_storage_filter_shap_select_special"
                  value="specialShape"
                >
                  <!-- L形 -->
                  {{ $translateLang('异形') }}
                </a-select-option>
              </a-select>
            </div>
            <div class="filter-item">
              <span class="label">
                <!-- 板材材质 -->
                {{ $t('common.plankMatCode') }}：
              </span>
              <a-select
                id="supplus_storage_filter_matcode_select"
                v-model="activeMatcode"
                style="width: 200px"
              >
                <a-select-option
                  v-for="(item, index) in ['全部', ...allMatcodeList]"
                  :key="index + 'matcode'"
                  :id="`supplus_storage_filter_matcode_select_${index}`"
                  :value="item"
                  >{{
                    index ? dealMatcodeName(item) : $t('common.all')
                  }}</a-select-option
                >
              </a-select>
            </div>
            <div class="filter-item">
              <span class="label">
                <!-- 筛选 板材厚度 -->
                {{ $t('common.plankThick') }}：
              </span>
              <a-select
                id="supplus_storage_filter_thick_select"
                v-model="activeThick"
                style="width: 200px"
              >
                <a-select-option
                  v-for="(item, index) in ['全部', ...allThickList]"
                  :key="index + 'thick'"
                  :id="`supplus_storage_filter_thick_select_${index}`"
                  :value="item"
                  >{{
                    item == '全部' ? $t('common.all') : item + 'mm'
                  }}</a-select-option
                >
              </a-select>
            </div>
            <div class="filter-item">
              <span class="label">
                <!-- 板材纹理 -->
                {{ $translateLang('纹理') }}：
              </span>
              <a-select
                id="supplus_storage_filter_texDir_select"
                v-model="activeTexDir"
                style="width: 200px"
              >
                <a-select-option
                  v-for="(item, index) in [
                    { label: '全部', value: '全部' },
                    ...allTexDirList,
                  ]"
                  :key="index + 'texDir'"
                  :id="`supplus_storage_filter_texDir_select_${index}`"
                  :value="item.value"
                  >{{ $translateLang(item.label) }}</a-select-option
                >
              </a-select>
            </div>
            <div class="filter-item">
              <span class="label">
                <!-- 板材颜色 -->
                {{ $t('common.plankColor') }}：
              </span>
              <a-select
                id="supplus_storage_filter_color_select"
                v-model="activeColor"
                style="width: 200px"
                showSearch
              >
                <a-select-option
                  v-for="(item, index) in [
                    { label: $t('common.all'), value: '全部' },
                    ...this.allColorList,
                  ]"
                  :key="index + 'color'"
                  :id="`supplus_storage_filter_color_select_${index}`"
                  :value="item.value"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
            </div>
            <div class="filter-item">
              <span class="label">
                <!-- 余料库 -->
                {{ t('surplusStore') }}：
              </span>
              <a-select
                id="supplus_storage_filter_store_select"
                v-model="activeSurplusStore"
                style="width: 200px"
                showSearch
              >
                <a-select-option
                  v-for="(item, index) in [
                    { label: $t('common.all'), value: '全部' },
                    ...this.surplusStoreList,
                  ]"
                  :key="index + 'store'"
                  :id="`supplus_storage_filter_store_select_${index}`"
                  :value="item.value"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
            </div>
            <div class="filter-item" v-show="isSurplusLock">
              <span class="label">
                <!-- 锁定状态 -->
                {{ t('lockStatus') }}：
              </span>
              <a-select
                id="supplus_storage_filter_lock_select"
                v-model="activeLockState"
                style="width: 200px"
              >
                <a-select-option
                  v-for="(item, index) in [
                    { label: $t('common.all'), value: '全部' },
                    ...lockStateList,
                  ]"
                  :key="index + 'lock'"
                  :id="`supplus_storage_filter_lock_select_${index}`"
                  :value="item.value"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
            </div>
            <div class="filter-item">
              <span class="label">
                <!-- 添加时间 -->
                {{ $t('common.addTime') }}：
              </span>
              <el-date-picker
                v-model="activeTime"
                type="daterange"
                align="right"
                unlink-panels
                :range-separator="$t('common.to')"
                :start-placeholder="$t('common.startDate')"
                :end-placeholder="$t('common.endDate')"
                :picker-options="pickerOptions"
                value-format="yyyy/MM/dd"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="filter-btn">
            <a-button
              class="mr8"
              type="primary"
              @click="getSupplusList()"
              id="supplus_storage_filter_btn"
            >
              <!-- 筛选 -->
              {{ ct('filter') }}
            </a-button>
            <a-button @click="resetClassify" id="supplus_storage_reset_btn">
              <!-- 重置 -->
              {{ ct('reset') }}
            </a-button>
          </div>
        </div>
        <a-table
          :columns="supplusColumn"
          :data-source="supplusList"
          row-key="id"
          :scroll="{
            x: '100%',
            y: 'calc(100vh - 64px - 40px - 160px - 20px - 52px - 20px - 170px)',
          }"
          :pagination="false"
          :customRow="handleClickTableRow"
          class="surplus-table"
        >
          <template slot="selectTitle">
            <a-popover
              trigger="click"
              placement="right"
              overlayClassName="select-all-popover"
            >
              <template #content>
                <div class="select-all-checkbox-group">
                  <a-checkbox-group
                    v-model="selectAllTypeList"
                    @change="handleSelectAllTypeChange"
                  >
                    <div class="select-all-checkbox-item">
                      <a-checkbox
                        value="port"
                        id="supplus_storage_list_current_page_checkbox"
                      >
                        {{ $t('surplusPage.currentPage') }}
                      </a-checkbox>
                    </div>
                    <div class="select-all-checkbox-item">
                      <a-checkbox
                        value="all"
                        @change="handleChangeTotalPage"
                        id="supplus_storage_list_total_page_checkbox"
                      >
                        {{ $t('surplusPage.totalPage') }}
                      </a-checkbox>
                    </div>
                  </a-checkbox-group>
                </div>
              </template>
              <a-checkbox
                :checked="isSelectAll"
                :indeterminate="isIndeterminate"
                id="supplus_storage_list_all_checkbox"
                @change="handleHeaderCheckboxChange"
              ></a-checkbox>
            </a-popover>
          </template>
          <template slot="select" slot-scope="text, record, index">
            <div class="relative">
              <GCopyLine
                v-if="record.id === currentClickSurplus.id"
                class="copy-line"
                :showText="ct('clickCopy', { type: ct('currentLine') })"
                :rowIndex="index"
                @copyClick="copyLine(record)"
              />
              <a-checkbox
                v-model="record.isSelected"
                class="ml20"
                :id="`supplus_storage_table_${index}_select_checkbox`"
                @change="selectedSurplus(record)"
              ></a-checkbox>
            </div>
          </template>
          <template slot="surplusTrimEdgeTitle">
            <div class="flex trim-box">
              <span>{{ $translateLang('修边') }}</span>
              <a-tooltip placement="top">
                <template slot="title">
                  <div>
                    <span>{{
                      $translateLang('1.自定义修边功能仅对焊接板生效')
                    }}</span>
                  </div>
                  <span>2.L形余料、异形余料不支持使用自定义修边</span>
                </template>
                <img
                  src="@/assets/icon/questionMark.png"
                  alt=""
                  class="ml20"
                  style="width: 17px; height: 17px"
                />
              </a-tooltip>
            </div>
          </template>
          <template slot="surplusType" slot-scope="text, record, index">
            <!-- 形状 -->
            <g-t-view
              style="padding-left: 10px"
              width="100%"
              :id="`supplus_storage_table_${index}_surplusType_checkbox`"
              :text="$t(record.surplusType)"
            >
            </g-t-view>
          </template>
          <template slot="surplusNum" slot-scope="text, record">
            <!-- 余料条码 -->
            {{ record.plankNum ?? '-' }}
          </template>
          <template slot="type" slot-scope="text, record">
            {{ record.type?.replace('高光_', '') }}
          </template>
          <template slot="is_high_gloss_plank" slot-scope="text, record, index">
            <a-select
              v-model="record.is_high_gloss_plank"
              size="small"
              :id="`supplus_storage_table_${index}_highGlossPlank_select`"
              @change="onHighPlankChange(record)"
              placeholder="请选择是否是高光板"
            >
              <a-select-option
                v-for="(item, i) in [
                  {
                    value: 0,
                    label: `非${matchHighlightBoardName(record.type)}`,
                  },
                  {
                    value: 1,
                    label: matchHighlightBoardName(record.type),
                  },
                ]"
                :key="i"
                :value="item.value"
                :id="`supplus_storage_table_${index}_highGlossPlank_select_${i}`"
                >{{ item.label }}</a-select-option
              >
            </a-select>
          </template>
          <template slot="texDir" slot-scope="text, record, index">
            <a-select
              v-model="record.texDir"
              size="small"
              :id="`supplus_storage_table_${index}_texDir_select`"
              @change="onHighPlankChange(record)"
              placeholder="请选择纹理"
            >
              <a-select-option
                v-for="(item, i) in [
                  {
                    value: 'normal',
                    label: $translateLang('竖纹'),
                  },
                  {
                    value: 'reverse',
                    label: $translateLang('横纹'),
                  },
                  {
                    value: 'notcare',
                    label: $translateLang('无纹理'),
                  },
                ]"
                :key="i"
                :value="item.value"
                :id="`supplus_storage_table_${index}_texDir_select_${i}`"
                >{{ item.label }}</a-select-option
              >
            </a-select>
          </template>
          <template slot="highlight_surface" slot-scope="text, record, index">
            <a-select
              v-model="record.highlight_surface"
              size="small"
              :id="`supplus_storage_table_${index}_highGlossSide_select`"
              :disabled="!record.is_high_gloss_plank"
              @change="onHighPlankChange(record)"
              placeholder="请选择高光面"
            >
              <a-select-option
                v-for="(item, i) in [
                  {
                    value: 1,
                    label: $translateLang('正面'),
                  },
                  {
                    value: 2,
                    label: $translateLang('反面'),
                  },
                  {
                    value: 0,
                    label: $translateLang('无正反'),
                  },
                ]"
                :key="i"
                :value="item.value"
                :id="`supplus_storage_table_${index}_highGlossSide_select_${i}`"
                >{{ item.label }}</a-select-option
              >
            </a-select>
          </template>
          <template slot="lock_status" slot-scope="text, record, index">
            <span :id="`supplus_storage_table_${index}_lock_status`">
              {{ record.lock_status ? '已锁定' : '未锁定' }}</span
            >
          </template>
          <template slot="lock_order" slot-scope="text, record">
            <span :title="record.lock_order">{{
              record.lock_order ? record.lock_order : '-'
            }}</span>
          </template>
          <template slot="lock_order" slot-scope="text, record, index">
            <span
              :title="record.lock_order"
              :id="`supplus_storage_table_${index}_lock_order`"
              >{{ record.lock_order ? record.lock_order : '-' }}</span
            >
          </template>
          <template slot="branch_name" slot-scope="text, record, index"
            ><span :id="`supplus_storage_table_${index}_branch_name`">{{
              record.branch_name ? record.branch_name : '-'
            }}</span></template
          >
          <template slot="operation" slot-scope="text, record, index">
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding-right: 8px;
              "
            >
              <span
                :id="`supplus_storage_table_${index}_edit_btn`"
                class="table-operation-btn ml10"
                @click="showEditSurplus(record)"
              >
                <!-- 编辑 -->
                <g-t-view :text="ct('edit')" width="28px"></g-t-view>
              </span>
              <a-popover
                trigger="click"
                placement="bottom"
                @visibleChange="(value) => showSupplusShape(value, record)"
                destroyTooltipOnHide
                arrowPointAtCenter
                :getPopupContainer="getPopupContainer"
              >
                <template slot="content">
                  <drawSupplus
                    :canvasKey="String(record.shape)"
                    :size="drawObj"
                    :isDrawSize="true"
                    :drawScale="drawScale"
                  ></drawSupplus>
                  <!-- TODO C形余料绘制 -->
                  <!-- <draw-supplus
                    canvasKey="C"
                    :size="{
                      width: 172,
                      long: 257,
                      mid_long: 150, //缺口宽
                      left_long: 10, // 缺口左边位置
                      right_long: 10 // 缺口右边位置 (long - left_long - right_long = 缺口高)
                  }"
                    :drawScale="1"
                  /> -->
                </template>
                <span
                  :id="`supplus_storage_table_${index}_detail_btn`"
                  class="table-operation-btn"
                  v-bp="'supplus_storage:detail'"
                >
                  <!-- 详情 -->
                  <g-t-view :text="ct('detail')" width="28px"></g-t-view>
                </span>
              </a-popover>
              <a-popover
                placement="bottom"
                overlayClassName="more-operate-popover"
              >
                <template #content>
                  <p
                    style="color: #18a8c7"
                    class="cursor-pointer"
                    @click="handleShowTransSurplus(record)"
                    :id="`supplus_storage_table_${index}_tran_btn`"
                  >
                    <!-- 转移 -->
                    {{ ct('transferByType', {}) }}
                  </p>
                  <p
                    style="color: #18a8c7"
                    class="cursor-pointer"
                    @click="showDeleteDialog(record)"
                    :id="`supplus_storage_table_${index}_delete_btn`"
                  >
                    <!-- 删除 -->
                    {{ ct('delete') }}
                  </p>
                  <p
                    style="color: #18a8c7"
                    class="cursor-pointer"
                    @click="handleLock(record)"
                    v-show="isSurplusLock"
                    :id="`supplus_storage_table_${index}_lock_btn`"
                  >
                    <!-- 锁定、解锁 -->
                    <g-t-view
                      :text="
                        record.lock_status == 1 ? ct('unlock') : ct('lock')
                      "
                      width="56px"
                    ></g-t-view>
                  </p>
                  <!-- 复制 -->
                  <p
                    style="color: #18a8c7"
                    class="cursor-pointer mb0"
                    @click="showCopyDialog(record)"
                    :id="`supplus_storage_table_${index}_copy_btn`"
                  >
                    <g-t-view :text="ct('copy')" width="56px"></g-t-view>
                  </p>
                </template>
                <span class="table-operation-btn mr0">
                  <!-- 更多 -->
                  <g-t-view
                    :text="ct('moreOperate')"
                    width="56px"
                    :id="`supplus_storage_table_${index}_more_operate_btn`"
                  ></g-t-view>
                </span>
              </a-popover>
            </div>
          </template>
          <template slot="surplus_trim_edge" slot-scope="text, record, index">
            <a-tooltip placement="top">
              <template slot="title">
                <!-- 如果不存在,需要显示默认的修边设置 -->
                {{ getTrimDisplay(record, 'text') }}
              </template>
              <!-- 如果不存在,需要显示默认的修边设置 -->
              <span :id="`supplus_storage_table_${index}_trim_edge`">{{
                getTrimDisplay(record, 'edge')
              }}</span>
            </a-tooltip>
          </template>
        </a-table>
        <div class="supplus-pagination absolute b5">
          <div>
            <span class="color-o-6 mr15">
              <!-- 已选 {{selectedSurplusList.length}} 条数据 -->
              {{
                ct('chooseAmountData', {
                  number: selectedSurplusList.length + '',
                })
              }}
            </span>
            <a-button
              @click="showDeleteDialog()"
              :disabled="notAbleDelete"
              id="supplus_storage_delete-btn"
            >
              {{ $t('common.batchDelete') }}
            </a-button>
            <a-button
              @click="handleShowTransSurplus()"
              :disabled="notAbleDelete"
              id="supplus_storage_trans-btn"
              class="ml8"
            >
              <!-- 批量转移 -->
              {{ t('batchTransfer') }}
            </a-button>
            <a-popover
              placement="top"
              overlayClassName="batch-lock-popover"
              trigger="click"
              :visible="showBatchLockPop"
            >
              <template #content>
                <p
                  class="cursor-pointer"
                  @click="handleBatchLock(1)"
                  id="supplus_storage_lock-btn"
                >
                  <!-- 余料锁定 -->
                  <g-t-view :text="ct('surplusLock')" width="90px"></g-t-view>
                </p>
                <p
                  class="cursor-pointer mb0"
                  @click="handleBatchLock(0)"
                  id="supplus_storage_un_lock-btn"
                >
                  <!-- 余料解锁 -->
                  <g-t-view :text="ct('surplusUnlock')" width="90px"></g-t-view>
                </p>
              </template>
              <a-button
                :disabled="notAbleDelete"
                id="supplus_storage_batch_lock-btn"
                class="ml8"
                v-show="isSurplusLock"
                @click="showBatchLockPop = true"
                :title="$t('common.batchLock')"
              >
                <!-- 批量锁定/解锁 -->
                <g-t-view :text="ct('batchLock')" width="90px"></g-t-view>
              </a-button>
            </a-popover>
          </div>
          <div>
            <a-pagination
              v-model="page"
              :page-size-options="pageSizeOptions"
              :total="totalSupplus"
              show-size-changer
              :page-size="pageSize"
              @showSizeChange="onShowSizeChange"
              @change="changeCurrentPage"
              :show-total="
                () =>
                  ct('paginationTotalTip', {
                    current: (page - 1) * pageSize + 1,
                    page: page * pageSize,
                    total: totalSupplus,
                  })
              "
            >
              <template slot="buildOptionText" slot-scope="props">
                <span v-if="props.value != totalSupplus"
                  >{{ props.value }}{{ ct('strip') }}/{{ ct('page') }}</span
                >
                <span v-if="props.value == totalSupplus">{{ ct('all') }}</span>
              </template>
            </a-pagination>
            <div class="jump-to-page">
              <span>
                <!-- 跳至 -->
                {{ t('jumpTo') }}
              </span>
              <a-input
                @pressEnter="jumpToPage"
                @input="pageInputCheck"
                v-model="jumpPage"
                id="supplus_storage_pagination_input"
              ></a-input>
              <span>{{ ct('page') }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 余料库页面 -->
      <div v-else>
        <surplusStore @onGoDetail="handleGoDetail" />
      </div>
    </div>
    <!--    新建材质/新建颜色-->
    <div
      class="new-classify-dialog"
      v-if="isShowNewClassify"
      @click="closeNewClassify"
      id="supplus_storage_new_btn"
      style="z-index: 9999"
    >
      <div class="new-classify-content" @click.stop>
        <div class="new-classify-title">
          {{
            newClassifyType == 'matcode'
              ? translateLang('surplusPage.newMatcode')
              : translateLang('surplusPage.newColor')
          }}
        </div>
        <a-input
          id="supplus_storage_new_class_input"
          v-model="newClassify"
          class="new-classify"
        ></a-input>
        <div class="new-classify-btns">
          <div>
            <a-button
              id="supplus_storage_new_cancel_btn"
              @click="closeNewClassify"
              >{{ $t('common.cancel') }}</a-button
            >
            <a-button
              id="supplus_storage_new_confirm_btn"
              class="confirm-btn"
              @click="saveNewClassify"
              >{{ $t('common.confirm') }}</a-button
            >
          </div>
        </div>
      </div>
    </div>

    <!--  编辑侧边栏-->

    <el-drawer
      :visible.sync="showEditDrawer"
      direction="rtl"
      @close="closeEditDrawer"
      custom-class="surplus-new-plank"
      :size="500"
      :modal-append-to-body="false"
      :show-close="false"
    >
      <template slot="title">
        <div class="drawer-title-box">
          <span style="color: #333; font-size: 18px">{{
            $t('surplusPage.editSurplus')
          }}</span>
          <span
            id="supplus_storage_edit_close_btn"
            class="iconfont icon-close"
            @click="closeEditDrawer"
          ></span>
        </div>
      </template>
      <div class="edit-plank-info">
        <div class="plank-info-item">
          <div class="title-box">
            <span class="title">{{ $translateLang('余料条码') }}：</span>
          </div>
          <a-input disabled :value="currentSurplus.plankNum"></a-input>
        </div>
        <div class="plank-info-item">
          <div class="title-box">
            <span class="import">*</span>
            <span class="title">{{ $t('surplusPage.surplusName') }}：</span>
          </div>
          <a-input
            :maxLength="11"
            v-model="newSupplus.name"
            :placeholder="translateLang('common.inputPlaceholder')"
            :class="inputAlert.nameInputAlert ? 'alert-input' : ''"
            @input="inputCheck('name')"
            @blur="inputCheck('name')"
            id="supplus_storage_edit_name_input"
          >
            <span class="plank-form-limit" slot="suffix"
              >{{ newSupplus.name.length }}/10</span
            >
          </a-input>
          <transition name="errorInfo">
            <span
              v-show="inputAlert.nameInputAlert"
              class="error-info"
              id="supplus_storage_edit_name_input_error"
            >
              {{ inputAlert.nameInputAlert }}
            </span>
          </transition>
        </div>
        <div class="plank-info-item">
          <div class="title-box">
            <span class="title"
              >{{ $t('materialPage.surplusHead.shape') }}：</span
            >
          </div>
          <a-input
            disabled
            :value="
              (() => {
                const shapeObj = {
                  0: 'common.rect',
                  1: 'common.Ltype',
                  2: 'common.isSpecial',
                }
                return translateLang(shapeObj[currentSurplus.shape])
              })()
            "
          ></a-input>
        </div>
        <div class="plank-info-item">
          <div class="title-box">
            <span class="import">*</span>
            <span class="title">{{ $t('common.plankHeight') }}：</span>
          </div>
          <a-input
            v-model="newSupplus.long"
            :placeholder="translateLang('common.inputPlaceholder')"
            :class="inputAlert.longInputAlert ? 'alert-input' : ''"
            @input="inputCheck('long')"
            @blur="inputCheck('long')"
            :disabled="[1, 2].includes(currentSurplus.shape)"
            id="supplus_storage_edit_long_input"
          >
            <span slot="addonAfter" class="plank-form-after">mm</span>
          </a-input>
          <transition name="errorInfo">
            <span
              v-show="inputAlert.longInputAlert"
              class="error-info"
              id="supplus_storage_edit_long_input_error_info"
            >
              {{ inputAlert.longInputAlert }}
            </span>
          </transition>
        </div>
        <div class="plank-info-item" v-if="selectedShape == 'L'">
          <div class="title-box">
            <span class="import">*</span>
            <span class="title">{{ $t('common.shortLong') }}：</span>
          </div>
          <a-input
            v-model="newSupplus.min_long"
            :placeholder="translateLang('common.inputPlaceholder')"
            :class="inputAlert.minLongInputAlert ? 'alert-input' : ''"
            @input="inputCheck('min_long')"
            @blur="inputCheck('min_long')"
            :disabled="[1, 2].includes(currentSurplus.shape)"
            id="supplus_storage_edit_min_long_input"
          >
            <span slot="addonAfter" class="plank-form-after">mm</span>
          </a-input>
          <transition name="errorInfo">
            <span
              v-show="inputAlert.minLongInputAlert"
              class="error-info"
              id="supplus_storage_edit_min_long_input_error"
            >
              {{ inputAlert.minLongInputAlert }}
            </span>
          </transition>
        </div>
        <div class="plank-info-item">
          <div class="title-box">
            <span class="import">*</span>
            <span class="title">{{ $t('common.plankWidth') }}：</span>
          </div>
          <a-input
            v-model="newSupplus.width"
            :placeholder="translateLang('common.inputPlaceholder')"
            :class="inputAlert.widthInputAlert ? 'alert-input' : ''"
            @input="inputCheck('width')"
            @blur="inputCheck('width')"
            :disabled="[1, 2].includes(currentSurplus.shape)"
            id="supplus_storage_edit_width_input"
          >
            <span slot="addonAfter" class="plank-form-after">mm</span>
          </a-input>
          <transition name="errorInfo">
            <span
              v-show="inputAlert.widthInputAlert"
              class="error-info"
              id="supplus_storage_edit_width_input_error"
            >
              {{ inputAlert.widthInputAlert }}
            </span>
          </transition>
        </div>
        <div class="plank-info-item" v-if="selectedShape == 'L'">
          <div class="title-box">
            <span class="import">*</span>
            <span class="title">{{ $t('common.shortWidth') }}：</span>
          </div>
          <a-input
            v-model="newSupplus.min_width"
            :placeholder="translateLang('common.inputPlaceholder')"
            :class="inputAlert.minWidthInputAlert ? 'alert-input' : ''"
            @input="inputCheck('min_width')"
            @blur="inputCheck('min_width')"
            :disabled="[1, 2].includes(currentSurplus.shape)"
            id="supplus_storage_edit_min_width_input"
          >
            <span slot="addonAfter" class="plank-form-after">mm</span>
          </a-input>
          <transition name="errorInfo">
            <span
              v-show="inputAlert.minWidthInputAlert"
              class="error-info"
              id="supplus_storage_edit_min_width_input_error"
            >
              {{ inputAlert.minWidthInputAlert }}
            </span>
          </transition>
        </div>
        <div class="plank-info-item">
          <div class="title-box">
            <span class="import">*</span>
            <span class="title">{{ $t('common.plankThick') }}：</span>
          </div>
          <a-input
            v-model="newSupplus.thick"
            :placeholder="translateLang('common.inputPlaceholder')"
            :class="inputAlert.thickInputAlert ? 'alert-input' : ''"
            @input="inputCheck('thick')"
            @blur="inputCheck('thick')"
            id="supplus_storage_edit_thick_input"
          >
            <span slot="addonAfter" class="plank-form-after">mm</span>
          </a-input>
          <transition name="errorInfo">
            <span
              v-show="inputAlert.thickInputAlert"
              class="error-info"
              id="supplus_storage_edit_thick_input_error"
            >
              {{ inputAlert.thickInputAlert }}
            </span>
          </transition>
        </div>
        <!-- 余料修边 修改-->
        <div class="plank-info-item" v-if="currentSurplus.shape == 0">
          <div class="title-box">
            <span class="import">*</span>
            <span class="title">{{ $translateLang('修边方式') }}：</span>
          </div>
          <a-radio-group
            v-model="newSupplus.trimmingMethod"
            class="flex"
            style="width: 350px"
          >
            <a-radio value="follow">
              <g-t-view
                :text="$translateLang('跟随原片中标准板材的修边值')"
                width="220px"
              ></g-t-view
            ></a-radio>
            <a-radio value="custom">{{
              $translateLang('单独设置修边值')
            }}</a-radio>
          </a-radio-group>
        </div>
        <!-- 单独设置修边值 -->
        <div
          class="plank-info-item"
          v-if="newSupplus.trimmingMethod === 'custom'"
        >
          <div class="title-box">
            <span class="import">*</span>
            <span class="title">{{ $translateLang('修边值') }}：</span>
          </div>
          <a-input
            addon-after="mm"
            v-model="newSupplus.trimValue"
            @input="inputCheck('trimValue', $event)"
            @blur="inputCheck('trimValue', $event)"
            :class="inputAlert.trimValueInputAlert ? 'alter-input' : ''"
            :disabled="newSupplus.isCustomTrim"
            style="width: 200px"
          ></a-input>
          <transition name="errorInfo">
            <span
              v-show="inputAlert.trimValueInputAlert"
              class="error-info"
              id="supplus_storage_edit_thick_input_error"
            >
              {{ inputAlert.trimValueInputAlert }}
            </span>
          </transition>
          <a-checkbox
            class="ml16"
            style="line-height: 30px"
            v-model="newSupplus.isCustomTrim"
            >{{ $translateLang('自定义修边值') }}</a-checkbox
          >
        </div>
        <template
          v-if="
            newSupplus.isCustomTrim && newSupplus.trimmingMethod === 'custom'
          "
        >
          <div class="plank-info-item">
            <div class="title-box">
              <span class="import">*</span>
              <span class="title">{{ $translateLang('上修边') }}：</span>
            </div>
            <a-input
              addon-after="mm"
              v-model="newSupplus.topTrim"
              @input="inputCheck('topTrim', $event)"
              @blur="inputCheck('topTrim', $event)"
              :class="inputAlert.topTrimInputAlert"
            ></a-input>
            <transition name="errorInfo">
              <span
                v-show="inputAlert.topTrimInputAlert"
                class="error-info"
                id="supplus_storage_edit_thick_input_error"
              >
                {{ inputAlert.topTrimInputAlert }}
              </span>
            </transition>
          </div>
          <div class="plank-info-item">
            <div class="title-box">
              <span class="import">*</span>
              <span class="title">{{ $translateLang('下修边') }}：</span>
            </div>
            <a-input
              addon-after="mm"
              v-model="newSupplus.bottomTrim"
              @input="inputCheck('bottomTrim', $event)"
              @blur="inputCheck('bottomTrim', $event)"
              :class="inputAlert.bottomTrimInputAlert"
            ></a-input>
            <transition name="errorInfo">
              <span
                v-show="inputAlert.bottomTrimInputAlert"
                class="error-info"
                id="supplus_storage_edit_thick_input_error"
              >
                {{ inputAlert.bottomTrimInputAlert }}
              </span>
            </transition>
          </div>
          <div class="plank-info-item">
            <div class="title-box">
              <span class="import">*</span>
              <span class="title">{{ $translateLang('左修边') }}：</span>
            </div>
            <a-input
              addon-after="mm"
              v-model="newSupplus.leftTrim"
              @input="inputCheck('leftTrim', $event)"
              @blur="inputCheck('leftTrim', $event)"
              :class="inputAlert.leftTrimInputAlert"
            ></a-input>
            <transition name="errorInfo">
              <span
                v-show="inputAlert.leftTrimInputAlert"
                class="error-info"
                id="supplus_storage_edit_thick_input_error"
              >
                {{ inputAlert.leftTrimInputAlert }}
              </span>
            </transition>
          </div>
          <div class="plank-info-item">
            <div class="title-box">
              <span class="import">*</span>
              <span class="title">{{ $translateLang('右修边') }}：</span>
            </div>
            <a-input
              addon-after="mm"
              v-model="newSupplus.rightTrim"
              @input="inputCheck('rightTrim', $event)"
              @blur="inputCheck('rightTrim', $event)"
              :class="inputAlert.rightTrimInputAlert"
            ></a-input>
            <transition name="errorInfo">
              <span
                v-show="inputAlert.rightTrimInputAlert"
                class="error-info"
                id="supplus_storage_edit_thick_input_error"
              >
                {{ inputAlert.rightTrimInputAlert }}
              </span>
            </transition>
          </div>
        </template>
        <!-- 纹理 -->
        <div class="plank-info-item">
          <div class="title-box">
            <span class="import">*</span>
            <span class="title">{{ $translateLang('纹理') }}：</span>
          </div>
          <el-select
            style="width: 368px"
            v-model="newSupplus.texDir"
            size="small"
            :placeholder="$translateLang('请选择')"
            id="supplus_storage_edit_gloss_select"
          >
            <el-option
              v-for="(item, index) in [
                {
                  value: 'normal',
                  label: $translateLang('竖纹'),
                },
                {
                  value: 'reverse',
                  label: $translateLang('横纹'),
                },
                {
                  value: 'notcare',
                  label: $translateLang('无纹理'),
                },
              ]"
              :key="index"
              :value="item.value"
              :label="translateLang(item.label)"
              :id="`supplus_storage_edit_texDir_select_${index}`"
            ></el-option>
          </el-select>
        </div>
        <div class="plank-info-item">
          <div class="title-box">
            <span class="import">*</span>
            <span class="title">{{ $t('common.plankMatCode') }}：</span>
          </div>
          <!-- <a-input
            v-model="newSupplus.type"
            v-if="isThinkerxMaterial"
            @blur="inputCheck('type')"
            @input="inputCheck('type')"
            :class="inputAlert.typeInputAlert ? 'alert-input' : ''"
            style="height: 32px;"
            id="supplus_storage_edit_type_input"
          ></a-input> -->
          <!-- 材质 -->
          <a-select
            show-search
            allowClear
            :placeholder="translateLang('common.inputPlaceholder')"
            option-filter-prop="children"
            style="width: 368px; height: 32px"
            :filter-option="filterOption"
            v-model="newSupplus.type"
            :class="inputAlert.typeInputAlert ? 'alert-input' : ''"
            @blur="inputCheck('type')"
            @change="handleSelectMatCode"
            @keydown.native.enter="handleEnterMatCode"
            dropdownClassName="supplus-storage-select"
            id="supplus_storage_edit_type_select"
          >
            <a-select-option
              v-for="(item, index) in matcodeList.filter((v) => v != '全部')"
              :key="'type' + index"
              :value="item + '@_@' + index"
              :id="`supplus_storage_edit_type_select_${index}`"
              >{{ item }}</a-select-option
            >
          </a-select>
          <transition name="errorInfo">
            <span
              v-show="inputAlert.typeInputAlert"
              class="error-info"
              id="supplus_storage_edit_type_input_error"
            >
              {{ inputAlert.typeInputAlert }}
            </span>
          </transition>
        </div>
        <!-- 颜色 -->
        <div class="plank-info-item">
          <div class="title-box">
            <span class="import">*</span>
            <span class="title">{{ $t('common.plankColor') }}：</span>
          </div>
          <el-cascader
            v-loading="isLoadingColors"
            id="supplus_material_edit_color_input"
            :class="{ 'error-border': inputAlert.colorInputAlert }"
            size="small"
            v-model="newPlankInfoTexture"
            :options="materialColorOptions"
            @change="handleSelectTexture"
            @keydown.enter.native="handleEnterColor"
            @keyup.delete.native="handleDeleteColorSearch('edit')"
            @blur="inputCheck('color')"
            ref="editColorCascaderRef"
            :before-filter="onBeforeFilter"
            :show-all-levels="false"
            filterable
            clearable
            :placeholder="translateLang('surplusPage.autoCreateColor')"
          />

          <transition name="errorInfo">
            <span
              v-show="inputAlert.colorInputAlert"
              class="error-info"
              id="supplus_storage_edit_color_input_error"
            >
              {{ inputAlert.colorInputAlert }}
            </span>
          </transition>
        </div>
        <!-- 数量 -->
        <div class="plank-info-item">
          <div class="title-box">
            <span class="import">*</span>
            <span class="title">{{ $t('common.count') }}：</span>
          </div>
          <a-input
            v-model="newSupplus.amount"
            :placeholder="translateLang('common.inputPlaceholder')"
            :class="inputAlert.amountInputAlert ? 'alert-input' : ''"
            @input="inputCheck('amount')"
            @blur="inputCheck('amount')"
            disabled
            id="supplus_storage_edit_amount_input"
          ></a-input>
          <transition name="errorInfo">
            <span
              v-show="inputAlert.amountInputAlert"
              class="error-info"
              id="supplus_storage_edit_amount_input_error"
            >
              {{ inputAlert.amountInputAlert }}
            </span>
          </transition>
        </div>
        <!-- 高光板 -->
        <div class="plank-info-item">
          <div class="title-box">
            <span class="import">*</span>
            <span class="title">{{ $t('common.heighGlossPlank') }}：</span>
          </div>
          <el-select
            style="width: 368px"
            v-model="newSupplus.is_high_gloss_plank"
            size="small"
            :placeholder="translateLang('common.isHeightGloss')"
            id="supplus_storage_edit_gloss_select"
          >
            <el-option
              v-for="(item, index) in [
                {
                  value: 0,
                  label: `非${matchHighlightBoardName(newSupplus.type)}`,
                },
                {
                  value: 1,
                  label: matchHighlightBoardName(newSupplus.type),
                },
              ]"
              :key="index"
              :value="item.value"
              :label="translateLang(item.label)"
              :id="`supplus_storage_edit_gloss_select_${index}`"
            ></el-option>
          </el-select>
        </div>
        <!-- 高光面 -->
        <div class="plank-info-item">
          <div class="title-box">
            <span class="import">*</span>
            <span class="title">{{ $t('common.heighGlossSide') }}：</span>
          </div>
          <el-select
            style="width: 368px"
            v-model="newSupplus.highlight_surface"
            :disabled="!newSupplus.is_high_gloss_plank"
            size="small"
            :placeholder="$translateLang('请选择')"
            id="supplus_storage_edit_highlight_surface_select"
          >
            <el-option
              v-for="(item, index) in [
                {
                  value: 1,
                  label: $translateLang('正面'),
                },
                {
                  value: 2,
                  label: $translateLang('反面'),
                },
                {
                  value: 0,
                  label: $translateLang('无正反'),
                },
              ]"
              :key="index"
              :value="item.value"
              :label="item.label"
              :id="`supplus_storage_edit_highlight_surface_select_${index}`"
            ></el-option>
          </el-select>
        </div>
        <div class="plank-info-item">
          <div class="title-box">
            <span class="title">
              <!-- 所在余料库 -->
              {{ t('branchName') }}：
            </span>
          </div>
          <el-select
            style="width: 368px"
            v-model="newSupplus.branch_no"
            size="small"
            placeholder="请选择所在余料库"
            id="supplus_storage_edit_branch_name_select"
            clearable
          >
            <el-option
              v-for="(item, index) in surplusStoreList"
              :key="index"
              :value="item.value"
              :label="item.label"
              :id="`supplus_storage_edit_branch_name_select_${index}`"
            ></el-option>
          </el-select>
        </div>
        <div class="plank-info-item" v-show="isSurplusLock">
          <div class="title-box">
            <span class="title">
              <!-- 锁定状态 -->
              {{ t('lockStatus') }}：
            </span>
          </div>
          <el-select
            style="width: 368px"
            v-model="newSupplus.lock_status"
            size="small"
            placeholder="请选择锁定状态"
            id="supplus_storage_edit_lock_state_select"
            clearable
          >
            <el-option
              v-for="(item, index) in lockStateList"
              :key="index"
              :value="item.value"
              :label="item.label"
              :id="`supplus_storage_edit_branch_name_select_${index}`"
            ></el-option>
          </el-select>
        </div>
        <div
          class="plank-info-item"
          v-show="
            isSurplusLock &&
            newSupplus.lock_order &&
            newSupplus.lock_status == 1
          "
        >
          <div class="title-box">
            <span class="title">
              <!-- 锁定订单： -->
              {{ t('lockOrder') }}：
            </span>
          </div>
          <a-input
            v-model="newSupplus.lock_order"
            :title="newSupplus.lock_order"
            id="supplus_storage_edit_lock_order_input"
            :disabled="true"
          />
        </div>
        <div class="plank-info-item" v-if="newSupplus.from_address">
          <div class="title-box">
            <span class="title">{{ $t('surplusPage.orderAddress') }}：</span>
          </div>
          <a-input
            v-model="newSupplus.from_address"
            disabled
            @input="inputCheck('remark')"
            id="supplus_storage_edit_orderAddress_input"
          ></a-input>
          <transition name="errorInfo">
            <span
              v-show="inputAlert.orderAddressInputAlert"
              class="error-info remark-info"
              id="supplus_storage_edit_orderAddress_input_error"
              >{{ inputAlert.orderAddressInputAlert }}</span
            >
          </transition>
        </div>
        <div class="plank-info-item" v-if="newSupplus.from_order_num">
          <div class="title-box">
            <span class="title">{{ $t('surplusPage.orderId') }}：</span>
          </div>
          <a-input
            v-model="newSupplus.from_order_num"
            disabled
            @input="inputCheck('remark')"
            id="supplus_storage_edit_orderId_input"
          ></a-input>
          <transition name="errorInfo">
            <span
              v-show="inputAlert.orderIdInputAlert"
              class="error-info remark-info"
              id="supplus_storage_edit_orderId_input_error"
              >{{ inputAlert.orderIdInputAlert }}</span
            >
          </transition>
        </div>
        <div class="plank-info-item remark-form" v-if="!newSupplus.fromGg">
          <div class="title-box">
            <span class="title"
              >{{ $t('materialPage.surplusHead.remark') }}：</span
            >
          </div>
          <a-textarea
            style="height: 88px; resize: none"
            v-model="newSupplus.remark"
            @input="inputCheck('remark')"
            id="supplus_storage_edit_remark_textarea"
          ></a-textarea>
          <transition name="errorInfo">
            <span
              v-show="inputAlert.remarkInputAlert"
              class="error-info remark-info"
              id="supplus_storage_edit_remark_textarea_error"
              >{{ inputAlert.remarkInputAlert }}</span
            >
          </transition>
        </div>
        <div class="edit-bottom-operation">
          <div>
            <a-button
              id="supplus_storage_edit_cancel_btn"
              @click="closeEditDrawer"
              >{{ $t('common.cancel') }}</a-button
            >
            <a-button
              id="supplus_storage_edit_confirm_btn"
              @click="confirmEditSurplus"
              >{{ $t('common.confirm') }}</a-button
            >
          </div>
        </div>
      </div>
    </el-drawer>

    <!--    侧边栏添加余料-->

    <el-drawer
      :title="translateLang('surplusPage.addSurplus')"
      :visible.sync="addSupplusDrawer"
      append-to-body
      size="550px"
      :with-header="false"
      @close="handleCloseDrawer"
    >
      <div class="new-supllus-dialog">
        <div style="padding: 20px">
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              height: 50px;
            "
          >
            <div
              :class="[
                selectedShape == 'rect' ? 'active-shape-side' : '',
                'select-shape-side',
              ]"
              @click="changeSelectedShape('rect')"
              id="supplus_storage_add_shape_rect_btn"
            >
              <span>{{ $t('surplusPage.rectSurplus') }}</span>
              <span class="iconfont icon-right"></span>
            </div>
            <div
              :class="[
                selectedShape == 'L' ? 'active-shape-side' : '',
                'select-shape-side',
              ]"
              @click="changeSelectedShape('L')"
              id="supplus_storage_add_shape_L_btn"
            >
              <span>{{ $t('surplusPage.LTypeSurplus') }}</span>
              <span class="iconfont icon-right"></span>
            </div>
          </div>

          <!-- 缩放比例 -->
          <div class="plank-img">
            <div style="margin-left: 28%">
              <drawSupplus
                v-if="addSupplusDrawer"
                :canvasKey="selectedShape"
                :size="drawObj"
                :drawScale="2.5"
                isNewSurplus
              ></drawSupplus>
            </div>
          </div>
          <div class="right-supplus-form">
            <div class="supplus-info-img">
              <div class="plank-info">
                <div
                  class="plank-info-item"
                  style="display: flex; flex-direction: column"
                >
                  <div class="base-info">
                    {{ $t('materialPage.paibanSetting.baseInfo') }}
                  </div>
                  <el-row>
                    <el-col :span="5">
                      <div style="float: right">
                        <span style="color: red">*</span>
                        <span style="line-height: 30px"
                          >{{ $t('surplusPage.surplusName') }}：</span
                        >
                      </div>
                    </el-col>
                    <el-col :span="19">
                      <a-input
                        :maxLength="11"
                        v-model="newSupplus.name"
                        :placeholder="translateLang('common.inputPlaceholder')"
                        :class="inputAlert.nameInputAlert ? 'alert-input' : ''"
                        @input="inputCheck('name')"
                        @blur="inputCheck('name')"
                        id="supplus_storage_add_name_input"
                      >
                        <span class="plank-form-limit" slot="suffix"
                          >{{ newSupplus.name.length }}/10</span
                        >
                      </a-input>
                      <transition name="errorInfo">
                        <span
                          v-show="inputAlert.nameInputAlert"
                          class="error-info"
                          id="supplus_storage_add_name_input_error"
                          >{{ inputAlert.nameInputAlert }}</span
                        >
                      </transition>
                    </el-col>
                  </el-row>
                </div>
                <div class="plank-info-item">
                  <el-row>
                    <el-col :span="5">
                      <div style="float: right">
                        <span style="color: red">*</span>
                        <span style="line-height: 30px"
                          >{{ $t('common.plankHeight') }}：</span
                        >
                      </div>
                    </el-col>
                    <el-col :span="19">
                      <a-input
                        v-model="newSupplus.long"
                        :placeholder="translateLang('common.inputPlaceholder')"
                        :class="inputAlert.longInputAlert ? 'alert-input' : ''"
                        @input="inputCheck('long')"
                        @blur="inputCheck('long')"
                        id="supplus_storage_add_long_input"
                      >
                        <span slot="addonAfter" class="plank-form-after"
                          >mm</span
                        >
                      </a-input>
                      <transition name="errorInfo">
                        <span
                          v-show="inputAlert.longInputAlert"
                          class="error-info"
                          id="supplus_storage_add_long_input_error"
                          >{{ inputAlert.longInputAlert }}</span
                        >
                      </transition>
                    </el-col>
                  </el-row>
                </div>

                <div class="plank-info-item" v-if="selectedShape == 'L'">
                  <el-row>
                    <el-col :span="5">
                      <div style="float: right">
                        <span style="color: red">*</span>
                        <span style="line-height: 30px"
                          >{{ $t('common.shortLong') }}：</span
                        >
                      </div>
                    </el-col>
                    <el-col :span="19">
                      <a-input
                        v-model="newSupplus.min_long"
                        :placeholder="translateLang('common.inputPlaceholder')"
                        :class="
                          inputAlert.minLongInputAlert ? 'alert-input' : ''
                        "
                        @input="inputCheck('min_long')"
                        @blur="inputCheck('min_long')"
                        id="supplus_storage_add_min_long_input"
                      >
                        <span slot="addonAfter" class="plank-form-after"
                          >mm</span
                        >
                      </a-input>
                      <transition name="errorInfo">
                        <span
                          v-show="inputAlert.minLongInputAlert"
                          class="error-info"
                          id="supplus_storage_add_min_long_input_error"
                          >{{ inputAlert.minLongInputAlert }}</span
                        >
                      </transition>
                    </el-col>
                  </el-row>
                </div>

                <div class="plank-info-item">
                  <el-row style="margin-top: 20px">
                    <el-col :span="5">
                      <div style="float: right">
                        <span style="color: red">*</span>
                        <span style="line-height: 30px"
                          >{{ $t('common.plankWidth') }}：</span
                        >
                      </div>
                    </el-col>
                    <el-col :span="19">
                      <a-input
                        v-model="newSupplus.width"
                        :placeholder="translateLang('common.inputPlaceholder')"
                        :class="inputAlert.widthInputAlert ? 'alert-input' : ''"
                        @input="inputCheck('width')"
                        @blur="inputCheck('width')"
                        id="supplus_storage_add_width_input"
                      >
                        <span slot="addonAfter" class="plank-form-after"
                          >mm</span
                        >
                      </a-input>
                      <transition name="errorInfo">
                        <span
                          v-show="inputAlert.widthInputAlert"
                          class="error-info"
                          id="supplus_storage_add_width_input_error"
                          >{{ inputAlert.widthInputAlert }}</span
                        >
                      </transition>
                    </el-col>
                  </el-row>
                </div>
                <div class="plank-info-item" v-if="selectedShape == 'L'">
                  <el-row>
                    <el-col :span="5">
                      <div style="float: right">
                        <span style="color: red">*</span>
                        <span style="line-height: 30px"
                          >{{ $t('common.shortWidth') }}：</span
                        >
                      </div>
                    </el-col>
                    <el-col :span="19">
                      <a-input
                        v-model="newSupplus.min_width"
                        :placeholder="translateLang('common.inputPlaceholder')"
                        :class="
                          inputAlert.minWidthInputAlert ? 'alert-input' : ''
                        "
                        @input="inputCheck('min_width')"
                        @blur="inputCheck('min_width')"
                        id="supplus_storage_add_min_width_input"
                      >
                        <span slot="addonAfter" class="plank-form-after"
                          >mm</span
                        >
                      </a-input>
                      <transition name="errorInfo">
                        <span
                          v-show="inputAlert.minWidthInputAlert"
                          class="error-info"
                          id="supplus_storage_add_min_width_input_error"
                          >{{ inputAlert.minWidthInputAlert }}</span
                        >
                      </transition>
                    </el-col>
                  </el-row>
                </div>
                <!-- 厚度 -->
                <div class="plank-info-item">
                  <el-row>
                    <el-col :span="5">
                      <div style="float: right">
                        <span style="color: red">*</span>
                        <span style="line-height: 30px"
                          >{{ $t('common.plankThick') }}：</span
                        >
                      </div>
                    </el-col>
                    <el-col :span="19">
                      <a-input
                        v-model="newSupplus.thick"
                        :placeholder="translateLang('common.inputPlaceholder')"
                        :class="inputAlert.thickInputAlert ? 'alert-input' : ''"
                        @input="inputCheck('thick')"
                        @blur="inputCheck('thick')"
                        id="supplus_storage_add_thick_input"
                      >
                        <span slot="addonAfter" class="plank-form-after"
                          >mm</span
                        >
                      </a-input>
                      <transition name="errorInfo">
                        <span
                          v-show="inputAlert.thickInputAlert"
                          class="error-info"
                          id="supplus_storage_add_thick_input_error"
                          >{{ inputAlert.thickInputAlert }}</span
                        >
                      </transition>
                    </el-col>
                  </el-row>
                </div>
                <!-- 修边设置 -->
                <div class="plank-info-item" v-if="selectedShape !== 'L'">
                  <el-row class="flex flex-cross--center">
                    <el-col :span="5"
                      ><div style="float: right">
                        <span style="color: red">*</span>
                        <span style="line-height: 30px"
                          >{{ $translateLang('修边方式') }}：</span
                        >
                      </div></el-col
                    >
                    <el-col :span="19">
                      <a-radio-group
                        v-model="newSupplus.trimmingMethod"
                        class="flex"
                      >
                        <a-radio value="follow">
                          <g-t-view
                            :text="$translateLang('跟随原片中标准板材的修边值')"
                            width="220px"
                          ></g-t-view
                        ></a-radio>
                        <a-radio value="custom">{{
                          $translateLang('单独设置修边值')
                        }}</a-radio>
                      </a-radio-group>
                    </el-col>
                  </el-row>
                </div>
                <!-- 选择单独设置修边才展示 -->
                <div
                  class="plank-info-item"
                  v-if="newSupplus.trimmingMethod === 'custom'"
                >
                  <el-row>
                    <el-col :span="5">
                      <div style="float: right">
                        <span style="color: red">*</span>
                        <span style="line-height: 30px"
                          >{{ $translateLang('修边值') }}：</span
                        >
                      </div></el-col
                    >
                    <el-col :span="11">
                      <a-input
                        addon-after="mm"
                        :disabled="newSupplus.isCustomTrim"
                        @input="inputCheck('trimValue', $event)"
                        @blur="inputCheck('trimValue', $event)"
                        v-model="newSupplus.trimValue"
                        :class="
                          inputAlert.trimValueInputAlert ? 'alert-input' : ''
                        "
                      ></a-input>
                      <transition name="errorInfo">
                        <span
                          v-show="inputAlert.trimValueInputAlert"
                          class="error-info"
                          id="supplus_storage_add_thick_input_error"
                          >{{ inputAlert.trimValueInputAlert }}</span
                        >
                      </transition>
                    </el-col>
                    <el-col :span="8">
                      <a-checkbox
                        class="ml16"
                        style="line-height: 30px"
                        v-model="newSupplus.isCustomTrim"
                        >{{ $translateLang('自定义修边值') }}</a-checkbox
                      >
                    </el-col>
                  </el-row>
                </div>
                <div
                  v-if="
                    newSupplus.isCustomTrim &&
                    newSupplus.trimmingMethod === 'custom'
                  "
                >
                  <div class="plank-info-item">
                    <el-row>
                      <el-col :span="5">
                        <div style="float: right">
                          <span style="color: red">*</span>
                          <span style="line-height: 30px"
                            >{{ $translateLang('上修边') }}：</span
                          >
                        </div>
                      </el-col>
                      <el-col :span="19">
                        <a-input
                          addon-after="mm"
                          @input="inputCheck('topTrim', $event)"
                          @blur="inputCheck('topTrim', $event)"
                          v-model="newSupplus.topTrim"
                          :class="
                            inputAlert.topTrimInputAlert ? 'alert-input' : ''
                          "
                        ></a-input>
                        <transition name="errorInfo">
                          <span
                            v-show="inputAlert.topTrimInputAlert"
                            class="error-info"
                            id="supplus_storage_add_thick_input_error"
                            >{{ inputAlert.topTrimInputAlert }}</span
                          >
                        </transition>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="plank-info-item">
                    <el-row>
                      <el-col :span="5">
                        <div style="float: right">
                          <span style="color: red">*</span>
                          <span style="line-height: 30px"
                            >{{ $translateLang('下修边') }}：</span
                          >
                        </div>
                      </el-col>
                      <el-col :span="19">
                        <a-input
                          addon-after="mm"
                          @input="inputCheck('bottomTrim', $event)"
                          @blur="inputCheck('bottomTrim', $event)"
                          v-model="newSupplus.bottomTrim"
                          :class="
                            inputAlert.bottomTrimInputAlert ? 'alert-input' : ''
                          "
                        ></a-input>
                        <transition name="errorInfo">
                          <span
                            v-show="inputAlert.bottomTrimInputAlert"
                            class="error-info"
                            id="supplus_storage_add_thick_input_error"
                            >{{ inputAlert.bottomTrimInputAlert }}</span
                          >
                        </transition>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="plank-info-item">
                    <el-row>
                      <el-col :span="5">
                        <div style="float: right">
                          <span style="color: red">*</span>
                          <span style="line-height: 30px"
                            >{{ $translateLang('左修边') }}：</span
                          >
                        </div>
                      </el-col>
                      <el-col :span="19">
                        <a-input
                          addon-after="mm"
                          @input="inputCheck('leftTrim', $event)"
                          @blur="inputCheck('leftTrim', $event)"
                          v-model="newSupplus.leftTrim"
                          :class="
                            inputAlert.leftTrimInputAlert ? 'alert-input' : ''
                          "
                        ></a-input>
                        <transition name="errorInfo">
                          <span
                            v-show="inputAlert.leftTrimInputAlert"
                            class="error-info"
                            id="supplus_storage_add_thick_input_error"
                            >{{ inputAlert.leftTrimInputAlert }}</span
                          >
                        </transition>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="plank-info-item">
                    <el-row>
                      <el-col :span="5">
                        <div style="float: right">
                          <span style="color: red">*</span>
                          <span style="line-height: 30px"
                            >{{ $translateLang('右修边') }}：</span
                          >
                        </div>
                      </el-col>
                      <el-col :span="19">
                        <a-input
                          addon-after="mm"
                          @input="inputCheck('rightTrim', $event)"
                          @blur="inputCheck('rightTrim', $event)"
                          v-model="newSupplus.rightTrim"
                          :class="
                            inputAlert.rightTrimInputAlert ? 'alert-input' : ''
                          "
                        ></a-input>
                        <transition name="errorInfo">
                          <span
                            v-show="inputAlert.rightTrimInputAlert"
                            class="error-info"
                            id="supplus_storage_add_thick_input_error"
                            >{{ inputAlert.rightTrimInputAlert }}</span
                          >
                        </transition>
                      </el-col>
                    </el-row>
                  </div>
                  <m-trim-example
                    :isCustomTrim="newSupplus.isCustomTrim"
                  ></m-trim-example>
                </div>
                <!-- 材质 -->
                <div class="plank-info-item">
                  <el-row>
                    <el-col :span="5">
                      <div style="float: right">
                        <span style="color: red">*</span>
                        <span style="line-height: 30px"
                          >{{ $t('common.plankMatCode') }}：</span
                        >
                      </div>
                    </el-col>
                    <el-col :span="19">
                      <!-- <a-input
                        v-model="newSupplus.type"
                        v-if="isThinkerxMaterial"
                        @blur="inputCheck('type')"
                        @input="inputCheck('type')"
                        id="supplus_storage_add_type_input"
                        :class="inputAlert.typeInputAlert ? 'alert-input' : ''"
                      ></a-input> -->

                      <el-select
                        v-model="newSupplus.type"
                        :placeholder="translateLang('common.inputPlaceholder')"
                        filterable
                        clearable
                        size="medium"
                        show-search
                        option-filter-prop="children"
                        style="width: 318px; height: 32px"
                        :filter-option="filterOption"
                        :class="inputAlert.typeInputAlert ? 'alert-input' : ''"
                        @change="handleSelectMatCode"
                        @blur="inputCheck('type')"
                        @keydown.native.enter="handleEnterMatCode"
                        id="supplus_storage_add_type_select"
                        @visible-change="
                          (visibleEv) =>
                            colorOrTypeSelectEnter(visibleEv, 'type')
                        "
                        ref="type"
                      >
                        <el-option
                          v-for="(item, index) in matcodeList.filter(
                            (v) => v != '全部'
                          )"
                          :key="'type' + index"
                          :value="item"
                          :id="`supplus_storage_add_type_select_${index}`"
                          >{{ item }}</el-option
                        >
                      </el-select>
                      <transition name="errorInfo">
                        <span
                          v-show="inputAlert.typeInputAlert"
                          class="error-info"
                          id="supplus_storage_add_type_input_error"
                          >{{ inputAlert.typeInputAlert }}</span
                        >
                      </transition>
                      <div
                        class="newSideAdd"
                        @click="addNewMatcode"
                        id="supplus_storage_add_matcode_btn"
                        v-if="!isThinkerxMaterial"
                      >
                        <span>{{ $t('surplusPage.newMatcode') }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <!-- 颜色 -->
                <div class="plank-info-item">
                  <el-row>
                    <el-col :span="5">
                      <div class="title-box" style="float: right">
                        <span style="color: red">*</span>
                        <span style="line-height: 30px"
                          >{{ $t('common.plankColor') }}：</span
                        >
                      </div>
                    </el-col>
                    <el-col :span="19">
                      <!-- <a-input
                        v-model="newSupplus.color"
                        v-if="isThinkerxMaterial"
                        @blur="inputCheck('color')"
                        @input="inputCheck('color')"
                        id="supplus_storage_add_color_input"
                        :class="inputAlert.colorInputAlert ? 'alert-input' : ''"
                      ></a-input> -->

                      <el-cascader
                        v-loading="isLoadingColors"
                        id="supplus_material_color_input"
                        :class="{ 'error-border': inputAlert.colorInputAlert }"
                        size="small"
                        v-model="newPlankInfoTexture"
                        :options="materialColorOptions"
                        @change="handleSelectTexture"
                        @keydown.enter.native="handleEnterColor"
                        @keyup.delete.native="handleDeleteColorSearch"
                        @blur="inputCheck('color')"
                        :before-filter="onBeforeFilter"
                        :show-all-levels="false"
                        ref="addColorCascaderRef"
                        filterable
                        clearable
                        :placeholder="
                          translateLang('surplusPage.autoCreateColor')
                        "
                      />
                      <transition name="errorInfo">
                        <span
                          v-show="inputAlert.colorInputAlert"
                          class="error-info"
                          id="supplus_storage_add_color_input_error"
                          >{{ inputAlert.colorInputAlert }}</span
                        >
                      </transition>
                      <div
                        class="newSideAdd"
                        @click="addNewColor"
                        id="supplus_storage_add_color_btn"
                        v-if="!isThinkerxMaterial"
                      >
                        <span>{{ $t('surplusPage.newColor') }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <!-- 数量 -->
                <div class="plank-info-item">
                  <el-row>
                    <el-col :span="5">
                      <div style="float: right" class="mr7">
                        <span style="color: red">*</span>
                        <span style="line-height: 30px"
                          >{{ $t('common.count') }}：</span
                        >
                      </div>
                    </el-col>
                    <el-col :span="19">
                      <a-input
                        style="width: 404px"
                        v-model="newSupplus.amount"
                        :placeholder="translateLang('common.inputPlaceholder')"
                        :class="
                          inputAlert.amountInputAlert ? 'alert-input' : ''
                        "
                        @input="inputCheck('amount')"
                        @blur="inputCheck('amount')"
                        id="supplus_storage_add_amount_input"
                      ></a-input>
                      <transition name="errorInfo">
                        <span
                          v-show="inputAlert.amountInputAlert"
                          class="error-info"
                          id="supplus_storage_add_amount_input_error"
                          >{{ inputAlert.amountInputAlert }}</span
                        >
                      </transition>
                    </el-col>
                  </el-row>
                </div>
                <!-- 纹理 -->
                <div class="plank-info-item">
                  <el-row>
                    <el-col :span="5">
                      <div class="title-box align-right mr7">
                        <span style="color: red">*</span>
                        <span style="line-height: 30px"
                          >{{ $translateLang('纹理') }}：</span
                        >
                      </div>
                    </el-col>
                    <el-col :span="19">
                      <el-select
                        style="width: 404px"
                        v-model="newSupplus.texDir"
                        size="small"
                        :placeholder="$translateLang('请选择')"
                        id="supplus_storage_edit_gloss_select"
                      >
                        <el-option
                          v-for="(item, index) in [
                            {
                              value: 'normal',
                              label: $translateLang('竖纹'),
                            },
                            {
                              value: 'reverse',
                              label: $translateLang('横纹'),
                            },
                            {
                              value: 'notcare',
                              label: $translateLang('无纹理'),
                            },
                          ]"
                          :key="index"
                          :value="item.value"
                          :label="translateLang(item.label)"
                          :id="`supplus_storage_add_texDir_select_${index}`"
                        ></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </div>
                <!-- 高光板 -->
                <div class="plank-info-item">
                  <el-row>
                    <el-col :span="5">
                      <div class="title-box align-right mr7">
                        <span style="color: red">*</span>
                        <span style="line-height: 30px"
                          >{{ $t('common.heighGlossPlank') }}：</span
                        >
                      </div>
                    </el-col>
                    <el-col :span="19">
                      <el-select
                        style="width: 404px"
                        v-model="newSupplus.is_high_gloss_plank"
                        size="small"
                        :placeholder="translateLang('common.isHeightGloss')"
                        id="supplus_storage_add_gloss_select"
                      >
                        <el-option
                          v-for="(item, index) in [
                            {
                              value: 0,
                              label: `非${matchHighlightBoardName(
                                newSupplus.type
                              )}`,
                            },
                            {
                              value: 1,
                              label: matchHighlightBoardName(newSupplus.type),
                            },
                          ]"
                          :key="index"
                          :value="item.value"
                          :label="translateLang(item.label)"
                          :id="`supplus_storage_add_gloss_select_${index}`"
                        ></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </div>
                <!-- 高光面 -->
                <div class="plank-info-item">
                  <el-row>
                    <el-col :span="5">
                      <div class="title-box align-right mr7">
                        <span style="color: red">*</span>
                        <span style="line-height: 30px"
                          >{{ $translateLang('高光面') }}：</span
                        >
                      </div>
                    </el-col>
                    <el-col :span="19">
                      <el-select
                        style="width: 404px"
                        v-model="newSupplus.highlight_surface"
                        size="small"
                        :disabled="!newSupplus.is_high_gloss_plank"
                        :placeholder="$translateLang('请选择')"
                        id="supplus_storage_add_highlight_surface_select"
                      >
                        <el-option
                          v-for="(item, index) in [
                            {
                              value: 0,
                              label: $translateLang('无正反'),
                            },
                            {
                              value: 1,
                              label: $translateLang('正面'),
                            },
                            {
                              value: 2,
                              label: $translateLang('反面'),
                            },
                          ]"
                          :key="index"
                          :value="item.value"
                          :label="item.label"
                          :id="`supplus_storage_add_highlight_surface_select_${index}`"
                        ></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </div>
                <div class="plank-info-item">
                  <el-row>
                    <el-col :span="5">
                      <div style="float: right" class="mr7">
                        <span style="line-height: 30px">
                          <!-- 所在余料库 -->
                          {{ t('branchName') }}：
                        </span>
                      </div>
                    </el-col>
                    <el-col :span="19">
                      <el-select
                        style="width: 404px"
                        v-model="newSupplus.branch_no"
                        size="small"
                        placeholder="请选择所在余料库"
                        id="supplus_storage_add_branch_name_select"
                        clearable
                      >
                        <el-option
                          v-for="(item, index) in surplusStoreList"
                          :key="index"
                          :value="item.value"
                          :label="item.label"
                          :id="`supplus_storage_add_branch_name_select_${index}`"
                        ></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </div>
                <div class="plank-info-item" v-show="isSurplusLock">
                  <el-row>
                    <el-col :span="5">
                      <div style="float: right" class="mr7">
                        <span style="line-height: 30px">
                          <!-- 锁定状态 -->
                          {{ t('lockStatus') }}：
                        </span>
                      </div>
                    </el-col>
                    <el-col :span="19">
                      <el-select
                        style="width: 404px"
                        v-model="newSupplus.lock_status"
                        size="small"
                        placeholder="请选择锁定状态"
                        id="supplus_storage_add_lock_state_select"
                        clearable
                      >
                        <el-option
                          v-for="(item, index) in lockStateList"
                          :key="index"
                          :value="item.value"
                          :label="item.label"
                          :id="`supplus_storage_add_lock_state_select_${index}`"
                        ></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </div>
                <div class="plank-info-item remark-form">
                  <el-row>
                    <el-col :span="5">
                      <div style="float: right" class="mr7">
                        <span style="line-height: 30px"
                          >{{ $t('materialPage.surplusHead.remark') }}：</span
                        >
                      </div>
                    </el-col>
                    <el-col :span="19" style="margin-top: 10px">
                      <div class="remark-input">
                        <a-textarea
                          style="height: 88px; resize: none"
                          v-model="newSupplus.remark"
                          @input="inputCheck('remark')"
                          @blur="inputCheck('remark')"
                          id="supplus_storage_add_remark_textarea"
                        ></a-textarea>
                        <span class="remark-limit"
                          >{{ newSupplus.remark.length }}/50</span
                        >
                      </div>
                      <transition name="errorInfo">
                        <span
                          v-show="inputAlert.remarkInputAlert"
                          class="error-info remark-info"
                          id="supplus_storage_add_remark_textarea_error"
                          >{{ inputAlert.remarkInputAlert }}</span
                        >
                      </transition>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="padding-bottom: 30px; text-align: center">
          <div>
            <a-button
              id="supplus_storage_add_cancel_btn"
              @click="addSupplusDrawer = false"
              style="width: 120px"
              >{{ $t('common.cancel') }}</a-button
            >
            <a-button
              @click="saveNewSupplus"
              style="
                width: 120px;
                margin-right: 8px;
                color: #fff;
                background: #18a8c7;
              "
              id="supplus_storage_add_save_btn"
              >{{ $t('common.save') }}</a-button
            >
          </div>
        </div>
      </div>
    </el-drawer>
    <g-base-modal
      :visible="isShowDeleteDialog"
      v-if="isShowDeleteDialog"
      @ok="confirmDeleteSupplus"
      @cancel="isShowDeleteDialog = false"
      :contain="
        isShowRecycleBin
          ? translateLang('materialPage.deleteConfirm')
          : translateLang('common.deleteTip')
      "
      :ok-text="translateLang('materialPage.delete.confirm')"
    >
    </g-base-modal>
    <g-base-modal
      :visible="isShowCopyDialog"
      v-if="isShowCopyDialog"
      @ok="handleConfirmCopy"
      @cancel="isShowCopyDialog = false"
      :contain="$translateLang('即将对选中余料进行复制操作')"
      :is-loading="isCopyLoading"
      :ok-text="$translateLang('确认')"
      :disabledOkBtn="!Number(copySetting.copyNum)"
    >
      <div>
        <span>{{ $translateLang('请确认需要复制的数量') }}：</span>
        <a-input
          class="inline-block"
          style="width: 100px"
          v-model="copySetting.copyNum"
          :placeholder="$translateLang('请输入1-99的数字')"
          @input="handleLimitInput"
        ></a-input>
      </div>
    </g-base-modal>
    <!-- 余料转移弹窗 -->
    <g-base-modal
      :visible="showTransSurplus"
      v-if="showTransSurplus"
      :showIcon="false"
      :title="translateLang('surplusPage.surplusTransfer')"
      :ok-text="translateLang('common.confirm')"
      @cancel="showTransSurplus = false"
      @ok="handleTransSurplus"
    >
      <div class="flex flex-main--center flex-cross--center">
        <!-- 目标余料库 -->
        <g-t-view
          :text="$t('surplusPage.targetSurplusStore')"
          width="130px"
        ></g-t-view>
        <div class="flex-box--3">
          <a-select
            v-model="selectedSurplusStore"
            show-search
            style="width: 313px"
            optionFilterProp="label"
            id="surplus_storage_add_target_surplus_store_select"
          >
            <a-select-option
              v-for="item in surplusStoreList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
              :id="`surplus_storage_add_target_surplus_store_select_${item.value}`"
              >{{ item.label }}</a-select-option
            >
          </a-select>
        </div>
      </div>
    </g-base-modal>
    <!-- 关闭锁定提示弹窗 -->
    <g-base-modal
      :visible="isShowCloseLock"
      v-if="isShowCloseLock"
      @ok="confirmCloseLock"
      @cancel="isShowCloseLock = false"
      :ok-text="translateLang('surplusPage.confirm')"
      :contain="translateLang('surplusPage.isCloseSurplusLock') + '？'"
    >
    </g-base-modal>
    <!-- 导入余料清单确实的表头信息 -->
    <g-table-dialog
      @confirm="handleClearMissingData"
      @cancel="handleClearMissingData"
      :lackTableString="lackTableString"
      :necessaryTableLackString="{}"
      :prefix-text="'导入数据失败，'"
      :isShowLackNeedTableHeader="true"
      :isShowLackNeedTableHeaderData="false"
      v-if="showTableDialog"
    ></g-table-dialog>
    <!-- 余料默认修边值弹窗 -->
    <m-surplus-trim-setting
      :isVisible.sync="isVisible"
      :formData="surplus_trim_data"
      @saveDefaultSurplusTrimData="saveDefaultSurplusTrimData"
    ></m-surplus-trim-setting>
    <!-- 余料入库码 -->
    <surplus-material-storage-code
      :isShowQRcode="isShowQRCodeModal"
      @close="isShowQRCodeModal = false"
    />
  </div>
</template>

<script>
import { buryPoint } from '@/apis/common/buryPoint'
import {
  createSurplus,
  surplusLock,
  surplusTransfer,
} from '@/apis/surplusManage/index.ts'
import { checkUserPermissionWithToast } from '@/auth/user_function'
import GBaseModal from '@/components/g-base-modal.vue'
import GCopyLine from '@/components/g-copy-line'
import GPaidFeature from '@/components/g-paid-feature.vue'
import GTableDialog from '@/components/g-table-dialog.vue'
import newContent from '@/components/newContent.vue'
import GTView from '@/components/translateComp/g-t-view.vue'
import {
  formatSurplusTrimDisplay,
  getSurplusImportTemplateData,
  isValidSurplusTrimValue,
  parseSurplusTrimImport,
  sanitizeSurplusTrimValueInput,
} from '@/constants/surplusTemplate'
import { USER_PERMISSION_KEY } from '@/data/auth'
import { updateLocalPreference } from '@/store/modules/preferencesSetting'
import { buryPointFunc } from '@/util/buryPointDeal'
import { EventBusKey } from '@/util/bus'
import EventBus from '@/util/bus'
import {
  checkColorIsExist,
  checkMatCodeIsExist,
  matchHighlightBoardName,
  restoreOriginalMatcode,
  translate,
} from '@/util/commonFun'
import { operateRecordTableType } from '@/util/configure'
import { dealExcelManifest, downloadCsvFile } from '@/util/plankCommonFuncs'
import { regReplaceSupplusStorageDealDecimal } from '@/util/regReplace'
import { message } from 'ant-design-vue'
import { mapMutations, mapState } from 'vuex'
import XLSX from 'xlsx'

import drawSupplus from '../../components/draw/drawSupplus.vue'
import {
  buryPointApi,
  dealLshapeSurplusFromSize,
  genFinalRecord,
  toDecimal,
  uniquePlankNum,
  verifyInputNumber,
} from '../../util/commonFuncs'
import MSurplusTrimSetting from './components/m-surplus-trim-setting.vue'
import MTrimExample from './components/m-trim-example.vue'
import SurplusMaterialStorageCode from './components/surplusMaterialStorageCode.vue'
import {
  isSecondConfirmCompareMsg,
  isSecondConfirmCompareTextMap,
  isSecondConfirmCompareValueMap,
  surplusNoRollCompareMsg,
  surplusNoRollCompareTextMap,
  surplusNoRollCompareValueMap,
  surplusTrimCompareMsg,
  surplusTrimCompareTextMap,
  surplusTrimCompareValueMap,
} from './config/compareConfig'
import {
  surplusKeyMap,
  surplusTableHeaderMappingList,
} from './config/sampHeaderConfig'
import surplusStore from './surplusStore.vue'
import { calculateSurplusArea } from './utils/dealPlank'
import { checkSurplusCsvData, dealCsvOrderInfo } from './utils/importFile'

const OPTIONS = ['Apples', 'Nails', 'Bananas', 'Helicopters']

//余料形状映射表
const shapleMap = {
  0: '矩形',
  1: 'L形',
  2: '异形',
}

export default {
  components: {
    drawSupplus,
    GCopyLine,
    GPaidFeature,
    newContent,
    GBaseModal,
    surplusStore,
    GTView,
    GTableDialog,
    MSurplusTrimSetting,
    MTrimExample,
    SurplusMaterialStorageCode,
  },
  data() {
    return {
      USER_PERMISSION_KEY,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      activeKey: '余料清单',
      selectedItems: [],
      addSupplusDrawer: false,
      // 记录绘制点位
      drawObj: {
        width: 172,
        long: 257,
        min_width: 0,
        min_long: 0,
      },
      // 记录绘制的缩放比例
      drawScale: 1,
      // 记录余料库列表
      supplusList: [],
      // 记录当前页码
      page: 1,
      // 记录输入的跳转页码
      jumpPage: '',
      // 记录当前一页显示条数
      pageSize: 10,
      // 记录可切换的pageSize
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      // 记录总条数
      totalSupplus: 1,
      // 记录所有的板材类型的分类
      matcodeList: [],
      // 记录选中的板材类型
      activeMatcode: '全部',
      // 记录是矩形还是L形
      activeShape: '全部',
      // 记录所有板材厚度的分类
      thickList: [],
      // 记录选中的板材厚度
      activeThick: '全部',
      // 记录选中的板材纹理
      activeTexDir: '全部',
      // 判断是否存在筛选
      isFilterStatus: false,
      // 记录所有的板材颜色
      colorList: [],
      // 记录输入的搜索关键词
      keyWord: '',
      // 是否全选板件
      isSelectAll: false,
      // 记录余料表格的列
      supplusColumn: [
        {
          dataIndex: 'select',
          key: 'select',
          width: 60,
          fixed: 'left',
          scopedSlots: { customRender: 'select' },
          slots: { title: 'selectTitle' },
        },
        {
          dataIndex: 'name',
          key: 'name',
          title: '余料名称',
          width: 100,
          fixed: 'left',
          ellipsis: true,
          translateKey: 'surplusPage.surplusName',
        },
        {
          dataIndex: 'plankNum',
          key: 'plankNum',
          title: '余料条码',
          width: 120,
          fixed: 'left',
          ellipsis: true,
          translateKey: 'common.surplusNum',
        },
        {
          dataIndex: 'from_address',
          key: 'from_address',
          title: '来源订单地址',
          width: 150,
          ellipsis: true,
          translateKey: 'surplusPage.orderAddress',
        },
        {
          dataIndex: 'from_order_num',
          key: 'from_order_num',
          title: '来源订单号',
          width: 150,
          ellipsis: true,
          translateKey: 'surplusPage.orderId',
        },
        {
          dataIndex: 'surplusType',
          key: 'surplusType',
          title: '板材形状',
          width: 80,
          ellipsis: true,
          scopedSlots: { customRender: 'surplusType' },
          translateKey: 'common.plankShape',
        },
        {
          dataIndex: 'type',
          key: 'type',
          title: '板材材质',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'type' },
          translateKey: 'common.plankMatCode',
        },
        {
          dataIndex: 'color',
          key: 'color',
          title: '板材颜色',
          width: 80,
          ellipsis: true,
          translateKey: 'common.plankColor',
        },
        {
          dataIndex: 'thick',
          key: 'thick',
          title: '厚度(mm)',
          width: 80,
          ellipsis: true,
          translateKey: 'common.thick',
        },
        {
          dataIndex: 'long',
          key: 'long',
          title: '长度(mm)',
          width: 80,
          ellipsis: true,
          translateKey: 'common.long',
        },
        {
          dataIndex: 'min_long',
          key: 'min_long',
          title: '短边长度(mm)',
          width: 120,
          ellipsis: true,
          translateKey: 'common.shortLong',
        },
        {
          dataIndex: 'width',
          key: 'width',
          title: '宽度(mm)',
          width: 80,
          ellipsis: true,
          translateKey: 'common.width',
        },
        {
          dataIndex: 'min_width',
          key: 'min_width',
          title: '短边宽度(mm)',
          width: 120,
          ellipsis: true,
          translateKey: 'common.shortWidth',
        },
        {
          dataIndex: 'texDir',
          key: 'texDir',
          title: '纹理',
          width: 80,
          ellipsis: true,
          scopedSlots: { customRender: 'texDir' },
          translateKey: 'common.texture',
        },
        {
          dataIndex: 'area',
          key: 'area',
          title: '面积(m²)',
          width: 80,
          ellipsis: true,
          translateKey: 'materialPage.surplusHead.area',
        },
        {
          dataIndex: 'surplus_trim_edge',
          key: 'surplus_trim_edge',
          // title: '修边1', // 这个会覆盖slots里面自定义的title
          width: 100,
          ellipsis: true,
          // translateKey: 'cuttingDock.sawEngraving.trim',
          scopedSlots: { customRender: 'surplus_trim_edge' },
          slots: { title: 'surplusTrimEdgeTitle' },
        },
        {
          dataIndex: 'amount',
          key: 'amount',
          title: '数量',
          width: 60,
          ellipsis: true,
          translateKey: 'common.count',
        },
        {
          dataIndex: 'is_high_gloss_plank',
          key: 'is_high_gloss_plank',
          title: '高光板',
          width: 110,
          scopedSlots: { customRender: 'is_high_gloss_plank' },
          ellipsis: true,
          translateKey: 'common.heighGlossPlank',
        },
        {
          dataIndex: 'highlight_surface',
          key: 'highlight_surface',
          title: '高光面',
          width: 110,
          scopedSlots: { customRender: 'highlight_surface' },
          ellipsis: true,
          translateKey: 'common.heighGlossSide',
        },
        {
          dataIndex: 'create_time',
          key: 'create_time',
          title: '添加时间',
          width: 100,
          ellipsis: true,
          translateKey: 'surplusPage.createTime',
        },
        {
          dataIndex: 'branch_name',
          key: 'branch_name',
          title: '所在余料库',
          width: 90,
          ellipsis: true,
          scopedSlots: { customRender: 'branch_name' },
          translateKey: 'materialPage.branchName',
        },
        {
          dataIndex: 'remark',
          key: 'remark',
          title: '备注',
          width: 100,
          ellipsis: true,
          translateKey: 'materialPage.surplusHead.remark',
        },
        {
          dataIndex: 'operation',
          key: 'operation',
          title: '操作',
          fixed: 'right',
          width: 140,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          translateKey: 'common.operation',
        },
      ],
      // 记录是否显示添加余料
      showAddNewSupplus: false,
      // 记录添加余料时选择的余料形状, 默认为矩形
      selectedShape: 'rect',
      // 记录新加余料的信息
      newSupplus: {
        name: '',
        long: '',
        min_long: '',
        width: '',
        min_width: '',
        thick: '',
        trimmingMethod: 'follow',
        isCustomTrim: false,
        trimValue: '',
        topTrim: '',
        bottomTrim: '',
        leftTrim: '',
        rightTrim: '',
        type: '',
        color: '',
        amount: '1',
        remark: '',
        is_high_gloss_plank: 0,
        highlight_surface: 0,
      },
      // 下一张余料名称
      nextSurplusName: '',
      // 显示板件颜色下拉框
      showColorMenu: false,
      // 显示板件材质下拉框
      showTypeMenu: false,
      // 显示板件厚度下拉框
      showThickMenu: false,
      // 记录是否需要显示所有子项
      showAllItem: true,
      // 记录选择的子项
      selectedItem: '',
      // 记录各种输入警示
      inputAlert: {
        nameInputAlert: '', // 名称
        longInputAlert: '', // 板材长度
        minLongInputAlert: '', // 板材短边长度
        widthInputAlert: '', // 板材宽度
        minWidthInputAlert: '', // 板材短边宽度
        thickInputAlert: '', // 厚度
        trimValueInputAlert: '', // 修边值
        topTrimInputAlert: '', // 上修边
        bottomTrimInputAlert: '', // 下修边
        leftTrimInputAlert: '', // 左修边
        rightTrimInputAlert: '', // 右修边
        typeInputAlert: '', // 材质
        colorInputAlert: '', // 颜色
        amountInputAlert: '', // 数量
        remarkInputAlert: '', //备注
        orderAddressInputAlert: '', //备注
        orderIdInputAlert: '', //备注
      },
      // 显示删除确认弹框
      isShowDeleteDialog: false,
      // 显示复制确认弹框
      isShowCopyDialog: false,
      // 复制条数
      copySetting: {
        copyNum: 1,
      },
      // 复制的余料数据
      copySurplus: null,
      // 记录要删除的余料id
      deleteIds: [],
      // 记录要删除的余料ggid
      deleteGgids: [],
      // 是否显示新建分类的弹窗
      isShowNewClassify: false,
      // 记录当前正在进行哪一个分类的新建
      newClassifyType: 'matcode',
      // 记录输入的新建分类
      newClassify: '',
      // 显示编辑抽屉
      showEditDrawer: false,
      // 记录当前编辑的余料
      currentSurplus: {},
      // 记录选择的搜索类型
      searchType: 'name',
      // 记录是否显示加载
      showLoading: false,
      // 复制按钮是否加载中
      isCopyLoading: false,
      // 是否为第三方跳转过来
      isThinkerxMaterial: false,
      // 当前点击余料
      currentClickSurplus: {},
      //记录是否少翻版
      isLessReserve: false,
      preferencesSetting: [],
      newPlankInfoTexture: '',
      materialColorOptions: [],
      colorSearchKey: '',
      newSlabColor: '',
      showTransSurplus: false,
      selectedSurplusStore: '',
      // 记录所有的余料库分类
      surplusStoreList: [],
      // 记录选中的余料库
      activeSurplusStore: '全部',
      selectedSurplusList: [],
      // 存储所有选中的数据（全选所有时使用）
      allSelectedSurplusList: [],
      // 标记是否已全选所有数据
      isSelectAllSurplus: false,
      activeColor: '全部',
      allColorList: [],
      activeTime: '',
      allMatcodeList: [],
      allThickList: [],
      allTexDirList: [
        { label: '竖纹', value: 'normal' },
        { label: '横纹', value: 'reverse' },
        { label: '无纹理', value: 'notcare' },
      ],
      specialUserIds: [11402, 181028, 483317], // 用户id，第一个是客户正式服的
      // 是否启用余料锁定
      isSurplusLock: false,
      activeLockState: '全部',
      lockStateList: [
        { label: '已锁定', value: 1 },
        { label: '未锁定', value: 0 },
      ],
      // 关闭锁定弹窗显示
      isShowCloseLock: false,
      showBatchLockPop: false,
      // 是否展示余料锁定new标识
      isShowSurLockNew: null,
      // 是否启用余料入库二次确认
      isSecondConfirm: true,
      isSecondConfirmNew: null,
      oriIsSecondConfirm: true,
      // 导入文件的 ref
      inputFileRef: null,
      // 用于展示导入余料清单确实的的表头信息
      showTableDialog: false,
      lackTableString: '',
      // 用于显示余料批量导入导出的显示
      isShowPopover: false,
      selectedRowKeys: [],
      // 全选类型列表（用于复选框组，但只允许选中一个）
      selectAllTypeList: [],
      // 存储每一页的选中状态（key为页码，value为该页选中的id数组）
      pageSelectedKeysMap: {},
      // 上一个页码，用于在切换页面时保存旧页面的选中状态
      prevPage: 1,
      isVisible: false, // 控制余料默认修边值弹窗是否展示
      isPopoverVisible: false, // 点击更多弹窗
      oriSurplusTrimData: null,
      surplus_trim_data: {
        trimmingMethod: 'follow', // 默认选中跟随原片中标准板材的修边值
        trimValue: '', // 修边值
        isCustomTrim: false, // 是否是自定义修边
        topTrim: '', // 上修边
        bottomTrim: '', // 下修边
        leftTrim: '', // 左修边
        rightTrim: '', // 右修边
      },
      isShowQRCodeModal: false,
      oriSurplusNoRoll: false,
    }
  },
  computed: {
    ...mapState([
      'isLoadingColors',
      'userInfo',
      'materialColorList',
      'supplusStorageColorList',
      'supplusStorageMatCode',
    ]),
    notAbleDelete() {
      let flag = this.supplusList.some((v) => v.isSelected)
      if (flag) {
        return false
      } else {
        return true
      }
    },
    // 是否是定制用户
    isCustomUser() {
      return this.specialUserIds.includes(this.userInfo?.id)
    },
    isShowRecycleBin() {
      return this.$store.state.userPermissions['surplus_recycle_bin']
    },
    storePreferencesSetting() {
      return this.$store.state.preferencesSetting?.setting
    },
    // 计算表头复选框的模糊选中状态
    isIndeterminate() {
      // 如果有选中的项，但不是全部选中，则显示模糊选中状态
      const hasSelected = this.selectedRowKeys.length > 0
      const allSelected =
        this.supplusList.length > 0 &&
        this.supplusList.every((item) => this.selectedRowKeys.includes(item.id))
      return hasSelected && !allSelected && !this.isSelectAll
    },
  },
  methods: {
    ...mapMutations([
      'setSurplusNoRoll',
      'setSupplusStorageColorList',
      'setSupplusStorageMatCode',
    ]),
    handleLimitInput() {
      verifyInputNumber(
        this.copySetting.copyNum,
        this.copySetting,
        ['copyNum'],
        '2',
        false,
        1,
        false,
        99
      )
    },
    handleGoDetail(surplus) {
      this.activeKey = '余料清单'
      this.activeSurplusStore = surplus.branch_no
      this.getSupplusList()
    },
    translateLang(key) {
      return translate(key)
    },
    /** 余料库部分翻译函数 */
    t(k) {
      return translate('surplusPage.' + k)
    },
    /** 公共部分翻译函数 */
    ct(k, val) {
      return translate('common.' + k, val)
    },
    handleChange(e) {
      let timer = null
      if (!e.target.value) {
        if (timer !== null) {
          clearTimeout(timer)
        }
        timer = setTimeout(() => {
          this.page = 1 //time用来控制事件的触发
          this.getSupplusList()
        }, 500)
      }
    },
    // 重置筛选条件
    resetClassify() {
      buryPointApi('supplus_storage', 'reset')
      this.page = 1
      this.activeThick = '全部'
      this.activeShape = '全部'
      this.activeMatcode = '全部'
      this.activeTexDir = '全部'
      this.keyWord = ''
      this.activeSurplusStore = '全部'
      this.activeColor = '全部'
      this.activeTime = ''
      this.activeLockState = '全部'
      // 清除所有选中状态
      this.isSelectAllSurplus = false
      this.allSelectedSurplusList = []
      this.selectedRowKeys = []
      this.selectedSurplusList = []
      this.selectAllTypeList = []
      this.pageSelectedKeysMap = {}
      this.getSupplusList()
    },
    // 显示余料绘制
    showSupplusShape(visible, supplus) {
      if (visible) {
        if (supplus.long > 257 || supplus.width > 172) {
          let scaleY = supplus.long / 257
          let scaleX = supplus.width / 172
          if (scaleX >= scaleY) {
            this.drawScale = scaleX
          } else {
            this.drawScale = scaleY
          }
        }
        this.drawObj = {
          long: Number(supplus.long),
          width: Number(supplus.width),
          min_long: supplus.min_long == '' ? 0 : Number(supplus.min_long),
          min_width: supplus.min_width == '' ? 0 : Number(supplus.min_width),
          path: supplus.path,
        }
      }
    },
    // 处理全选类型选择变化
    handleSelectAllTypeChange(checkedValues) {
      // 勾选所有时，当前页也应该被勾选
      if (
        checkedValues.includes('all') &&
        !checkedValues.includes('port') &&
        !this.isSelectAllSurplus
      ) {
        checkedValues.push('port')
      }
      this.selectAllTypeList = [...checkedValues]

      const hasAll = checkedValues.includes('all')
      const hasPort = checkedValues.includes('port')
      const isEmpty = checkedValues.length === 0

      if (hasAll) {
        if (!this.isSelectAllSurplus) {
          // 首次全选所有
          this.switchSelectAllType('all')
        } else {
          // 在全选所有模式下，切换当前页的选中状态
          this.updateCurrentPageInSelectAllMode(hasPort)
        }
        return
      }

      if (hasPort) {
        if (this.isSelectAllSurplus) {
          // 从全选所有模式切换到当前页全选
          this.isSelectAllSurplus = false
          this.allSelectedSurplusList = []
          this.selectAllCurrentPage()
        } else {
          // 执行当前页全选
          this.switchSelectAllType('port')
        }
        return
      }

      if (isEmpty) {
        if (this.isSelectAllSurplus) {
          // 取消全选所有
          this.clearAllSelection(true)
        } else {
          // 取消当前页选中或部分选中
          this.clearCurrentPageSelection()
        }
        return
      }

      // 如果之前是全选所有模式，但当前没有选中任何项，清除所有选中状态
      if (this.isSelectAllSurplus) {
        this.clearAllSelection(true)
      }
    },
    handleChangeTotalPage() {
      this.selectAllTypeList = []
      this.isSelectAllSurplus = false
    },
    // 全选当前页
    selectAllCurrentPage() {
      const currentPageKeys = this.supplusList.map((item) => item.id)

      // 更新选中状态
      this.selectedRowKeys = currentPageKeys
      this.pageSelectedKeysMap[this.page] = [...currentPageKeys]
      this.supplusList.forEach((item) => {
        item.isSelected = true
      })

      // 更新选中列表：保留其他页的选中数据，更新当前页的数据
      this.selectedSurplusList = this.selectedSurplusList.filter(
        (item) => !currentPageKeys.includes(item.id)
      )
      this.selectedSurplusList = [
        ...this.selectedSurplusList,
        ...this.supplusList,
      ]

      // 更新状态
      this.isSelectAll = true
      this.selectAllTypeList = this.isSelectAllSurplus
        ? ['port', 'all']
        : ['port']
      this.$forceUpdate()
    },
    // 取消当前页全选（保留全选所有状态）
    cancelSelectAllCurrentPage() {
      this.selectedRowKeys = []
      this.supplusList.forEach((item) => {
        item.isSelected = false
      })
      this.selectedSurplusList = []
      this.isSelectAll = false
      this.selectAllTypeList = this.isSelectAllSurplus ? ['all'] : []
      this.$forceUpdate()
    },
    // 切换全选类型
    switchSelectAllType(newType) {
      if (newType === 'all') {
        // 全选所有
        if (this.isSelectAllSurplus) {
          // 如果已经是全选所有，则取消
          this.clearAllSelection(true)
          return
        }
        // 设置全选所有状态
        this.isSelectAllSurplus = true
        this.showLoading = true
        this.selectAllTypeList = ['port', 'all']
        // 清除之前的全选数据，避免使用旧数据
        this.allSelectedSurplusList = []
        this.selectedRowKeys = []
        this.selectedSurplusList = []
        // 获取所有数据，确保使用最新的 totalSupplus
        // 如果 totalSupplus 为 0 或未定义，使用一个较大的值确保能获取所有数据
        const limit = this.totalSupplus > 0 ? this.totalSupplus : 10000
        this.getSupplusList(1, false, limit, true)
      } else if (newType === 'port') {
        // 全选当前页
        if (this.isSelectAll) {
          // 如果当前已经是当前页全选，则取消当前页全选
          this.cancelSelectAllCurrentPage()
          return
        }
        // 执行当前页的全选
        this.selectAllCurrentPage()
      }
    },
    // 清除当前页选中状态
    clearCurrentPageSelection() {
      this.selectedRowKeys = []
      this.supplusList.forEach((item) => {
        item.isSelected = false
      })
      this.selectedSurplusList = []
      this.selectAllTypeList = []
      this.isSelectAll = false
      delete this.pageSelectedKeysMap[this.page]
      this.$forceUpdate()
    },
    // 清除所有选中状态（包括全选所有）
    clearAllSelection(needReload = false) {
      this.isSelectAllSurplus = false
      this.allSelectedSurplusList = []
      this.pageSelectedKeysMap = {}
      this.selectedRowKeys = []
      this.selectedSurplusList = []
      this.isSelectAll = false
      this.selectAllTypeList = []
      if (needReload) {
        this.getSupplusList(this.page)
      }
    },
    // 根据当前状态设置默认全选类型
    getDefaultSelectAllType() {
      if (this.isSelectAllSurplus) {
        return ['port', 'all']
      }
      // 当前页全选或部分选中时，默认选择当前页
      return ['port']
    },
    // 在全选所有模式下，更新当前页的选中状态
    updateCurrentPageInSelectAllMode(shouldSelect) {
      const currentPageKeys = this.supplusList.map((item) => item.id)

      if (shouldSelect) {
        // 确保当前页的所有项都被选中
        currentPageKeys.forEach((id) => {
          if (!this.selectedRowKeys.includes(id)) {
            this.selectedRowKeys.push(id)
          }
        })
        this.isSelectAll = true
        this.selectAllTypeList = ['port', 'all']
      } else {
        // 取消当前页的选中状态
        currentPageKeys.forEach((id) => {
          const index = this.selectedRowKeys.indexOf(id)
          if (index > -1) {
            this.selectedRowKeys.splice(index, 1)
          }
        })
        this.isSelectAll = false
        this.selectAllTypeList = ['all']
      }

      // 更新 allSelectedSurplusList 中当前页项的选中状态
      this.allSelectedSurplusList.forEach((item) => {
        item.isSelected = currentPageKeys.includes(item.id)
          ? shouldSelect
          : item.isSelected
      })

      // 更新当前页显示的数据的选中状态
      this.supplusList.forEach((item) => {
        item.isSelected = shouldSelect
      })

      // 更新选中列表
      this.selectedSurplusList = this.allSelectedSurplusList.filter((item) =>
        this.selectedRowKeys.includes(item.id)
      )

      this.$forceUpdate()
    },
    // 处理表头复选框变化
    handleHeaderCheckboxChange(e) {
      const checked = e.target.checked
      if (checked) {
        // 如果复选框被选中，根据当前状态设置默认选中项
        this.selectAllTypeList = this.getDefaultSelectAllType()
      } else {
        // 如果取消选中，根据当前类型执行取消操作
        if (this.isSelectAllSurplus) {
          // 取消全选所有，需要重新加载数据
          this.clearAllSelection(true)
        } else {
          // 取消全选当前页或部分选中状态
          this.clearCurrentPageSelection()
        }
      }
    },
    // 选中单个余料
    selectedSurplus(item) {
      // 如果已全选所有，取消全选所有状态
      if (this.isSelectAllSurplus && !item.isSelected) {
        this.isSelectAllSurplus = false
        this.allSelectedSurplusList = []
        this.selectAllTypeList = []
        this.pageSelectedKeysMap = {}
      }

      // 更新 selectedRowKeys
      if (item.isSelected) {
        if (!this.selectedRowKeys.includes(item.id)) {
          this.selectedRowKeys.push(item.id)
        }
      } else {
        const index = this.selectedRowKeys.indexOf(item.id)
        if (index > -1) {
          this.selectedRowKeys.splice(index, 1)
        }
      }

      // 更新全选状态
      this.isSelectAll =
        this.supplusList.length > 0 &&
        this.supplusList.every((item) => this.selectedRowKeys.includes(item.id))

      // 更新选中列表
      if (this.isSelectAllSurplus) {
        this.selectedSurplusList = this.allSelectedSurplusList.filter((i) =>
          this.selectedRowKeys.includes(i.id)
        )
        // 同步更新 selectedSurplusList 中项的 isSelected 状态
        this.selectedSurplusList.forEach((item) => {
          item.isSelected = this.selectedRowKeys.includes(item.id)
        })
      } else {
        const currentPageIds = this.supplusList.map((i) => i.id)
        const currentPageSelectedIds = this.supplusList
          .filter((i) => this.selectedRowKeys.includes(i.id))
          .map((i) => i.id)

        // 更新 selectedSurplusList 中属于当前页的项的 isSelected 状态
        this.selectedSurplusList.forEach((item) => {
          if (currentPageIds.includes(item.id)) {
            item.isSelected = currentPageSelectedIds.includes(item.id)
          }
        })

        // 移除之前 selectedSurplusList 中属于当前页的数据
        this.selectedSurplusList = this.selectedSurplusList.filter(
          (i) =>
            !currentPageIds.includes(i.id) ||
            currentPageSelectedIds.includes(i.id)
        )

        // 添加当前页新选中的数据（如果不在 selectedSurplusList 中）
        const existingIds = this.selectedSurplusList.map((i) => i.id)
        const currentPageSelected = this.supplusList.filter(
          (i) =>
            this.selectedRowKeys.includes(i.id) && !existingIds.includes(i.id)
        )
        this.selectedSurplusList = [
          ...this.selectedSurplusList,
          ...currentPageSelected,
        ]
        // 如果是当前页模式，更新当前页的选中状态映射
        if (this.selectAllTypeList.includes('port')) {
          this.pageSelectedKeysMap[this.page] = [...this.selectedRowKeys]
        }
      }

      // 如果取消选中导致没有选中项，清除复选框组状态
      if (this.selectedRowKeys.length === 0) {
        this.selectAllTypeList = []
        // 清除当前页的选中状态映射
        delete this.pageSelectedKeysMap[this.page]
      }
    },
    // 是否显示tooltip
    showTootip(value, surplus, prop) {
      let dom = this.$refs[`surplus_${surplus.id}_${prop}`][0]
      if (dom) {
        if (dom.offsetWidth < dom.scrollWidth) {
          this.$set(surplus, `show${prop}`, true)
        } else {
          this.$set(surplus, `show${prop}`, false)
        }
        if (!value) {
          surplus[`show${prop}`] = false
        }
      }
    },
    // 切换每页显示条数
    onShowSizeChange(val, pageSize) {
      this.pageSize = pageSize
      let currentPage
      if (this.page > Math.ceil(this.totalSupplus / pageSize)) {
        currentPage = Math.ceil(this.totalSupplus / pageSize)
      } else {
        currentPage = this.page
      }
      this.getSupplusList(currentPage)
    },
    // 切换页码
    changeCurrentPage() {
      // 如果已全选所有，保持全选所有状态，只更新当前页显示
      if (this.isSelectAllSurplus && this.allSelectedSurplusList.length > 0) {
        const startIndex = (this.page - 1) * this.pageSize
        const endIndex = startIndex + this.pageSize
        const currentPageData = this.allSelectedSurplusList.slice(
          startIndex,
          endIndex
        )
        // 根据 selectedRowKeys 来判断当前页的每一项是否应该被选中
        currentPageData.forEach((item) => {
          item.isSelected = this.selectedRowKeys.includes(item.id)
        })
        this.supplusList = currentPageData
        // 根据当前页的选中状态来设置 isSelectAll
        this.isSelectAll =
          this.supplusList.length > 0 &&
          this.supplusList.every((item) =>
            this.selectedRowKeys.includes(item.id)
          )
        if (this.isSelectAll) {
          // 当前页全部选中，确保 selectAllTypeList 包含 port
          if (!this.selectAllTypeList.includes('port')) {
            this.selectAllTypeList = ['port', 'all']
          }
        } else {
          // 当前页没有全部选中，移除 port，但保留 all
          if (this.selectAllTypeList.includes('port')) {
            this.selectAllTypeList = ['all']
          }
        }
        // 更新上一个页码
        this.prevPage = this.page
        this.$forceUpdate()
      } else {
        // 当前页模式：先保存上一个页面的选中状态，然后加载新页面
        if (
          this.selectAllTypeList.includes('port') &&
          this.prevPage !== this.page
        ) {
          // 从当前页的 supplusList 中获取选中项的 id（因为 selectedRowKeys 可能已经被更新）
          const currentPageSelectedKeys = this.supplusList
            .filter((item) => item.isSelected)
            .map((item) => item.id)
          // 保存上一个页面的选中状态
          this.pageSelectedKeysMap[this.prevPage] = [...currentPageSelectedKeys]
        }
        // 更新上一个页码
        this.prevPage = this.page
        // 加载新页面数据
        this.getSupplusList(this.page)
      }
    },
    // 页码输入限制
    pageInputCheck() {
      this.jumpPage = this.jumpPage.replace(/^(0+)|[^\d]+/g, '')
    },
    // 跳转至指定页
    jumpToPage() {
      if (this.jumpPage != '') {
        const targetPage = Number(this.jumpPage)
        // 如果是在当前页模式，先保存上一个页面的选中状态
        if (
          !this.isSelectAllSurplus &&
          this.selectAllTypeList.includes('port') &&
          this.prevPage !== targetPage
        ) {
          // 从当前页的 supplusList 中获取选中项的 id
          const currentPageSelectedKeys = this.supplusList
            .filter((item) => item.isSelected)
            .map((item) => item.id)
          // 保存上一个页面的选中状态
          this.pageSelectedKeysMap[this.prevPage] = [...currentPageSelectedKeys]
        }
        // 更新上一个页码
        this.prevPage = targetPage
        this.page = targetPage
        this.getSupplusList(this.page)
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    // 输入框输入事件
    inputCheck(type, $event) {
      switch (type) {
        case 'name':
          if (this.newSupplus.name.length > 10) {
            this.inputAlert.nameInputAlert = translate('surplusPage.nameLimit')
          } else if (this.newSupplus.name == '') {
            this.inputAlert.nameInputAlert = translate(
              'surplusPage.nameLimitNameErr'
            )
          } else {
            this.inputAlert.nameInputAlert = ''
          }
          this.newSupplus.name = this.newSupplus.name.slice(0, 10)
          break
        case 'long':
          if (this.dealDecimal(type)) {
            this.inputAlert.longInputAlert = translate(
              'surplusPage.tempLongTip'
            )
          } else if (
            this.newSupplus.long == '' ||
            Number(this.newSupplus.long) == 0
          ) {
            this.inputAlert.longInputAlert = translate(
              'basePlankManager.heightErr'
            )
          } else {
            this.inputAlert.longInputAlert = ''
          }
          break
        case 'min_long':
          if (this.dealDecimal(type)) {
            this.inputAlert.minLongInputAlert = translate(
              'surplusPage.minLongLimit'
            )
          } else if (this.newSupplus.min_long == '') {
            this.inputAlert.minLongInputAlert = translate(
              'surplusPage.minLongEmptyTip'
            )
          } else if (
            Number(this.newSupplus.min_long) >= Number(this.newSupplus.long)
          ) {
            this.inputAlert.minLongInputAlert = translate(
              'surplusPage.minLongLimitMax'
            )
          } else {
            this.inputAlert.minLongInputAlert = ''
          }
          break
        case 'width':
          if (this.dealDecimal(type)) {
            this.inputAlert.widthInputAlert = translate(
              'surplusPage.widthLimit'
            )
          } else if (
            this.newSupplus.width == '' ||
            Number(this.newSupplus.width) == 0
          ) {
            this.inputAlert.widthInputAlert = translate(
              'basePlankManager.widthErr'
            )
          } else {
            this.inputAlert.widthInputAlert = ''
          }
          break
        case 'min_width':
          if (this.dealDecimal(type)) {
            this.inputAlert.minWidthInputAlert = translate(
              'surplusPage.minWidthLimit'
            )
          } else if (this.newSupplus.min_width == '') {
            this.inputAlert.minWidthInputAlert = translate(
              'surplusPage.minWidthEmptyLimit'
            )
          } else if (
            Number(this.newSupplus.min_width) >= Number(this.newSupplus.width)
          ) {
            this.inputAlert.minWidthInputAlert = translate(
              'surplusPage.minWidthLimitMax'
            )
          } else {
            this.inputAlert.minWidthInputAlert = ''
          }
          break
        case 'thick':
          if (this.dealDecimal(type, 1)) {
            this.inputAlert.thickInputAlert = translate(
              'surplusPage.thickLimit'
            )
          } else if (
            this.newSupplus.thick == '' ||
            Number(this.newSupplus.thick) == 0
          ) {
            this.inputAlert.thickInputAlert = translate(
              'surplusPage.thickEmptyLimit'
            )
          } else {
            this.inputAlert.thickInputAlert = ''
          }
          break
        case 'type':
          if (this.isThinkerxMaterial) {
            this.newSupplus.type = this.newSupplus.type.replace(
              /^\s+|\s+$/g,
              ''
            )
          }
          if (this.newSupplus.type == '') {
            this.inputAlert.typeInputAlert = translate(
              'basePlankManager.matCodeErr'
            )
          } else {
            this.inputAlert.typeInputAlert = ''
          }
          break
        case 'color':
          if (this.isThinkerxMaterial) {
            this.newSupplus.color = this.newSupplus.color.replace(
              /^\s+|\s+$/g,
              ''
            )
          }
          if (this.newPlankInfoTexture == '') {
            this.inputAlert.colorInputAlert = translate(
              'basePlankManager.colorErr'
            )
          } else {
            this.inputAlert.colorInputAlert = ''
          }
          break
        case 'amount':
          let reg = /^(0+)|[^\d]+/
          let flag = false
          if (reg.test(this.newSupplus.amount)) {
            flag = true
          }
          this.newSupplus.amount = (this.newSupplus.amount + '').replace(
            /^(0+)|[^\d]+/g,
            ''
          )
          if (flag) {
            this.inputAlert.amountInputAlert = translate(
              'surplusPage.countInputLimit'
            )
          } else if (this.newSupplus.amount == '') {
            this.inputAlert.amountInputAlert = translate(
              'surplusPage.countEmptyLimit'
            )
          } else {
            this.inputAlert.amountInputAlert = ''
          }
          break
        case 'remark':
          if (this.newSupplus.remark.length > 50) {
            this.inputAlert.remarkInputAlert = translate(
              'surplusPage.remarkMaxlimit'
            )
          } else {
            this.inputAlert.remarkInputAlert = ''
          }
          this.newSupplus.remark = this.newSupplus.remark.slice(0, 50)
          break
        case 'from_address':
          if (this.newSupplus.from_address.length > 100) {
            this.inputAlert.orderAddressInputAlert = translate(
              'surplusPage.orderAddressMaxlimit'
            )
          } else {
            this.inputAlert.orderAddressInputAlert = ''
          }
          this.newSupplus.from_address = this.newSupplus.from_address.slice(
            0,
            50
          )
          break
        case 'from_order_num':
          if (this.newSupplus.from_order_num.length > 100) {
            this.inputAlert.orderIdInputAlert = translate(
              'surplusPage.orderIdMaxlimit'
            )
          } else {
            this.inputAlert.orderIdInputAlert = ''
          }
          this.newSupplus.from_order_num = this.newSupplus.from_order_num.slice(
            0,
            50
          )
          break
        case 'trimValue':
        case 'topTrim':
        case 'bottomTrim':
        case 'leftTrim':
        case 'rightTrim':
        case 'bottomTrim':
          const alterKeyMap = new Map([
            ['trimValue', '修边值'],
            ['topTrim', '上修边'],
            ['bottomTrim', '下修边'],
            ['leftTrim', '左修边'],
            ['rightTrim', '右修边'],
          ])
          // 处理修边值的输入限制
          this.dealTrimInputValue($event, type)
          // 提示信息展示
          if (this.newSupplus[type] == '') {
            this.inputAlert[`${type}InputAlert`] = `${alterKeyMap.get(
              type
            )}不能为空`
          } else {
            this.inputAlert[`${type}InputAlert`] = ''
          }
          break
      }
    },
    dealTrimInputValue($event, prop) {
      const value = $event.target.value
      const validValue = sanitizeSurplusTrimValueInput(value)
      const normalizedValue =
        $event.type === 'blur' &&
        validValue &&
        !isValidSurplusTrimValue(validValue)
          ? ''
          : validValue
      this.newSupplus[prop] = normalizedValue
      // 更新输入框中的内容
      $event.target.value = normalizedValue
    },
    dealDecimal(type, decimal) {
      let reg = /[^\d.]/
      let flag = false
      if (reg.test(this.newSupplus[type])) {
        flag = true
      }
      this.newSupplus[type] = regReplaceSupplusStorageDealDecimal(
        this.newSupplus[type],
        decimal
      )
      return flag
    },
    // 选择子项
    selectMenuItem(item, type) {
      this.selectedItem = item.name
      this.newSupplus[type] = item.name
    },
    // 格式化单个余料项
    formatSurplusItem(item) {
      const shapeObj = {
        0: 'common.rect',
        1: 'common.Ltype',
        2: 'common.isSpecial',
      }
      const formatted = { ...item }
      // 翻译
      formatted.surplusType = shapeObj[formatted.shape]
      formatted.isSelected = false
      // 如果是柜柜添加的余料, 则不显示备注信息, 且不可编辑备注信息
      formatted.fromGg = formatted.ggid && formatted.ggid.length == 4
      // 设置默认值
      formatted.min_long = formatted.min_long || 0
      formatted.min_width = formatted.min_width || 0
      // 格式化面积
      const area = Number(formatted.area)
      if (area != 0) {
        formatted.area = area.toFixed(2)
      }
      // 处理高光别名
      if (formatted.type) {
        const arrs = formatted.type.split('_')
        if (arrs.length > 1) {
          const highGlossName = matchHighlightBoardName(arrs[1], false)
          if (formatted.type.startsWith(`${highGlossName}_`)) {
            formatted.type = formatted.type.replace(
              `${highGlossName}_`,
              '高光_'
            )
          }
        }
      }
      // 高光板属性
      formatted.is_high_gloss_plank = formatted.type.startsWith('高光_') ? 1 : 0
      function resetTrim(
        formatted,
        vals = ['', '', '', ''],
        trimValue = '',
        isCustom = false
      ) {
        const [top, bottom, left, right] = vals
        Object.assign(formatted, {
          topTrim: top,
          bottomTrim: bottom,
          leftTrim: left,
          rightTrim: right,
          trimValue,
          isCustomTrim: isCustom,
        })
      }

      if (formatted.trimming_method === 'custom') {
        const edge = formatted.surplus_trim_edge
        const isCustom = edge.includes(',')
        isCustom
          ? resetTrim(formatted, edge.split(','), '', true)
          : resetTrim(formatted, ['', '', '', ''], edge, false)
      } else {
        resetTrim(formatted)
      }
      formatted.trimmingMethod = formatted.trimming_method
      delete formatted.surplus_trim_edge
      delete formatted.trimming_method
      formatted.highlight_surface = formatted.highlight_surface ?? 0
      formatted.texDir = formatted.texDir ?? 'normal'
      return formatted
    },
    // 处理全选所有模式
    handleSelectAllSurplusMode(formattedData) {
      // 将所有数据标记为选中并存储
      formattedData.forEach((item) => {
        item.isSelected = true
      })
      this.allSelectedSurplusList = formattedData
      // 只显示当前页的数据（根据当前页码计算）
      const startIndex = (this.page - 1) * this.pageSize
      const endIndex = startIndex + this.pageSize
      this.supplusList = formattedData.slice(startIndex, endIndex)
      // 更新选中列表为所有数据
      this.selectedSurplusList = [...this.allSelectedSurplusList]
      // 更新 selectedRowKeys 为所有数据的 id
      this.selectedRowKeys = this.allSelectedSurplusList.map((item) => item.id)
      // 更新当前页显示的数据的选中状态
      this.isSelectAll =
        this.supplusList.length > 0 &&
        this.supplusList.every((item) => item.isSelected)
      this.showLoading = false
      this.$forceUpdate()
      this.$message.success(
        `已全选 ${this.allSelectedSurplusList.length} 条数据`
      )
    },
    // 从全选所有列表同步选中状态
    syncSelectionFromAllSelected() {
      const allSelectedIds = this.allSelectedSurplusList.map((item) => item.id)
      // 更新当前页数据的选中状态
      this.supplusList.forEach((item) => {
        item.isSelected = allSelectedIds.includes(item.id)
      })
      // 更新 selectedRowKeys 为当前页在 allSelectedSurplusList 中的数据
      this.selectedRowKeys = this.supplusList
        .filter((item) => allSelectedIds.includes(item.id))
        .map((item) => item.id)
      // 更新全选状态
      this.isSelectAll =
        this.supplusList.length > 0 &&
        this.supplusList.every((item) => allSelectedIds.includes(item.id))
      // 更新 selectAllTypeList
      this.updateSelectAllTypeList()
      // 更新 selectedSurplusList
      this.updateSelectedSurplusListFromAllSelected(allSelectedIds)
    },
    // 恢复当前页选中状态
    restoreCurrentPageSelection() {
      if (this.pageSelectedKeysMap[this.page]) {
        // 如果有保存的选中状态，恢复它
        this.selectedRowKeys = [...this.pageSelectedKeysMap[this.page]]
        this.supplusList.forEach((item) => {
          item.isSelected = this.selectedRowKeys.includes(item.id)
        })
        this.updateSelectedSurplusList()
        this.updateIsSelectAll()
        this.updateSelectAllTypeList()
      } else {
        // 如果没有保存的选中状态，重置
        this.selectedRowKeys = this.supplusList
          .filter((item) => item.isSelected)
          .map((item) => item.id)
        this.supplusList.forEach((item) => {
          item.isSelected = this.selectedRowKeys.includes(item.id)
        })
        this.updateSelectedSurplusList()
        this.updateIsSelectAll()
        // 如果当前页不是全选，移除 port
        if (!this.isSelectAll && this.selectAllTypeList.includes('port')) {
          this.selectAllTypeList = this.selectAllTypeList.filter(
            (item) => item !== 'port'
          )
        }
      }
    },
    // 更新选中列表（从当前页）
    updateSelectedSurplusList() {
      const currentPageSelectedIds = this.supplusList
        .filter((item) => this.selectedRowKeys.includes(item.id))
        .map((item) => item.id)
      // 移除之前 selectedSurplusList 中属于当前页的数据
      this.selectedSurplusList = this.selectedSurplusList.filter(
        (item) => !currentPageSelectedIds.includes(item.id)
      )
      // 添加当前页新选中的数据
      const currentPageSelected = this.supplusList.filter((item) =>
        this.selectedRowKeys.includes(item.id)
      )
      this.selectedSurplusList = [
        ...this.selectedSurplusList,
        ...currentPageSelected,
      ]
    },
    // 从全选所有列表更新选中列表
    updateSelectedSurplusListFromAllSelected(allSelectedIds) {
      const currentPageSelected = this.supplusList.filter((item) =>
        allSelectedIds.includes(item.id)
      )
      // 移除之前 selectedSurplusList 中属于当前页的数据
      const currentPageIds = this.supplusList.map((item) => item.id)
      this.selectedSurplusList = this.selectedSurplusList.filter(
        (item) => !currentPageIds.includes(item.id)
      )
      // 添加当前页在 allSelectedSurplusList 中的数据
      this.selectedSurplusList = [
        ...this.selectedSurplusList,
        ...currentPageSelected,
      ]
    },
    // 更新全选状态
    updateIsSelectAll() {
      this.isSelectAll =
        this.supplusList.length > 0 &&
        this.supplusList.every((item) => this.selectedRowKeys.includes(item.id))
    },
    // 更新 selectAllTypeList
    updateSelectAllTypeList() {
      if (this.isSelectAll) {
        if (!this.selectAllTypeList.includes('port')) {
          this.selectAllTypeList = [...this.selectAllTypeList, 'port']
        }
      } else {
        if (this.selectAllTypeList.includes('port')) {
          this.selectAllTypeList = this.selectAllTypeList.filter(
            (item) => item !== 'port'
          )
        }
      }
    },
    // 更新余料仓库信息
    updateSurplusStoreInfo(formattedRawData) {
      formattedRawData?.forEach((item) => {
        this.supplusList.forEach((supplus) => {
          if (item.id == supplus.id) {
            supplus.branch_name = item.branch_name || '-'
            supplus.branch_no = item.branch_no
            supplus.from_address = item.from_address
            supplus.from_order_num = item.from_order_num
          }
        })
      })
    },
    // 更新余料列表相关数据
    updateSurplusListData(data) {
      this.totalSupplus = data.total
      this.showLoading = false
      this.allMatcodeList = data.mat_code_list?.filter((item) => item)
      this.allThickList = data.thick_list?.filter((item) => item)
      this.allColorList = data.color_list?.map((item) => ({
        label: item,
        value: item,
      }))
      this.surplusStoreList = data.surplus_warehouse_list?.map((item) => ({
        ...item,
        value: item.branch_no,
        label: item.branch_name,
      }))
      if (data.surplus_warehouse_list?.length) {
        this.selectedSurplusStore = data.surplus_warehouse_list[0].branch_no
      } else {
        this.selectedSurplusStore = ''
      }
    },
    /**@description 获取余料仓数据
     * @param page 页数
     * @param isGetSurStore 全选
     * @param limit 获取多少条数据
     * @param get_all 获取所有数据
     *  */
    getSupplusList(page = 1, isGetSurStore, limit, get_all = false) {
      const shapeMap = {
        L: 1,
        specialShape: 2,
        rect: 0,
      }
      // 更新上一个页码（在设置新页码之前）
      if (this.page !== page) {
        this.prevPage = this.page
      }
      this.page = page
      if (!isGetSurStore) {
        if (!this.isSelectAllSurplus) {
          this.isSelectAll = false
        }
      }
      let param = {
        page: page,
        limit: limit || this.pageSize,
      }
      if (this.activeShape != '全部' && this.activeShape != 'all') {
        param.shape = shapeMap[this.activeShape]
        this.isFilterStatus = true
        buryPointApi('supplus_storage', 'filter_shape')
      }
      if (this.activeThick != '全部') {
        param.thick = this.activeThick
        this.isFilterStatus = true
        buryPointApi('supplus_storage', 'filter_thick')
      }

      if (this.activeTexDir != '全部') {
        param.texDir = this.activeTexDir
        this.isFilterStatus = true
        buryPointApi('supplus_storage', 'filter_texDir')
      }

      if (this.activeMatcode != '全部') {
        param.matCode = this.activeMatcode
        this.isFilterStatus = true
        buryPointApi('supplus_storage', 'filter_matCode')
      }
      if (this.keyWord != '') {
        param.search_type = this.searchType
        param.search_value = this.keyWord
        this.isFilterStatus = true
        this.page = 1
        buryPointApi('supplus_storage', 'search')
      }
      if (this.activeSurplusStore != '全部') {
        param.branch_no = this.activeSurplusStore
        this.isFilterStatus = true
        buryPointApi('supplus_storage', 'filter_surplus_store')
      }
      if (this.activeColor != '全部') {
        param.color = this.activeColor
        this.isFilterStatus = true
        buryPointApi('supplus_storage', 'filter_color')
      }
      if (this.activeTime) {
        param.start_date = this.activeTime[0]
        param.end_date = this.activeTime[1]
        this.isFilterStatus = true
        buryPointApi('supplus_storage', 'filter_time')
      }
      if (this.activeLockState != '全部') {
        param.lock_status = this.activeLockState
        param.surplus_lock = this.isSurplusLock
        this.isFilterStatus = true
      }
      this.$getByToken(
        `/get_surplus_depot${get_all ? '?get_all=true' : ''}`,
        param,
        (res) => {
          if (res.status == 1) {
            // 格式化原始数据
            const formattedRawData = res.data.data?.map((item) =>
              this.formatSurplusItem(item)
            )

            if (!isGetSurStore) {
              const formattedData = formattedRawData?.map((item) => ({
                ...item,
                branch_name: item.branch_name || '-',
                from_address: item.from_address,
                from_order_num: item.from_order_num,
                branch_no:
                  item.branch_no == '000' || item.branch_no == '0'
                    ? ''
                    : item.branch_no,
                create_time: item.create_time.split(' ')[0],
                highlight_surface: item.highlight_surface ?? 0,
              }))

              // 处理全选所有模式
              if (
                this.isSelectAllSurplus &&
                (get_all || (limit && limit > this.pageSize))
              ) {
                this.handleSelectAllSurplusMode(formattedData)
              } else {
                this.supplusList = formattedData
                // 根据模式处理选中状态
                if (
                  this.isSelectAllSurplus &&
                  this.allSelectedSurplusList.length > 0
                ) {
                  this.syncSelectionFromAllSelected()
                } else if (!this.isSelectAllSurplus) {
                  this.restoreCurrentPageSelection()
                }
              }
            } else {
              this.updateSurplusStoreInfo(formattedRawData)
            }

            // 更新其他数据
            this.updateSurplusListData(res.data)
          }
        }
      )
    },
    // 获取余料筛选项
    async getSurplusClassify() {
      await this.$getByToken('/get_user_plank_setting', {}, (res) => {
        if (res.status == 1) {
          const otherMatCodes = localStorage.getItem('matcodeList')
            ? JSON.parse(localStorage.getItem('matcodeList'))
            : []
          this.matcodeList = res.data.matCodes.concat(otherMatCodes)
          this.colorList = res.data.colors
          this.thickList = res.data.thicks
          this.isShowNewClassify = false
          this.nextSurplusName = res.data.next_surplus_name
          this.newSupplus.name = res.data.next_surplus_name
        }
      })
    },
    // 显示删除余料弹窗
    showDeleteDialog(val) {
      this.deleteIds = []
      this.deleteGgids = []
      if (val) {
        this.deleteIds = [val.id]
        this.deleteGgids = [val.ggid]
        buryPointApi('supplus_storage', 'del_surplus')
      } else {
        buryPointApi('supplus_storage', 'batch_del_surplus')
        // 如果已全选所有，使用所有选中的数据
        const listToProcess = this.isSelectAllSurplus
          ? this.allSelectedSurplusList
          : this.supplusList
        for (let i = 0; i < listToProcess.length; ++i) {
          if (listToProcess[i].isSelected) {
            this.deleteIds.push(listToProcess[i].id)
            this.deleteGgids.push(listToProcess[i].ggid)
          }
        }
      }
      this.isShowDeleteDialog = true
    },
    // 显示复制余料弹窗
    showCopyDialog(val) {
      this.copySurplus = val
      this.isShowCopyDialog = true
    },
    // 显示转移弹窗
    handleShowTransSurplus(val) {
      this.deleteIds = []
      this.deleteGgids = []
      if (val) {
        this.deleteIds = [val.id]
        this.deleteGgids = [val.ggid]
      } else {
        for (let i = 0; i < this.supplusList.length; ++i) {
          if (this.supplusList[i].isSelected) {
            this.deleteIds.push(this.supplusList[i].id)
            this.deleteGgids.push(this.supplusList[i].ggid)
          }
        }
      }
      this.showTransSurplus = true
    },
    // 确认转移
    handleTransSurplus() {
      if (!this.selectedSurplusStore) {
        this.$message.error('暂无余料库请创建后转移！')
        this.showTransSurplus = false
        return
      }
      const params = {
        roll_out_surplus_ids: this.deleteIds,
        roll_out_ggids: this.deleteGgids,
        roll_in_branch_no: this.selectedSurplusStore,
      }
      const listToProcess = this.isSelectAllSurplus
        ? this.allSelectedSurplusList
        : this.supplusList
      const transferItems = listToProcess.filter((item) =>
        this.deleteIds.includes(item.id)
      )
      surplusTransfer(params).then((res) => {
        if (res.status == 1) {
          this.saveSurplusRecord(
            'transfer',
            transferItems.map((item) => ({
              ...item,
              branch_name: this.surplusStoreList.find(
                (surItem) => surItem.branch_no == this.selectedSurplusStore
              )?.branch_name,
            })),
            transferItems
          )
          this.$message.success('转移成功')
          this.getSupplusList(this.page)
          this.selectedSurplusList = []
          buryPoint({
            function_module: 'supplus_storage',
            function_point: 'transfer_surplus',
          })
        } else {
          this.$message.error(res.msg)
        }
      })
      this.showTransSurplus = false
    },
    // 确认删除余料
    confirmDeleteSupplus() {
      const listToProcess = this.isSelectAllSurplus
        ? this.allSelectedSurplusList
        : this.supplusList
      const deletedItems = listToProcess.filter((item) =>
        this.deleteIds.includes(item.id)
      )

      this.$token(
        '/delete_surplus_depot',
        {
          ggids: this.deleteGgids,
          ids: this.deleteIds,
        },
        (res) => {
          if (res.status == 1) {
            this.saveSurplusRecord('delete', null, deletedItems)
            if (this.totalSupplus % this.pageSize == 1 && this.page > 1) {
              this.page = this.page - 1
              this.getSupplusList(this.page)
            }
            this.getSupplusList(this.page)
            this.selectedSurplusList = []
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 2000,
            })
          } else {
            this.$message({
              message: '删除失败',
              type: 'error',
              duration: 2000,
            })
          }
        }
      )
      this.isShowDeleteDialog = false
    },
    async handleConfirmCopy() {
      this.showLoading = true
      this.isCopyLoading = true
      await this.getSurplusClassify()
      const nextIndex = this.nextSurplusName.split('余料')[1]
      const payloadArr = []

      const copyPart = {
        ...this.copySurplus,
        plankNum: '',
        branch_name: '',
        branch_no: '',
      }

      if (this.copySurplus.isCustomTrim) {
        copyPart.surplus_trim_edge = [
          this.copySurplus.topTrim,
          this.copySurplus.bottomTrim,
          this.copySurplus.leftTrim,
          this.copySurplus.rightTrim,
        ].join(',')
      }

      if (this.copySurplus.trimmingMethod) {
        copyPart.trimming_method = this.copySurplus.trimmingMethod
      }

      for (let i = 0; i < this.copySetting.copyNum; i++) {
        payloadArr.push({
          ...copyPart,
          amount: 1,
          name: `余料${Number(nextIndex) + i}`,
          plankNum: uniquePlankNum.createUniquePlankNum(copyPart, true),
          lock_status: 0,
          lock_num: 0,
        })
      }

      const res = await createSurplus({
        surplus_data: payloadArr,
        designated: true,
      })
      if (res) {
        if (res.status == 1) {
          buryPointApi('supplus_storage', 'copy')
          this.saveSurplusRecord(
            'add',
            res.data.map((item) => ({
              ...item,
              surplus_trim_edge: payloadArr[0].surplus_trim_edge,
            }))
          )
          this.showAddNewSupplus = false
          this.addSupplusDrawer = false
          this.getSupplusList(1)

          this.$message.success(`复制余料成功`)
        }
        if (res.status == 0) {
          this.$message({
            type: 'error',
            message: res.msg,
          })
          // this.addSupplusDrawer = false
        }
        this.showLoading = false
        this.isCopyLoading = false
        this.isShowCopyDialog = false
      }
    },
    // 切换新增余料时选择的余料
    changeSelectedShape(type) {
      this.selectedShape = type
      // 切换时, 去除报警
      this.inputAlert = {
        nameInputAlert: '',
        longInputAlert: '',
        minLongInputAlert: '',
        widthInputAlert: '',
        minWidthInputAlert: '',
        thickInputAlert: '',
        trimValueInputAlert: '',
        topTrimInputAlert: '',
        bottomTrimInputAlert: '',
        leftTrimInputAlert: '',
        rightTrimInputAlert: '',
        typeInputAlert: '',
        colorInputAlert: '',
        amountInputAlert: '',
        remarkInputAlert: '',
        orderAddressInputAlert: '',
        orderIdInputAlert: '',
      }
      let name = this.newSupplus.name
      this.newSupplus = {
        name: name,
        long: '',
        min_long: '',
        width: '',
        min_width: '',
        thick: '',
        trimmingMethod: 'follow',
        trimValue: '',
        isCustomTrim: false,
        topTrim: '',
        bottomTrim: '',
        leftTrim: '',
        rightTrim: '',
        type: this.supplusStorageMatCode,
        color: this.supplusStorageColorList[this.supplusStorageColorList - 1],
        amount: '1',
        remark: '',
        from_address: '',
        from_order_num: '',
        is_high_gloss_plank: 0,
      }
      this.newSupplus
      if (type == 'rect') {
        this.drawObj = {
          width: 172,
          long: 257,
          min_width: 0,
          min_long: 0,
        }
      } else {
        this.drawObj = {
          width: 172,
          long: 257,
          min_width: 81,
          min_long: 111,
          path: [],
        }
      }
      this.$forceUpdate()
    },
    // 新增余料
    async addNewSupplus() {
      this.newSupplus = {
        name: '',
        long: '',
        min_long: '',
        width: '',
        min_width: '',
        shape: 0,
        thick: '',
        trimmingMethod: 'follow',
        isCustomTrim: false,
        trimValue: '',
        topTrim: '',
        bottomTrim: '',
        leftTrim: '',
        rightTrim: '',
        type: '',
        color: '',
        amount: '1',
        remark: '',
        from_address: '',
        from_order_num: '',
        is_high_gloss_plank: 0,
      }
      await this.getSurplusClassify()
      this.drawObj = {
        width: 172,
        long: 257,
        min_width: 0,
        min_long: 0,
      }
      this.selectedShape = 'rect'
      this.showAddNewSupplus = true
    },
    // 取消新增余料
    cancelAddNewSupplus() {
      this.showAddNewSupplus = false
      // 关闭时, 去除报警
      this.inputAlert = {
        nameInputAlert: '',
        longInputAlert: '',
        minLongInputAlert: '',
        widthInputAlert: '',
        minWidthInputAlert: '',
        thickInputAlert: '',
        trimValueInputAlert: '',
        topTrimInputAlert: '',
        bottomTrimInputAlert: '',
        leftTrimInputAlert: '',
        rightTrimInputAlert: '',
        typeInputAlert: '',
        colorInputAlert: '',
        amountInputAlert: '',
        remarkInputAlert: '',
        orderAddressInputAlert: '',
        orderIdInputAlert: '',
      }
    },
    dealSurplusTrimEdge(newSurplus) {
      if (newSurplus.trimmingMethod === 'custom') {
        newSurplus.surplus_trim_edge = newSurplus.isCustomTrim
          ? `${newSurplus.topTrim},${newSurplus.bottomTrim},${newSurplus.leftTrim},${newSurplus.rightTrim}`
          : newSurplus.trimValue
      } else {
        newSurplus.surplus_trim_edge = ''
      }
      newSurplus.trimming_method = newSurplus.trimmingMethod
      const removeKeys = [
        'topTrim',
        'bottomTrim',
        'leftTrim',
        'rightTrim',
        'trimValue',
        'isCustomTrim',
        'trimmingMethod',
      ]
      removeKeys.forEach((k) => delete newSurplus[k])

      return newSurplus
    },
    /** 格式化余料操作记录表格数据 */
    formatSurplusRecordItem(item) {
      if (!item) return null
      return {
        ...item,
        surplus_name: item.name,
        shape: item.shape == 0 ? '矩形' : 'L形',
        matCode: item.type.replaceAll('高光_', ''),
        is_high_gloss_plank: item.type.includes('高光') ? '高光板' : '非高光板',
        branch_name: item.branch_name ?? '-',
        surplus_trim_edge:
          item.surplus_trim_edge ??
          (item.trimmingMethod === 'custom'
            ? item.isCustomTrim
              ? `${item.topTrim},${item.bottomTrim},${item.leftTrim},${item.rightTrim}`
              : item.trimValue
            : ''),
      }
    },
    /**
     * @desc 余料新增/编辑/删除操作记录（表格形式）
     * @param {'add' | 'edit' | 'delete'} operateType
     * @param {*} newData 最新数据或新增列表
     * @param {*} oriData 原始数据或删除列表
     */
    saveSurplusRecord(operateType, newData, oriData) {
      const surplusRecordKeys = [
        'surplus_name',
        'shape',
        'matCode',
        'color',
        'thick',
        'long',
        'width',
        'min_long',
        'min_width',
        'area',
        'surplus_trim_edge',
        'amount',
        'is_high_gloss_plank',
        'branch_name',
        'remark',
      ]
      let list = []
      let oriList = []
      let idKey = 'id'

      if (operateType === 'add') {
        const addList = Array.isArray(newData) ? newData : [newData]
        list = addList.map((item) => this.formatSurplusRecordItem(item))
        oriList = []
      } else if (operateType === 'edit') {
        list = [this.formatSurplusRecordItem(newData)]
        oriList = [this.formatSurplusRecordItem(oriData)]
      } else if (operateType === 'delete') {
        const deleteList = Array.isArray(oriData) ? oriData : [oriData]
        list = []
        oriList = deleteList.map((item) => this.formatSurplusRecordItem(item))
      } else if (operateType === 'transfer') {
        const transferList = Array.isArray(newData) ? newData : [newData]
        const oriTransferList = Array.isArray(oriData) ? oriData : [oriData]
        list = transferList.map((item) => this.formatSurplusRecordItem(item))
        oriList = oriTransferList.map((item) =>
          this.formatSurplusRecordItem(item)
        )
      }

      genFinalRecord(
        {
          key: '余料清单',
          operateArr: [
            {
              key: '余料',
              dataArr: [
                {
                  type: 'table',
                  list,
                  oriList,
                  keys: surplusRecordKeys,
                  tableType: operateRecordTableType.SURPLUS_DEPOT_TABLE,
                  idKey,
                },
              ],
            },
          ],
        },
        'surplus-management',
        -2
      )
    },
    // 保存新增余料
    saveNewSupplus(cb, isCopy = false) {
      // 判断是否可以保存
      if (!isCopy) {
        this.newSupplus.color =
          this.newPlankInfoTexture[this.newPlankInfoTexture.length - 1]
      }
      // 输入校验
      let ableSave = this.checkInputIsBlank()
      if (!ableSave) return
      this.showLoading = true
      let newSurplus = JSON.parse(JSON.stringify(this.newSupplus))
      let area = 0
      // 余料修边值处理 TODO
      newSurplus = this.dealSurplusTrimEdge(newSurplus)
      newSurplus.long = Number(newSurplus.long)
      newSurplus.width = Number(newSurplus.width)
      newSurplus.amount = Number(newSurplus.amount)
      newSurplus.thick = Number(newSurplus.thick)
      const isCopyLShaple = isCopy && newSurplus.shape === 1
      if (this.selectedShape == 'L' || isCopyLShaple) {
        area =
          newSurplus.long * newSurplus.width -
          (newSurplus.long - newSurplus.min_long) *
            (newSurplus.width - newSurplus.min_width)
        newSurplus.min_long = Number(newSurplus.min_long)
        newSurplus.min_width = Number(newSurplus.min_width)
      } else {
        area = newSurplus.long * newSurplus.width
      }
      area = toDecimal(area / 1000000, 2)
      newSurplus.color = isCopy
        ? newSurplus.color.split('@_@')[0].trim()
        : this.newPlankInfoTexture[this.newPlankInfoTexture.length - 1].trim()
      newSurplus.type = newSurplus.type.split('@_@')[0].trim()
      newSurplus.shape = isCopy
        ? newSurplus.shape
        : this.selectedShape == 'L'
        ? 1
        : 0
      newSurplus.area = area
      newSurplus.type = this.handlePlankMatCode(
        newSurplus,
        newSurplus.is_high_gloss_plank
      )
      newSurplus.branch_no = newSurplus.branch_no
      newSurplus.from_address = newSurplus.from_address
      newSurplus.from_order_num = newSurplus.from_order_num
      newSurplus.name = newSurplus.name.trim()
      newSurplus.surplus_lock = this.isSurplusLock
      newSurplus.lock_status = newSurplus.lock_status
      newSurplus.lock_num = newSurplus.amount
      // 新接口为满足批量添加
      // const data = {
      //   surplus_data: [],
      // }
      // data.surplus_data.push(newSurplus)
      let surplusIndex = this.nextSurplusName.split('余料')[1]
      const payloadArr = []
      const isSameName = newSurplus.name == this.nextSurplusName
      if (isSameName) {
        payloadArr.push({
          ...newSurplus,
          amount: 1,
          name: this.nextSurplusName,
          plankNum: uniquePlankNum.createUniquePlankNum(
            { ...newSurplus, plankNum: '' },
            true
          ),
        })
        surplusIndex = Number(surplusIndex) + 1
      } else {
        payloadArr.push({
          ...newSurplus,
          amount: 1,
          name: newSurplus.name,
          plankNum: uniquePlankNum.createUniquePlankNum(
            { ...newSurplus, plankNum: '' },
            true
          ),
        })
      }
      for (let i = 0; i < newSurplus.amount - 1; i++) {
        payloadArr.push({
          ...newSurplus,
          amount: 1,
          name: `余料${Number(surplusIndex) + i}`,
          plankNum: uniquePlankNum.createUniquePlankNum(
            { ...newSurplus, plankNum: '' },
            true
          ),
        })
      }
      this.$token(
        '/create_surplus_depot',
        { surplus_data: payloadArr, designated: true },
        (res) => {
          if (res.status == 1) {
            this.saveSurplusRecord(
              'add',
              res.data.map((item) => ({
                ...item,
                surplus_trim_edge: payloadArr[0].surplus_trim_edge,
              }))
            )
            this.showAddNewSupplus = false
            this.addSupplusDrawer = false
            this.getSupplusList(1)
            cb && typeof cb == 'function'
            if (cb && typeof cb == 'function') {
              cb()
            } else {
              this.$message.success(`添加余料成功`)
            }
          }
          if (res.status == 0) {
            if (res.data?.err_surplus) {
              let errSurplus = res.data?.err_surplus
              Object.keys(errSurplus).forEach((key) => {
                this.$message.error(errSurplus[key][0])
                return
              })
            }
            this.showLoading = false
            // this.addSupplusDrawer = false
          }
        }
      )
      // this.$token('/create_surplus_depot', newSurplus, (res) => {
      //   if (res.status == 1) {
      //     this.showAddNewSupplus = false
      //     this.addSupplusDrawer = false
      //     this.getSupplusList(1)
      //   }
      //   if (res.status == 0) {
      //     this.$message({
      //       type: 'error',
      //       message: res.msg,
      //     })
      //     this.showLoading = false
      //     this.addSupplusDrawer = false
      //   }
      // })
    },
    // 判断输入是否为空
    checkInputIsBlank() {
      let ableSave = true
      if (this.newSupplus.name == '') {
        this.inputAlert.nameInputAlert = '余料名称不能为空!'
        ableSave = false
      }
      if (this.newSupplus.long == '') {
        this.inputAlert.longInputAlert = '板材长度不能为空!'
        ableSave = false
      }
      if (Number(this.newSupplus.long) == 0) {
        this.inputAlert.longInputAlert = '板材长度不能为0!'
        ableSave = false
      }
      if (this.newSupplus.min_long == '' && this.selectedShape == 'L') {
        this.inputAlert.minLongInputAlert = '短边长度不能为空!'
        ableSave = false
      }
      if (this.newSupplus.min_long != '' && this.selectedShape == 'L') {
        if (Number(this.newSupplus.min_long) == 0) {
          this.inputAlert.minLongInputAlert = '短边长度不能为0!'
          ableSave = false
        }
        if (Number(this.newSupplus.min_long) >= Number(this.newSupplus.long)) {
          this.inputAlert.minLongInputAlert = '短边长度不能超过板材长度!'
          ableSave = false
        }
      }
      if (this.newSupplus.width == '') {
        this.inputAlert.widthInputAlert = '板材宽度不能为空!'
        ableSave = false
      }
      if (Number(this.newSupplus.width) == 0) {
        this.inputAlert.widthInputAlert = '板材宽度不能为0!'
        ableSave = false
      }
      if (this.newSupplus.min_width == '' && this.selectedShape == 'L') {
        this.inputAlert.minWidthInputAlert = '短边宽度不能为空!'
        ableSave = false
      }
      if (this.newSupplus.min_width != '' && this.selectedShape == 'L') {
        if (Number(this.newSupplus.min_width) == 0) {
          this.inputAlert.minWidthInputAlert = '短边宽度不能为0!'
          ableSave = false
        }
        if (
          Number(this.newSupplus.min_width) >= Number(this.newSupplus.width)
        ) {
          this.inputAlert.minWidthInputAlert = '短边宽度不能超过板材宽度!'
          ableSave = false
        }
      }
      if (Number(this.newSupplus.thick) == 0) {
        this.inputAlert.thickInputAlert = '板材厚度不能为空!'
        ableSave = false
      }
      if (this.newSupplus.type == '') {
        this.inputAlert.typeInputAlert = '板材材质不能为空!'
        ableSave = false
      }
      if (
        !this.newSupplus.color ||
        this.newSupplus.color.includes('_catalog')
      ) {
        this.inputAlert.colorInputAlert = '板材颜色不能为空!'
        ableSave = false
      }
      if (Number(this.newSupplus.amount) == 0) {
        this.inputAlert.amountInputAlert = '数量不能为空!'
        ableSave = false
      }
      if (this.newSupplus.trimmingMethod === 'custom') {
        // 单独设置修边-非自定义修边
        if (!this.newSupplus.isCustomTrim && !this.newSupplus.trimValue) {
          this.inputAlert.trimValueInputAlert =
            this.$translateLang('修边值不能为空')
          ableSave = false
        } else if (this.newSupplus.isCustomTrim) {
          // 重置修边值输入提示
          // 配置每个字段对应的提示信息
          const trimFields = [
            { key: 'topTrim', message: this.$translateLang('上修边不能为空!') },
            {
              key: 'bottomTrim',
              message: this.$translateLang('下修边不能为空!'),
            },
            {
              key: 'leftTrim',
              message: this.$translateLang('左修边不能为空!'),
            },
            {
              key: 'rightTrim',
              message: this.$translateLang('右修边不能为空!'),
            },
          ]
          // 重置修边值输入提示
          this.inputAlert.trimValueInputAlert = ''
          // 遍历字段进行校验
          trimFields.forEach((field) => {
            if (!this.newSupplus[field.key]) {
              this.inputAlert[`${field.key}InputAlert`] = field.message
              ableSave = false
            } else {
              this.inputAlert[`${field.key}InputAlert`] = ''
            }
          })
        }
      }
      return ableSave
    },
    // 新建材质
    addNewMatcode() {
      this.newClassifyType = 'matcode'
      this.isShowNewClassify = true
    },
    // 新建颜色
    addNewColor() {
      this.newClassifyType = 'color'
      this.isShowNewClassify = true
    },
    // 关闭新建分类弹窗
    closeNewClassify() {
      this.isShowNewClassify = false
      this.newClassify = ''
    },
    // 保存新建的分类
    saveNewClassify() {
      if (this.newClassify == '') {
        this.$message({
          message:
            this.newClassifyType == 'matcode'
              ? '材质不能为空!'
              : '颜色不能为空!',
          type: 'error',
        })
        return
      }
      if (this.newClassifyType == 'matcode') {
        // this.$token(
        //   '/create_matcode',
        //   {
        //     name: this.newClassify,
        //   },
        //   (res) => {
        //     if (res.status == 1) {
        //       this.matcodeList.push(this.newClassify)
        //       this.newClassify = ''
        //       this.isShowNewClassify = false
        //     }
        //   }
        // )
        const matCodeStr = this.newClassify
        const checkMatCodeIsExistList = this.matcodeList.map((item) => {
          return {
            label: item,
            value: item,
          }
        })
        const isExist = checkMatCodeIsExist(matCodeStr, checkMatCodeIsExistList)
        if (isExist) {
          this.$message.error(`材质:${matCodeStr}已存在`)
        } else {
          let otherMatCodes = localStorage.getItem('matcodeList')
            ? JSON.parse(localStorage.getItem('matcodeList'))
            : []
          otherMatCodes.push(matCodeStr)
          localStorage.setItem('matcodeList', JSON.stringify(otherMatCodes))
          this.matcodeList.push(matCodeStr)
          this.newSupplus.type = matCodeStr
          this.newClassify = ''
          this.isShowNewClassify = false
        }
      }
      if (this.newClassifyType == 'color') {
        const colorStr = this.newClassify
        const isExist = checkColorIsExist(colorStr, this.materialColorOptions)
        if (isExist) {
          this.$message.error(`颜色:${colorStr}已存在`)
        } else {
          let otherColors = localStorage.getItem('colorList')
            ? JSON.parse(localStorage.getItem('colorList'))
            : []
          otherColors.push(colorStr)
          this.newPlankInfoTexture = ['other', colorStr]
          localStorage.setItem('colorList', JSON.stringify(otherColors))
          const lastIndex = this.materialColorOptions.length - 1
          this.materialColorOptions[lastIndex].children.push({
            label: colorStr,
            value: colorStr,
          })
          this.newClassify = ''
          this.isShowNewClassify = false
        }
      }
    },
    // 显示编辑
    showEditSurplus(item) {
      this.inputAlert = {
        nameInputAlert: '',
        longInputAlert: '',
        minLongInputAlert: '',
        widthInputAlert: '',
        minWidthInputAlert: '',
        thickInputAlert: '',
        trimValueInputAlert: '',
        topTrimInputAlert: '',
        bottomTrimInputAlert: '',
        leftTrimInputAlert: '',
        rightTrimInputAlert: '',
        typeInputAlert: '',
        colorInputAlert: '',
        amountInputAlert: '',
        remarkInputAlert: '',
        orderAddressInputAlert: '',
        orderIdInputAlert: '',
      }
      this.newSupplus = {
        name: item.name ? item.name : '',
        long: item.long,
        min_long: item.min_long,
        width: item.width,
        min_width: item.min_width,
        thick: item.thick,
        type: item.type.replaceAll('高光_', ''),
        color: item.color,
        amount: item.amount,
        remark: item.remark ? item.remark : '',
        fromGg: item.fromGg,
        is_high_gloss_plank: item.is_high_gloss_plank,
        branch_no:
          item.branch_no == '000' || item.branch_no == '0'
            ? ''
            : item.branch_no,
        from_address: item.from_address,
        from_order_num: item.from_order_num,
        lock_status: item.lock_status,
        lock_order: item.lock_order,
        // 这里要修改
        trimmingMethod: item.trimmingMethod || 'follow',
        trimValue: item.trimValue || '',
        isCustomTrim: item.isCustomTrim || false,
        topTrim: item.topTrim || '',
        bottomTrim: item.bottomTrim || '',
        leftTrim: item.leftTrim || '',
        rightTrim: item.rightTrim || '',
        texDir: item.texDir || '',
        highlight_surface: item.highlight_surface || 0,
      }
      if (item.path && item.path.length) {
        this.newSupplus.path = item.path
      }
      this.selectedShape = 'rect'
      if (item.min_long != 0 && item.min_long != '') {
        this.selectedShape = 'L'
      }
      this.showEditDrawer = true
      this.currentSurplus = item
      this.colorSearchKey = item.color
      this.handleEnterColor()
    },
    // 确认修改编辑
    confirmEditSurplus() {
      this.newSupplus.color = this.newPlankInfoTexture
        ? this.newPlankInfoTexture[this.newPlankInfoTexture.length - 1]
        : this.newSupplus.color.split('@_@')[0]
      if (!this.newSupplus.color || this.newSupplus.color.includes('_catalog'))
        return
      // 判断是否可以保存
      let ableSave = this.checkInputIsBlank()
      if (!ableSave) {
        this.$message.error('存在未填写的信息, 请核对!')
        return
      }
      let area = 0
      if (this.selectedShape == 'L') {
        area =
          this.newSupplus.long * this.newSupplus.width -
          (this.newSupplus.long - this.newSupplus.min_long) *
            (this.newSupplus.width - this.newSupplus.min_width)
      } else {
        area = this.newSupplus.long * this.newSupplus.width
      }
      area = toDecimal(area / 1000000, 2)
      let splitValue = '@@'

      const data = {
        id: this.currentSurplus.id,
        // 根据高光板属性重置板件材质
        type: this.newSupplus.type.split(splitValue)[0],
        name: this.newSupplus.name,
        thick: this.newSupplus.thick,
        area: area,
        width: this.newSupplus.width,
        long: this.newSupplus.long,
        color: this.newSupplus.color,
        ggid: this.currentSurplus.ggid,
        amount: this.newSupplus.amount,
        shape: this.currentSurplus.shape,
        remark: this.newSupplus.remark,
        min_long: this.newSupplus.min_long,
        min_width: this.newSupplus.min_width,
        branch_no: this.newSupplus.branch_no,
        from_address: this.newSupplus.from_address,
        from_order_num: this.newSupplus.from_order_num,
        surplus_lock: this.surplusLock,
        lock_status: this.newSupplus.lock_status,
        lock_order: this.newSupplus.lock_order,
        lock_num: this.newSupplus.amount,
        plankNum: uniquePlankNum.createUniquePlankNum(
          this.currentSurplus,
          true
        ),
        surplus_trim_edge:
          this.newSupplus.trimmingMethod === 'custom'
            ? this.newSupplus.isCustomTrim
              ? `${this.newSupplus.topTrim},${this.newSupplus.bottomTrim},${this.newSupplus.leftTrim},${this.newSupplus.rightTrim}`
              : this.newSupplus.trimValue
            : '',
        // trimmingMethod: this.newSupplus.trimmingMethod,
        trimming_method: this.newSupplus.trimmingMethod,
        highlight_surface: this.newSupplus.highlight_surface ?? 0,
        texDir: this.newSupplus.texDir,
      }

      if (this.newSupplus.path && this.newSupplus.path.length) {
        data.path = this.currentSurplus.path
      }

      if (this.selectedShape == 'L' && this.newSupplus.path) {
        Object.assign(data, dealLshapeSurplusFromSize(data))
      }

      data.type = this.handlePlankMatCode(
        this.newSupplus,
        this.newSupplus.is_high_gloss_plank
      )
      data.type = data.type.split(splitValue)[0]
      // currentSurplus
      this.$token('/update_surplus_depot', data, (res) => {
        if (res.status == 1) {
          this.saveSurplusRecord(
            'edit',
            {
              ...data,
              branch_name: this.surplusStoreList.find(
                (item) => item.branch_no == data.branch_no
              )?.branch_name,
            },
            this.currentSurplus
          )
          this.$message({
            message: '修改成功!',
            type: 'success',
          })
          // 调用重新请求当前页面
          this.getSupplusList(this.page)
          this.showEditDrawer = false
          buryPointApi('supplus_storage', 'edit_surplus')
        } else {
          this.$message({
            type: 'error',
            message: res.msg,
          })
        }
      })
    },
    // 关闭编辑
    closeEditDrawer() {
      this.showEditDrawer = false
      this.colorSearchKey = ''
      this.newPlankInfoTexture = ''
      // 关闭时, 去除报警
      this.inputAlert = {
        nameInputAlert: '',
        longInputAlert: '',
        minLongInputAlert: '',
        widthInputAlert: '',
        minWidthInputAlert: '',
        thickInputAlert: '',
        trimValueInputAlert: '',
        topTrimInputAlert: '',
        bottomTrimInputAlert: '',
        leftTrimInputAlert: '',
        rightTrimInputAlert: '',
        typeInputAlert: '',
        colorInputAlert: '',
        amountInputAlert: '',
        remarkInputAlert: '',
        orderAddressInputAlert: '',
        orderIdInputAlert: '',
      }
    },
    /**
     * @author lkk
     * @description 添加余料改为侧边栏显示
     */
    addNewSupplusSide() {
      buryPointApi('supplus_storage', 'add')
      this.addSupplusDrawer = true
      this.changeSelectedShape(this.selectedShape)
      Object.keys(this.newSupplus).forEach((key) => {
        if (key === 'isCustomTrim') {
          this.newSupplus[key] = false
        } else if (key != 'amount') {
          this.newSupplus[key] = ''
        } else {
          this.newSupplus[key] = 1
        }
        if (key === 'is_high_gloss_plank') {
          this.newSupplus[key] = 0
        }
        if (key === 'trimmingMethod') {
          this.newSupplus[key] = 'follow'
        }
      })
      this.newPlankInfoTexture = this.supplusStorageColorList
      this.newSupplus.color =
        this.supplusStorageColorList[this.supplusStorageColorList.length - 1] ??
        ''
      this.newSupplus.type = this.supplusStorageMatCode
      this.getSurplusClassify()
    },
    // 余料板材颜色 || 余料板材材质->回车操作
    colorOrTypeSelectEnter(callback, type) {
      const selectRef = this.$refs[type]
      const inputEl = selectRef.$el.querySelector('input')
      if (callback) {
        inputEl.addEventListener('keyup', (e) => {
          if (e.code === 'Enter') {
            this.newSupplus[type] = inputEl.value
            selectRef.blur()
          }
        })
      }
    },
    handleClickSupplus(supplus) {
      this.currentClickSurplus = supplus
    },
    // 复制行
    async copyLine(supplus) {
      this.newSupplus = {
        ...supplus,
        id: '',
        branch_name: '',
        branch_no: '',
        lock_status: 0,
        lock_order: '',
        name: '',
        long: supplus.long,
        min_long: supplus.min_long,
        width: supplus.width,
        min_width: supplus.min_width,
        thick: supplus.thick,
        type: supplus.type,
        color: supplus.color,
        amount: '1',
        remark: supplus.remark,
        is_high_gloss_plank: supplus.is_high_gloss_plank,
        from_address: supplus.from_address,
        from_order_num: supplus.from_order_num,
        shape: supplus.shape,
        plankNum: uniquePlankNum.createUniquePlankNum(
          { ...this.newSupplus, plankNum: '' },
          true
        ),
      }
      await this.getSurplusClassify()
      this.saveNewSupplus(() => {
        this.$message.success(`复制[${this.currentClickSurplus.name}]数据成功`)
        this.selectedSurplusList = []
      }, true)
    },
    handlePlankMatCode(part, type) {
      let { type: matCode } = part
      // 确定新的材质
      if (matCode.startsWith('高光_') && !type) {
        matCode = matCode.replace('高光_', '')
      } else if (!matCode.startsWith('高光_') && type) {
        matCode = '高光_' + matCode
      }
      return matCode
    },
    onHighPlankChange(item) {
      this.newSupplus = {
        name: item.name ? item.name : '',
        long: item.long,
        min_long: item.min_long,
        width: item.width,
        min_width: item.min_width,
        thick: item.thick,
        type: item.type,
        color: item.color,
        amount: item.amount,
        remark: item.remark ? item.remark : '',
        fromGg: item.fromGg,
        is_high_gloss_plank: item.is_high_gloss_plank,
        highlight_surface: item.highlight_surface,
        texDir: item.texDir,
        branch_no: item.branch_no,
        from_address: item.from_address,
        from_order_num: item.from_order_num,
        lock_status: item.lock_status,
        lock_order: item.lock_order,
      }
      if (item.path && item.path.length) {
        this.newSupplus.path = item.path
      }
      this.selectedShape = 'rect'
      if (item.min_long != 0 && item.min_long != '') {
        this.selectedShape = 'L'
      }
      this.currentSurplus = item
      this.confirmEditSurplus()
    },
    //切换少翻版
    handleLessReserve({ target }) {
      updateLocalPreference({ surplus_no_roll: target.checked })
      if (this.isLessReserve) {
        buryPointFunc('余料管理-不翻版加工')
      }
      this.setSurplusNoRoll(target.checked)
      genFinalRecord(
        {
          key: '余料清单',
          operateArr: [
            {
              key: '更多',
              dataArr: [
                {
                  type: 'form',
                  current: {
                    surplusNoRoll: target.checked,
                  },
                  ori: {
                    surplusNoRoll: this.oriSurplusNoRoll,
                  },
                  compareMsg: surplusNoRollCompareMsg,
                  formTextObj: surplusNoRollCompareTextMap,
                  formValueObj: surplusNoRollCompareValueMap,
                },
              ],
            },
          ],
        },
        'surplus-management',
        -2
      )
    },
    handleSelectTexture(val) {
      this.newSlabColor = val[val.length - 1]
      this.colorSearchKey = ''
      this.inputCheck('color')
      this.setSupplusStorageColorList(val)
    },
    handleSelectMatCode(val) {
      this.inputCheck('type')
      if (val?.includes('@_@')) val = val.split('@_@')[0]
      this.newSupplus.type = val
      this.setSupplusStorageMatCode(val)
    },
    onBeforeFilter(val) {
      this.colorSearchKey = val
    },
    // 回车时对材质进行的操作
    handleEnterMatCode(e) {
      // 当为空或者全是空格时不进行操作
      const inputMatCode = e?.target?.value ?? this.newSupplus.type
      if (!inputMatCode) return
      // 将matcodeList数组变成label value的形式
      const checkMatCodeIsExistList = this.matcodeList.map((item) => {
        return {
          label: item,
          value: item,
        }
      })
      // 判断数组是否已经存在当前添加的数据
      const isExist = checkMatCodeIsExist(inputMatCode, checkMatCodeIsExistList)
      // 获取本地的材质数据
      let otherMatCodes = localStorage.getItem('matcodeList')
        ? JSON.parse(localStorage.getItem('matcodeList'))
        : []
      if (!isExist) {
        // 如果不存在
        otherMatCodes.push(inputMatCode)
        localStorage.setItem('matcodeList', JSON.stringify(otherMatCodes))
        this.matcodeList.push(inputMatCode)
      }
      this.newSupplus.type = inputMatCode
      this.setSupplusStorageMatCode(inputMatCode)
    },
    handleEnterColor(e) {
      if (!this.colorSearchKey) return
      const isExist = checkColorIsExist(
        this.colorSearchKey,
        this.materialColorOptions
      )
      let otherColors = localStorage.getItem('colorList')
        ? JSON.parse(localStorage.getItem('colorList'))
        : []
      if (isExist) {
        this.newPlankInfoTexture = isExist
      } else {
        otherColors.push(this.colorSearchKey)
        this.newPlankInfoTexture = ['other', this.colorSearchKey]
        localStorage.setItem('colorList', JSON.stringify(otherColors))
        const lastIndex = this.materialColorOptions.length - 1
        this.materialColorOptions[lastIndex].children.push({
          label: this.colorSearchKey,
          value: this.colorSearchKey,
        })
      }
      if (e?.target?.value) {
        this.setSupplusStorageColorList(this.newPlankInfoTexture)
      }
    },
    cacleColorItem(list) {
      let newList = []
      list.forEach((item) => {
        let currentItem = {
          children: [],
          value: item.name,
          label: item.name,
        }
        if (item.children.length) {
          currentItem.children = this.cacleColorItem(item.children)
        }
        if (item.color) {
          let itemColors = item.color.map((e) => {
            return {
              label: e.color_name,
              value: e.color_name,
            }
          })
          currentItem.children = currentItem.children.concat(itemColors)
        }
        newList.push(currentItem)
      })
      return newList
    },
    handleCloseDrawer() {
      this.newPlankInfoTexture = ''
      this.colorSearchKey = ''
    },

    handleDeleteColorSearch(type) {
      const ref =
        type == 'edit'
          ? this.$refs['editColorCascaderRef']
          : this.$refs['addColorCascaderRef']
      this.colorSearchKey = ref.$children[0].value
    },
    handleChangeTab(val) {
      if (val == '余料清单') {
        this.getSupplusList(this.page, true)
        this.updateTransEmpty()
      }
    },
    // 余料锁定开启/关闭
    handleChangeSurplusLock(e) {
      if (this.isSurplusLock) {
        this.supplusColumn.splice(
          15,
          0,
          {
            dataIndex: 'lock_status',
            key: 'lock_status',
            title: '锁定状态',
            width: 90,
            ellipsis: true,
            scopedSlots: { customRender: 'lock_status' },
            translateKey: 'surplusPage.lockStatus',
          },
          {
            dataIndex: 'lock_order',
            key: 'lock_order',
            title: '锁定订单',
            width: 170,
            ellipsis: true,
            scopedSlots: { customRender: 'lock_order' },
            translateKey: 'surplusPage.lockOrder',
          }
        )

        this.isShowSurLockNew = true
        updateLocalPreference({
          surplus_lock: this.isSurplusLock,
          isShowSurLockNew: true,
        })
        this.updateTransSurplusTable()
        buryPoint({
          function_module: 'supplus_storage',
          function_point: 'surplusLock',
        })
        genFinalRecord(
          {
            key: '余料清单',
            operateArr: [
              {
                key: '更多',
                dataArr: [
                  {
                    type: 'form',
                    current: {
                      surplusLock: this.isSurplusLock ? '开启' : '关闭',
                    },
                    ori: { surplusLock: '关闭' },
                    compareMsg: [
                      {
                        title: '',
                        keys: ['surplusLock'],
                      },
                    ], // 要比较的内容
                    formTextObj: {
                      surplusLock: '余料锁定功能',
                    }, // key对应的意思
                    formValueObj: {}, // value对应的意思
                  },
                ],
              },
            ],
          },
          'surplus-management',
          -2
        )
      } else {
        this.isShowCloseLock = true
        this.isSurplusLock = true
      }
    },
    // 确认关闭余料锁定
    async confirmCloseLock() {
      this.supplusColumn.splice(15, 2)
      this.isShowCloseLock = false
      this.isSurplusLock = false
      this.isShowSurLockNew = true
      updateLocalPreference({
        surplus_lock: this.isSurplusLock,
        isShowSurLockNew: true,
      })
      await surplusLock({ surplus: [], release_all: true })
      this.activeLockState = '全部'
      this.getSupplusList(this.page)
      genFinalRecord(
        {
          key: '余料清单',
          operateArr: [
            {
              key: '更多',
              dataArr: [
                {
                  type: 'form',
                  current: {
                    surplusLock: this.isSurplusLock ? '开启' : '关闭',
                  },
                  ori: { surplusLock: '开启' },
                  compareMsg: [
                    {
                      title: '',
                      keys: ['surplusLock'],
                    },
                  ], // 要比较的内容
                  formTextObj: {
                    surplusLock: '余料锁定功能',
                  }, // key对应的意思
                  formValueObj: {}, // value对应的意思
                },
              ],
            },
          ],
        },
        'surplus-management',
        -2
      )
    },
    // 单个锁定
    handleLock(row) {
      const params = {
        surplus: [
          {
            ...row,
            lock_num: row.amount,
            lock_status: row.lock_status ? 0 : 1,
          },
        ],
        release_all: false,
      }
      surplusLock(params).then((res) => {
        if (res.status == 1) {
          this.$message.success(row.lock_status ? '解锁成功' : '锁定成功')
          this.getSupplusList(this.page)
        } else {
          this.$message.error(row.lock_status ? '解锁失败' : '锁定失败')
        }
      })
    },
    // 批量解锁/锁定
    handleBatchLock(type) {
      this.showBatchLockPop = false
      // 如果已全选所有，使用所有选中的数据
      const listToProcess = this.isSelectAllSurplus
        ? this.allSelectedSurplusList
        : this.selectedSurplusList
      const params = {
        surplus: listToProcess.map((item) => ({
          ...item,
          lock_num: item.amount,
          lock_status: type,
        })),
        release_all: false,
      }
      surplusLock(params).then((res) => {
        if (res.status == 1) {
          this.$message.success(type ? '批量锁定成功' : '批量解锁成功')
          this.getSupplusList(this.page)
        } else {
          this.$message.error(type ? '批量锁定失败' : '批量解锁失败')
        }
      })
    },
    // 表格行点击事件
    handleClickTableRow(row, index) {
      return {
        on: {
          click: () => {
            this.currentClickSurplus = row
          },
        },
      }
    },
    // 翻译余料表格表头列
    updateTransSurplusTable() {
      this.supplusColumn = this.supplusColumn.map((item) => {
        if (
          !['select', 'branch_name', 'surplus_trim_edge'].includes(item.key)
        ) {
          return {
            ...item,
            title: translate(item.translateKey),
            // 自定义头部单元格
            customHeaderCell: () => ({
              attrs: {
                // 可以在这里添加额外的属性，比如 title
                title: translate(item.translateKey),
              },
            }),
          }
        } else {
          return item
        }
      })
    },
    updateTransEmpty() {
      if (this.totalSupplus == 0) {
        this.$nextTick(() => {
          const emptyDom = document.querySelector(
            '.surplus-table .ant-empty-description'
          )
          if (emptyDom) {
            if (!this.isFilterStatus) {
              emptyDom.innerHTML = `${this.$t('common.notDataTipByType', {})}
            <span
              id="supplus_store_table_add_btn"
              style="color: #18a8c7; cursor: pointer"
            >${this.$t('surplusPage.addSurplus')}</span>
          `
            } else {
              // 未查询到相关数据
              emptyDom.innerHTML = this.$t('surplusPage.noMatchSup')
            }
          }
          const addBtn = document.querySelector('#supplus_store_table_add_btn')
          if (addBtn) {
            addBtn.addEventListener('click', this.addNewSupplusSide)
          }
        })
      }
    },
    // 刷新
    handleRefresh() {
      this.showLoading = true
      this.getSupplusList()
    },
    // 余料详情popover方法-浮层渲染父节点，默认渲染到 body 上
    getPopupContainer() {
      return document.body
    },
    updatePreference({ data, isErr }) {
      if (isErr) return
      data = data || this.$store.state.preferencesSetting.setting
      this.isLessReserve = data.surplus_no_roll
      this.isSurplusLock = data.surplus_lock
      this.isShowSurLockNew = data.isShowSurLockNew
      this.isSecondConfirm = data.isSecondConfirm ?? true
      this.isSecondConfirmNew = data.isSecondConfirmNew
      // 余料默认修边值数据

      this.surplus_trim_data = data.surplus_trim_data || {
        trimmingMethod: 'follow',
        trimValue: '',
        isCustomTrim: false,
        topTrim: '',
        bottomTrim: '',
        leftTrim: '',
        rightTrim: '',
      }
      this.oriSurplusTrimData = window.$copy(this.surplus_trim_data)
      this.oriSurplusNoRoll = data.surplus_no_roll
      this.oriIsSecondConfirm = data.isSecondConfirm
      this.setSurplusNoRoll(data.surplus_no_roll)
      if (this.isSurplusLock) {
        this.supplusColumn.splice(
          15,
          0,
          {
            dataIndex: 'lock_status',
            key: 'lock_status',
            title: '锁定状态',
            width: 90,
            ellipsis: true,
            scopedSlots: { customRender: 'lock_status' },
            translateKey: 'surplusPage.lockStatus',
          },
          {
            dataIndex: 'lock_order',
            key: 'lock_order',
            title: '锁定订单',
            width: 170,
            ellipsis: true,
            scopedSlots: { customRender: 'lock_order' },
            translateKey: 'surplusPage.lockOrder',
          }
        )
      }
    },
    /**
     * @description 添加事件监听
     */
    addBusEvent() {
      EventBus.$on(EventBusKey.TRANSLATE, this.updateTransSurplusTable)
      EventBus.$on(EventBusKey.TRANSLATE, this.updateTransEmpty)
    },
    /**
     * @description 取消事件监听
     */
    removeBusEvent() {
      EventBus.$off(EventBusKey.TRANSLATE, this.updateTransSurplusTable)
      EventBus.$off(EventBusKey.TRANSLATE, this.updateTransEmpty)
    },
    handleChangeSecond() {
      updateLocalPreference({
        isSecondConfirm: this.isSecondConfirm,
      })
      buryPointApi(
        'supplus_storage',
        this.isSecondConfirm ? 'enable_second_confirm' : 'close_second_confirm'
      )
      genFinalRecord(
        {
          key: '余料清单',
          operateArr: [
            {
              key: '更多',
              dataArr: [
                {
                  type: 'form',
                  current: {
                    isSecondConfirm: this.isSecondConfirm,
                  },
                  ori: {
                    isSecondConfirm: this.oriIsSecondConfirm,
                  },
                  compareMsg: isSecondConfirmCompareMsg,
                  formTextObj: isSecondConfirmCompareTextMap,
                  formValueObj: isSecondConfirmCompareValueMap,
                },
              ],
            },
          ],
        },
        'surplus-management',
        -2
      )
    },
    matchHighlightBoardName(matcode, flag = true) {
      return matchHighlightBoardName(restoreOriginalMatcode(matcode, flag))
    },
    dealMatcodeName(name) {
      if (name.startsWith('高光_')) {
        return name.replace(
          '高光_',
          `${this.matchHighlightBoardName(name, false)}_`
        )
      }
      return name
    },
    // 余料导出模板（表头 + 样例数据见 surplusTemplate）
    handleDownloadSample() {
      downloadCsvFile(getSurplusImportTemplateData(), '余料导入模板')
      this.isShowPopover = false
    },
    /**
     * 导出/再导入用的修边单元格：上0-下5-左0-右5 或 /（空也写 /）
     */
    getExportSurplusTrimEdge(plank) {
      return formatSurplusTrimDisplay({
        surplusTrimEdge: plank.surplus_trim_edge,
        trimmingMethod: plank.trimmingMethod,
        isCustomTrim: plank.isCustomTrim,
        topTrim: plank.topTrim,
        bottomTrim: plank.bottomTrim,
        leftTrim: plank.leftTrim,
        rightTrim: plank.rightTrim,
        trimValue: plank.trimValue,
        shape: plank.shape,
      })
    },
    // 余料批量导出
    async batchExportSurplus() {
      const res = await this.dealSurplusData(this.selectedSurplusList)
      // 再次对表头字段进行检查
      downloadCsvFile(res, '余料导出')
      this.isShowPopover = false
    },
    // 余料数据处理成表格数据
    dealSurplusData(selectedSurplusList) {
      // 这部分的代码参考 开料清单 的下载样表，比较简单
      // surplusTableHeaderMappingList：翻译key => 表格字段
      return new Promise((resolve) => {
        const downloadData = []
        downloadData[0] = Object.keys(surplusTableHeaderMappingList).map(
          (item) => this.$translateLang(item)
        )
        const surplusList = selectedSurplusList.flatMap((surplus) =>
          new Array(+surplus.amount).fill(surplus)
        )
        surplusList.forEach((plank) => {
          const d = []
          Object.values(surplusTableHeaderMappingList).forEach((item) => {
            if (!item) return
            let headerValue = plank[item]

            // 收敛类型
            if (
              typeof headerValue === 'number' ||
              typeof headerValue === 'string'
            ) {
              headerValue = headerValue.toString().replaceAll('\n', '')
            }
            if (item === 'shape') {
              d.push(shapleMap[plank['shape']])
            } else if (item === 'is_high_gloss_plank') {
              const highGlossName = this.matchHighlightBoardName(plank['type'])
              d.push(
                plank['is_high_gloss_plank'] === 1
                  ? highGlossName
                  : `非${highGlossName}`
              )
            } else if (item === 'type') {
              d.push(plank['type'].replace('高光_', ''))
            } else if (item === 'surplus_trim_edge') {
              // formatSurplusItem 会删掉 surplus_trim_edge，改从 UI 字段还原
              d.push(this.getExportSurplusTrimEdge(plank))
            } else if (item === 'texDir') {
              let texDir = this.allTexDirList.find(
                (texDirItem) => texDirItem.value === plank.texDir
              )
              d.push(texDir?.label || '')
            } else {
              d.push(headerValue?.toString() || '')
            }
          })
          downloadData.push(d)
        })
        const result = downloadData.map((item) => {
          return item.map((itemData) => {
            if (typeof itemData === 'string') {
              itemData = itemData.replace('\n', '')
            }
            return itemData
          })
        })
        resolve(result)
      })
    },
    // 余料批量导入
    handleOpenFile() {
      this.$refs['inputFileRef'].dispatchEvent(new MouseEvent('click'))
      // 关闭 a-popover 的显示
      this.isShowPopover = false
    },
    getFileData(e) {
      try {
        const allFiles = e.target.files
        if (!allFiles || allFiles.length === 0)
          throw new Error('导入文件数量为空')
        let file = allFiles[0]
        let fileType = file.name.split('.').pop()
        let files = { 0: file }

        // 创建一个文件读取器， 用于读取文件内容
        let fileReader = new FileReader()
        if (fileType === 'csv') {
          // 导入csv文件
          fileReader.readAsText(files[0], 'GBK')
          fileReader.onload = (e) => {
            try {
              if (e.target?.result === '' || e.target?.result === '\r\n') {
                message.warning('没有查询到数据!')
                return
              }
              let temData = []
              if (e.target?.result && typeof e.target?.result === 'string') {
                if (e.target.result.includes('\r\n')) {
                  temData = e.target.result.split(/\r\n/)
                } else if (e.target.result.includes('\n')) {
                  temData = e.target.result.split(/\n/)
                }
              }
              // 将读取的数据处理成可以普通表格数据
              const { data } = dealCsvOrderInfo(temData, 'surplusStorage')
              checkSurplusCsvData(data)
                .then(async (res) => {
                  /**
                   * res:
                   * [
                   *  {
                   *    '余料名称': 'xxx'
                   *  }
                   * ]
                   */
                  // 构造一份余料数据
                  const surplusList = res.map((item) => {
                    return Object.fromEntries(
                      Object.entries(item).map(([oldKey, value]) => {
                        const newKey = surplusKeyMap.get(oldKey) || oldKey
                        return [newKey, value]
                      })
                    )
                  })
                  await this.addSurplus(surplusList)
                })
                .catch((error) => {
                  const {
                    showTableDialog: showTableDialogTemp,
                    lackTableString: lackTableStringTemp,
                  } = error
                  this.showTableDialog = showTableDialogTemp
                  this.lackTableString = lackTableStringTemp
                })
            } catch (error) {
              message.error('解析文件内容失败，请确认文件内容!')
              return false
            }
          }
        } else if (fileType === 'xls' || fileType === 'xlsx') {
          fileReader.readAsBinaryString(files[0])
          fileReader.onload = async (e) => {
            try {
              if (!e.target) return
              let data = e.target.result
              let workbook = XLSX.read(data, { type: 'binary' })
              let wsname = workbook.SheetNames[0]
              let ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
                defval: '',
              })
              ws = dealExcelManifest(ws, wsname, this)
              // 检查数据验证
              await checkSurplusCsvData(ws)
                .then(async (res) => {
                  const surplusList = res.map((item) => {
                    return Object.fromEntries(
                      Object.entries(item).map(([oldKey, value]) => {
                        const newKey = surplusKeyMap.get(oldKey) || oldKey
                        return [newKey, value]
                      })
                    )
                  })
                  await this.addSurplus(surplusList)
                })
                .catch((error) => {
                  const {
                    showTableDialog: showTableDialogTemp,
                    lackTableString: lackTableStringTemp,
                  } = error
                  this.showTableDialog = showTableDialogTemp
                  this.lackTableString = lackTableStringTemp
                  return
                })
            } catch (error) {
              console.error('File processing error:', error)
            }
          }
        } else {
          throw new Error('文件类型错误')
        }
      } catch (error) {
        this.$message({
          type: 'error',
          message: error.message,
        })
      } finally {
        e.target.value = ''
      }
    },
    // 清空导入余料清单确实的表头信息
    handleClearMissingData() {
      this.showTableDialog = this.false
    },
    // 创建余料的方法
    async addSurplus(surplusList) {
      // 这里还需要加上板件条码
      const updatedSurplusList = surplusList.map((plank) => {
        const { surplus_trim_edge, trimming_method } = parseSurplusTrimImport(
          plank.surplus_trim_edge,
          plank.shape
        )
        return {
          ...plank,
          plankNum: uniquePlankNum.createUniquePlankNum(plank, true),
          area: calculateSurplusArea(plank),
          shape: plank.shape === 'L形' ? 1 : 0,
          is_high_gloss_plank: plank.is_high_gloss_plank === '高光板' ? 1 : 0,
          type:
            plank.is_high_gloss_plank === '高光板'
              ? `高光_${plank.type}`
              : plank.type,
          surplus_trim_edge,
          trimming_method,
        }
      })

      // 调用创建余料接口进行上传
      const newRes = await createSurplus({
        surplus_data: updatedSurplusList,
        designated: true,
      })
      if (newRes) {
        if (newRes.status == 1) {
          this.saveSurplusRecord(
            'add',
            newRes.data.map((item, index) => ({
              ...item,
              surplus_trim_edge:
                updatedSurplusList[index]?.surplus_trim_edge ?? '',
            }))
          )
          this.showAddNewSupplus = false
          this.getSupplusList(1)

          this.$message.success(`添加余料成功`)
        }
        if (newRes.status == 0) {
          const errorMessages = [
            ...new Set(Object.values(newRes.data.err_surplus).flat()),
          ]
          if (errorMessages.includes('余料名称已重复')) {
            this.$message({
              type: 'error',
              message: '余料名称已重复',
            })
            return
          } else {
            this.$message({
              type: 'error',
              message: newRes.msg,
            })
          }
        }
        this.showLoading = false
      }
    },
    /**
     * @description 打开余料默认修边设置
     */
    handleOpenSurplusTrimSetting() {
      this.isVisible = true
      this.isPopoverVisible = false
    },
    // handleMoreVisibleChange() {},
    saveDefaultSurplusTrimData(formData) {
      updateLocalPreference({
        surplus_trim_data: formData,
      })
      const compareObj = {
        key: '余料默认修边设置',
        dataArr: [
          {
            type: 'form',
            current: formData,
            ori: this.oriSurplusTrimData,
            compareMsg: surplusTrimCompareMsg,
            formTextObj: surplusTrimCompareTextMap,
            formValueObj: surplusTrimCompareValueMap,
          },
        ],
      }
      genFinalRecord(
        { key: '余料清单', operateArr: [compareObj] },
        'surplus-management',
        -2
      )
      this.$message.success('保存成功')
      // 修改余料修边默认设置
      buryPointApi('supplus_storage', 'change_default_surplus_trim')
    },
    /**
     * @description 获取余料修边的表格或提示文本
     * @param record 余料数据
     * @param type 显示位置
     * */
    getTrimDisplay(record, type) {
      const followsOriginal =
        record.shape !== 0 || record.trimmingMethod === 'follow'
      const trimEdge = followsOriginal
        ? '/'
        : record.isCustomTrim
        ? `上${record.topTrim}-下${record.bottomTrim}-左${record.leftTrim}-右${record.rightTrim}`
        : record.trimValue || '/'

      if (type === 'text' && trimEdge === '/') {
        return '跟随原片中标准板材的修边值'
      }

      return trimEdge
    },
    handleToRecycleBin() {
      const hasPermission = checkUserPermissionWithToast(
        USER_PERMISSION_KEY.SURPLUS_RECYCLE_BIN,
        this.$translateLang('该功能为付费功能，请联系销售开通后使用~')
      )
      if (!hasPermission) {
        return
      }
      this.$router.push({ path: '/recycleBin' })
    },
  },

  mounted() {
    // 挂载偏好设置的更新
    this.oriSurplusTrimData = window.$copy(this.surplus_trim_data)
    this.$preference.init(this.updatePreference, this.$route.path)
    this.addBusEvent()
    this.showLoading = true
    this.getSurplusClassify()
    this.getSupplusList()
    if (!this.materialColorOptions.length) {
      this.materialColorOptions = this.materialColorList
    }
    this.updateTransSurplusTable()
  },
  beforeDestroy() {
    this.removeBusEvent()
  },
  created() {
    if (sessionStorage.getItem('thinkerx_material')) {
      this.isThinkerxMaterial = true
    }
  },
  watch: {
    materialColorList: {
      handler(val) {
        this.materialColorOptions = val
      },
    },
    totalSupplus: {
      handler() {
        this.updateTransEmpty()
      },
    },
  },
}
</script>

<style scoped lang="less">
/deep/.el-range-separator {
  padding: 0px;
}

/deep/ .el-range__icon,
.el-range-separator {
  display: flex;
  align-items: center;
}

/deep/.el-range-separator {
  display: flex;
  align-items: center;
}

.supplus-storage {
  min-width: 1440px;
  margin: 16px;
  margin-bottom: 0px;
  background: #eeeeee;

  .flag {
    line-height: normal;
    display: block;
    width: fit-content;
    color: #000;
    background-color: rgb(249, 224, 199);
    position: absolute;
    left: 185px;
    top: 12px;
    z-index: 1000;
    white-space: nowrap;
    padding: 2px 5px;
    font-size: 12px;
    border-radius: 3px;
  }

  .special-flag {
    color: #fff;
    background-color: #fcdb3f;
  }

  span {
    font-family: PingFangSC-Medium, PingFang SC;
  }

  .supplus-content {
    .top-operation {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #fff;
    }

    .filter {
      min-height: 160px;
      background: #f5f5f5;
      padding-left: 34px;

      .label {
        min-width: 70px;
        display: inline-block;
        font-size: 14px;
        text-align: right;
        color: rgba(0, 0, 0, 0.9);
      }

      &-item {
        margin-right: 70px;
        margin-bottom: 16px;

        /deep/.el-input__inner {
          height: 32px;
          padding-left: 10px;
        }

        /deep/.el-input__prefix {
          display: none;
        }

        /deep/.el-input__suffix {
          height: 32px;
          display: flex;
          align-items: center;
        }
      }

      &-btn {
        margin-left: 70px;
      }
    }

    .left-operation {
      display: flex;
      align-items: center;
      input[type='file'] {
        display: none;
      }
    }

    .supplus-btn {
      display: flex;
      align-items: center;
      width: 110px;
      height: 32px;

      .iconfont {
        margin-right: 3px;
      }
    }

    .new-supplus {
      margin-right: 8px;
      color: #fff;
      background: #18a8c7;
      border: none;
    }

    .delete-btn-hover {
      color: #333;

      &:hover {
        color: #18a8c7;
      }
    }

    .right-filter {
      display: flex;
      align-items: center;

      .ant-select {
        width: 160px;
        margin-right: 8px;
      }

      .ant-input-search {
        width: 330px;
        margin-right: 8px;

        /deep/ .ant-input-group-addon {
          box-sizing: border-box;
          padding: 0;

          .ant-select.ant-select-enabled {
            width: 98px !important;
            margin-right: 0;
            margin-left: 1px;
          }
        }
      }

      .search-btn {
        width: 84px;
        color: #fff;
        background: #18a8c7;
        border: none;
      }

      .reset-btn {
        width: 82px;
        color: #333;
        background: #fafafa;

        &:hover {
          color: #18a8c7;
        }
      }

      .delete-btn {
        color: #333;
        &:hover {
          color: #18a8c7;
        }
      }
    }

    .supplus-pagination {
      display: flex;
      justify-content: space-between;
      height: 64px;
      padding: 16px;
      background: #f3f3f3;
      margin-top: 30px;
      min-width: 1440px;
      width: 98.3%;

      & > div {
        display: flex;
        align-items: center;
      }

      .jump-to-page {
        display: flex;
        align-items: center;

        .ant-input {
          width: 48px;
        }

        span:first-child {
          margin-right: 8px;
        }

        span:last-child {
          margin-left: 8px;
        }
      }
    }
  }

  .new-supllus-dialog {
    .supplus-bread {
      width: 100%;
      height: 38px;
      padding: 0 16px;
      line-height: 38px;
      background: #fafafa;

      span {
        font-family: PingFangSC-Regular, PingFang SC;
      }

      .supplus-bread-home {
        color: #333;
        font-size: 14px;
        cursor: pointer;
      }

      .supplus-bread-final {
        color: #999999;
      }
    }

    .new-supplus-main {
      display: flex;
      justify-content: flex-start;
      height: 673px;
      margin: 24px;
      background: #fff;

      .left-supplus-type {
        flex-shrink: 0;
        width: 208px;
        height: 662px;
        padding: 24px;
        border-right: 2px solid #eee;
        box-shadow: -1px 0px 0px 0px rgba(229, 229, 229, 1);

        .select-shape {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 160px;
          height: 40px;
          margin-bottom: 16px;
          padding: 16px;
          color: #333;
          font-size: 14px;
          cursor: pointer;
        }

        .active-shape {
          color: #fff;
          background: #18a8c7;
        }

        .icon-right {
          color: #fff;
        }
      }

      .right-supplus-form {
        flex-grow: 1;
        flex-shrink: 0;
        min-width: 1184px;
        padding: 24px 24px 0 24px;

        .base-info {
          width: 100%;
          height: 40px;
          margin-bottom: 32px;
          padding-left: 16px;
          color: #333;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 40px;
          background: #fafafa;
          border-left: 4px solid #18a8c7;
        }

        .supplus-info-img {
          display: flex;
        }

        .plank-info {
          padding-left: 16px;

          .plank-info-item {
            position: relative;
            display: flex;
            align-items: center;
            margin: 0 24px;
            margin-bottom: 16px;

            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          .error-info {
            position: absolute;
            top: 32px;
            left: 105px;
            color: #fd3232;
            font-size: 12px;
          }

          .remark-info {
            top: 90px;
          }

          .plank-info-item.remark-form {
            align-items: flex-start;
          }

          .title-box {
            width: 85px;
            margin-right: 2px;
            text-align: right;
          }

          .import {
            flex-shrink: 0;
            color: #fd3232;
            font-size: 14px;
          }

          .title {
            flex-shrink: 0;
            color: #666666;
            font-size: 14px;
          }

          .plank-form-limit {
            color: #b0b0b0;
            font-size: 14px;
          }

          .plank-form-after {
            color: #999999;
            font-size: 14px;
          }

          .remark-input {
            position: relative;

            .remark-limit {
              position: absolute;
              right: 11px;
              bottom: 8px;
              color: #b0b0b0;
              font-size: 14px;
            }
          }

          .new-classify {
            margin-left: 16px;
            color: #18a8c7;
            font-size: 14px;
            cursor: pointer;
          }

          .drop-supplus-menu {
            position: absolute;
            top: 32px;
            left: 84px;
            z-index: 10;
            width: 432px;
            height: 100px;
            max-height: 100px;
            overflow: scroll;
            background: #fff;
            border-radius: 4px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

            &::-webkit-scrollbar {
              display: none;
            }
          }

          .selectMenu-enter-active,
          .selectMenu-leave-active {
            transition: all 0.3s ease;
          }

          .selectMenu-enter,
          .selectMenu-leave-to {
            height: 0;
            max-height: 0;
            opacity: 0;
          }

          .selectMenu-enter-to,
          .selectMenu-leave {
            height: 100px;
            max-height: 100px;
          }

          .errorInfo-enter-active,
          .errorInfo-leave-active {
            transition: all 0.3s ease;
          }

          .errorInfo-enter,
          .errorInfo-leave-to {
            transform: scaleY(0);
            transform-origin: top;
            opacity: 0;
          }

          .errorInfo-enter-to,
          .errorInfo-leave {
            transform: scaleY(1);
            transform-origin: top;
          }

          .drop-supplus-menu-item {
            display: block;
            width: 100%;
            height: 32px;
            padding: 0 16px;
            color: #333;
            font-size: 14px;
            line-height: 32px;
            cursor: pointer;

            &:hover {
              background: #e6f7ff;
            }
          }

          .active-supplus-menu-item {
            background: #e6f7ff;
          }

          .ant-input {
            width: 432px;
          }

          .ant-input-affix-wrapper {
            width: 432px;
          }

          .ant-input-group-wrapper {
            width: 432px;

            /deep/ .ant-input-group-addon {
              width: 76px;
            }
          }

          .alert-input {
            /deep/ .ant-select-selection {
              border-color: #fd3232;
            }

            /deep/ .ant-input {
              border-color: #fd3232;
            }

            &.ant-input {
              border-color: #fd3232;
            }
          }
        }

        .plank-img {
          margin-left: 200px;

          .plank-img-title {
            margin-left: 62px;
            color: #333;
            font-size: 16px;
          }

          .plank-canvas {
            margin-top: 22px;
          }
        }
      }
    }

    .save-supplus-btn {
      display: flex;
      justify-content: center;
      height: 68px;
      margin: 0 24px;
      background: #fff;

      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 248px;
      }

      .ant-btn {
        width: 120px;
        height: 32px;
        color: #333;
        font-size: 14px;

        &:last-child {
          color: #fff;
          background: #18a8c7;
        }
      }
    }
  }

  .delete-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);

    .delete-dialog-content {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 424px;
      height: 170px;
      margin: auto;
      padding: 32px 32px 24px 32px;
      background: #fff;
      border-radius: 2px;
      box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
        0px 9px 28px 0px rgba(0, 0, 0, 0.05),
        0px 6px 16px -8px rgba(0, 0, 0, 0.08);

      .delete-title {
        display: flex;
        align-items: center;
        height: 22px;
        margin-bottom: 13px;
      }

      .icon-warn {
        margin-right: 17px;
        color: #faad14;
        font-size: 22px;
      }

      .warm-notice {
        color: rgba(0, 0, 0, 0.85);
        font-size: 16px;
      }

      .confirm-notice {
        margin-bottom: 24px;
        padding-left: 40px;
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
      }

      .delete-btns {
        display: flex;
        justify-content: flex-end;

        > div {
          .ant-btn {
            width: 65px;
            height: 32px;
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
          }

          .confirm-btn {
            color: #fff;
            background: #18a8c7;
            border: none;
          }
        }
      }
    }
  }

  .new-classify-dialog {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);

    .new-classify-content {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 424px;
      height: 170px;
      margin: auto;
      padding: 32px 32px 24px 32px;
      background: #fff;
      border-radius: 2px;
      box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
        0px 9px 28px 0px rgba(0, 0, 0, 0.05),
        0px 6px 16px -8px rgba(0, 0, 0, 0.08);

      .new-classify-title {
        margin-bottom: 12px;
        color: #333;
        font-size: 16px;
      }

      .new-classify {
        margin-bottom: 16px;
      }

      .new-classify-btns {
        display: flex;
        justify-content: flex-end;

        > div {
          .ant-btn {
            width: 65px;
            height: 32px;
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
          }

          .confirm-btn {
            color: #fff;
            background: #18a8c7;
            border: none;
          }
        }
      }
    }
  }

  /deep/ .el-drawer__wrapper {
    z-index: 2004 !important;

    .el-drawer__header {
      margin: 0;
      padding: 0;
    }

    .drawer-title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 50px;
      padding: 0 24px;
      border-bottom: 1px solid #ddd;

      .icon-close {
        cursor: pointer;
      }
    }
  }

  /deep/ .v-modal {
    z-index: 2003 !important;
  }

  .surplus-new-plank {
    z-index: 2003;

    .edit-plank-info {
      position: relative;
      height: 100%;
      padding-top: 24px;

      .plank-info-item {
        position: relative;
        display: flex;
        align-items: center;
        margin: 0 15px 24px 20px;
      }

      .error-info {
        position: absolute;
        top: 32px;
        left: 84px;
        color: #fd3232;
        font-size: 12px;
      }

      .remark-info {
        top: 90px;
      }

      .plank-info-item.remark-form {
        align-items: flex-start;
      }

      .title-box {
        width: 85px;
        margin-right: 2px;
        text-align: right;
      }

      .import {
        flex-shrink: 0;
        color: #fd3232;
        font-size: 14px;
      }

      .title {
        flex-shrink: 0;
        color: #666666;
        font-size: 14px;
      }

      .plank-form-limit {
        color: #b0b0b0;
        font-size: 14px;
      }

      .plank-form-after {
        color: #999999;
        font-size: 14px;
      }

      .remark-input {
        position: relative;

        .remark-limit {
          position: absolute;
          right: 11px;
          bottom: 8px;
          color: #b0b0b0;
          font-size: 14px;
        }
      }

      .new-classify {
        margin-left: 16px;
        color: #18a8c7;
        font-size: 14px;
        cursor: pointer;
      }

      .errorInfo-enter-active,
      .errorInfo-leave-active {
        transition: all 0.3s ease;
      }

      .errorInfo-enter,
      .errorInfo-leave-to {
        transform: scaleY(0);
        transform-origin: top;
        opacity: 0;
      }

      .errorInfo-enter-to,
      .errorInfo-leave {
        transform: scaleY(1);
        transform-origin: top;
      }

      .active-supplus-menu-item {
        background: #e6f7ff;
      }

      .ant-input {
        width: 368px;
      }

      .ant-input-affix-wrapper {
        width: 368px;
      }

      .ant-input-group-wrapper {
        width: 368px;

        /deep/ .ant-input-group-addon {
          width: 76px;
        }
      }

      .alert-input {
        /deep/ .ant-select-selection {
          border-color: #fd3232;
        }

        /deep/ .ant-input {
          border-color: #fd3232;
        }

        &.ant-input {
          border-color: #fd3232;
        }
      }

      .edit-bottom-operation {
        // position: absolute;
        // bottom: 0;
        // left: 0;
        display: flex;
        justify-content: center;
        // width: 100%;
        height: 60px;
        // padding: 0 24px;
        border-top: 1px solid #ddd;
        margin-top: 70px;

        > div {
          display: flex;
          align-items: center;
        }

        .ant-btn {
          width: 120px;
          height: 32px;
          margin: 0 16px;

          &:last-child {
            color: #fff;
            background: #18a8c7;
            border: none;
          }
        }
      }
    }
  }

  .loading-box {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2005;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    text-align: center;
    background: #0008;
  }
}

.error-info {
  position: absolute;
  top: 30px;
  left: 105px;
  color: #fd3232;
  font-size: 12px;
}

.error-info.remark-info {
  top: 100px;
  left: 150px;
}

.trim-box {
  align-items: center;
}
/deep/ #supplus_storage_add_type_select {
  height: 32px;
}

/deep/ #supplus_storage_edit_type_select {
  height: 32px;
}

.error-border {
  /deep/ .el-input__inner {
    border-color: red;
  }
}

/deep/.surplus-table {
  .ant-table {
    border: 1px solid #dcdcdc;

    .ant-table-placeholder {
      border-bottom: none;
    }
  }

  .ant-table-thead > tr {
    height: 40px !important;

    > th {
      height: 40px;
      padding: 0;
      background: #f5f5f5;
    }

    > th[key='select'] {
      .ant-table-header-column {
        padding-left: 20px;
      }
    }

    > th[key='branch_name'] {
      .ant-table-column-title {
        overflow: unset;
      }

      .new-button_text {
        top: -13px;
        right: -15px;
      }
    }

    > th[key='operation'] {
      .ant-table-header-column {
        padding-left: 10px;
      }
    }
  }

  .ant-table-tbody > tr {
    height: 40px !important;
    position: relative;

    > td {
      height: 40px;
      padding: 0;

      .copy-line {
        position: absolute;
        top: -5px;
        left: 0;
        z-index: 10;
        width: 16px;
        height: 40px;
        padding: 0;
        border-bottom-color: #dcdcdc;
      }

      .ant-select-selection__rendered {
        font-size: 12px;
        color: #606266;
      }

      .table-operation-btn {
        color: #18a8c7;
        cursor: pointer;
      }
    }
  }
}

/deep/.branch-name-new {
  .new-button_text {
    top: 0;
    right: 100px;
  }
}
</style>

<style lang="less">
.ant-select-dropdown.supplus-storage-select {
  z-index: 2006;
}

.el-row {
  margin-top: 14px;
}

.el-drawer {
  overflow-y: auto;
}

.active-shape-side {
  color: #ffffff;
  background: #18a8c7;

  span {
    color: white;
  }
}

.select-shape-side {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 160px;
  height: 40px;
  margin-bottom: 16px;
  padding: 16px;
  color: #333;
  font-size: 14px;
  cursor: pointer;
}

.error-info {
  position: absolute;
  top: 60px;
  left: 105px;
  color: #fd3232;
  font-size: 12px;
}

.error-info.remark-info {
  top: 100px;
  left: 150px;
}

.newSideAdd {
  float: right;
  margin-left: 16px;
  color: #18a8c7;
  font-size: 14px;
  line-height: 30px;
  cursor: pointer;
}

.base-info {
  width: 100%;
  height: 40px;
  // margin-bottom: 32px;
  padding-left: 16px;
  color: #333;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 40px;
  background: #fafafa;
  border-left: 4px solid #18a8c7;
}

.alert-input {
  .ant-input {
    border-color: red;
  }

  .el-input__inner {
    border-color: red;
  }
}

.ant-input.alert-input {
  border-color: red;
}

.action-btn {
  box-sizing: border-box;
  border-color: #dcdcdc;
  padding-left: 11px;
  padding-right: 14px;

  &:hover {
    color: #18a8c7;
    border-color: #18a8c7;
  }

  /deep/ .ant-checkbox-wrapper {
    color: inherit;
  }

  .ant-checkbox + span {
    padding-right: 0 !important;
  }
}

.action-btn.surplus-lock-btn {
  padding-right: 28px;
}

#supplus_material_color_input {
  width: 318px;
  height: 36px;
}

#supplus_material_edit_color_input {
  width: 370px;
}

.more-operate-popover.ant-popover-placement-bottom {
  width: 79px;
  height: 80px;
  padding-top: 0px;
  margin-top: 5px;

  .ant-popover-arrow {
    display: none;
  }
}

.ant-popover.more-popover {
  width: 203px;
  height: 88px;
  padding-top: 0px;
  margin-top: 5px;

  .ant-popover-arrow {
    display: none;
  }

  .ant-popover-inner-content {
    padding: 8px;
  }
}

.batch-lock-popover.ant-popover {
  width: 121px;
  padding-top: 0px;
  margin-top: 10px;

  .ant-popover-arrow {
    display: none;
  }
}
.select-all-popover.ant-popover {
  .ant-popover-inner-content {
    padding: 8px 12px;
  }
  .select-all-checkbox-group {
    .select-all-checkbox-item {
      display: block;
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
